var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
"undefined" != typeof navigator && function (t, e) {
  exports = e();
}(exports, function () {
  "use strict";

  var t = "",
    e = !1,
    i = -999999,
    s = function () {
      return t;
    };
  function a(t) {
    return document.createElement(t);
  }
  function r(t, e) {
    var i,
      s,
      a = t.length;
    for (i = 0; i < a; i += 1) for (r in s = t[i].prototype) Object.prototype.hasOwnProperty.call(s, r) && (e.prototype[r] = s[r]);
  }
  function n(t) {
    function e() {}
    return e.prototype = t, e;
  }
  var o = function () {
      function t(t) {
        (this || _global).audios = [], (this || _global).audioFactory = t, (this || _global)._volume = 1, (this || _global)._isMuted = !1;
      }
      return t.prototype = {
        addAudio: function (t) {
          (this || _global).audios.push(t);
        },
        pause: function () {
          var t,
            e = (this || _global).audios.length;
          for (t = 0; t < e; t += 1) (this || _global).audios[t].pause();
        },
        resume: function () {
          var t,
            e = (this || _global).audios.length;
          for (t = 0; t < e; t += 1) (this || _global).audios[t].resume();
        },
        setRate: function (t) {
          var e,
            i = (this || _global).audios.length;
          for (e = 0; e < i; e += 1) (this || _global).audios[e].setRate(t);
        },
        createAudio: function (t) {
          return (this || _global).audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
            src: [t]
          }) : {
            isPlaying: !1,
            play: function () {
              (this || _global).isPlaying = !0;
            },
            seek: function () {
              (this || _global).isPlaying = !1;
            },
            playing: function () {},
            rate: function () {},
            setVolume: function () {}
          };
        },
        setAudioFactory: function (t) {
          (this || _global).audioFactory = t;
        },
        setVolume: function (t) {
          (this || _global)._volume = t, this._updateVolume();
        },
        mute: function () {
          (this || _global)._isMuted = !0, this._updateVolume();
        },
        unmute: function () {
          (this || _global)._isMuted = !1, this._updateVolume();
        },
        getVolume: function () {
          return (this || _global)._volume;
        },
        _updateVolume: function () {
          var t,
            e = (this || _global).audios.length;
          for (t = 0; t < e; t += 1) (this || _global).audios[t].volume((this || _global)._volume * ((this || _global)._isMuted ? 0 : 1));
        }
      }, function () {
        return new t();
      };
    }(),
    h = function () {
      function t(t, e) {
        var i,
          s = 0,
          a = [];
        switch (t) {
          case "int16":
          case "uint8c":
            i = 1;
            break;
          default:
            i = 1.1;
        }
        for (s = 0; s < e; s += 1) a.push(i);
        return a;
      }
      return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function (e, i) {
        return "float32" === e ? new Float32Array(i) : "int16" === e ? new Int16Array(i) : "uint8c" === e ? new Uint8ClampedArray(i) : t(e, i);
      } : t;
    }();
  function l(t) {
    return Array.apply(null, {
      length: t
    });
  }
  function p(t) {
    return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, p(t);
  }
  var f = !0,
    d = null,
    m = null,
    c = "",
    u = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    g = Math.pow,
    y = Math.sqrt,
    v = Math.floor,
    b = (Math.max, Math.min),
    _ = {};
  !function () {
    var t,
      e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"],
      i = e.length;
    for (t = 0; t < i; t += 1) _[e[t]] = Math[e[t]];
  }(), _.random = Math.random, _.abs = function (t) {
    if ("object" === p(t) && t.length) {
      var e,
        i = l(t.length),
        s = t.length;
      for (e = 0; e < s; e += 1) i[e] = Math.abs(t[e]);
      return i;
    }
    return Math.abs(t);
  };
  var k = 150,
    P = Math.PI / 180,
    A = 0.5519;
  function S(t) {
    !!t;
  }
  function x(t, e, i, s) {
    (this || _global).type = t, (this || _global).currentTime = e, (this || _global).totalTime = i, (this || _global).direction = s < 0 ? -1 : 1;
  }
  function w(t, e) {
    (this || _global).type = t, (this || _global).direction = e < 0 ? -1 : 1;
  }
  function D(t, e, i, s) {
    (this || _global).type = t, (this || _global).currentLoop = i, (this || _global).totalLoops = e, (this || _global).direction = s < 0 ? -1 : 1;
  }
  function C(t, e, i) {
    (this || _global).type = t, (this || _global).firstFrame = e, (this || _global).totalFrames = i;
  }
  function M(t, e) {
    (this || _global).type = t, (this || _global).target = e;
  }
  function T(t, e) {
    (this || _global).type = "renderFrameError", (this || _global).nativeError = t, (this || _global).currentTime = e;
  }
  function F(t) {
    (this || _global).type = "configError", (this || _global).nativeError = t;
  }
  var E,
    I = (E = 0, function () {
      return c + "__lottie_element_" + (E += 1);
    });
  function L(t, e, i) {
    var s, a, r, n, o, h, l, p;
    switch (h = i * (1 - e), l = i * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = i * (1 - (1 - o) * e), n % 6) {
      case 0:
        s = i, a = p, r = h;
        break;
      case 1:
        s = l, a = i, r = h;
        break;
      case 2:
        s = h, a = i, r = p;
        break;
      case 3:
        s = h, a = l, r = i;
        break;
      case 4:
        s = p, a = h, r = i;
        break;
      case 5:
        s = i, a = h, r = l;
    }
    return [s, a, r];
  }
  function V(t, e, i) {
    var s,
      a = Math.max(t, e, i),
      r = Math.min(t, e, i),
      n = a - r,
      o = 0 === a ? 0 : n / a,
      h = a / 255;
    switch (a) {
      case r:
        s = 0;
        break;
      case t:
        s = e - i + n * (e < i ? 6 : 0), s /= 6 * n;
        break;
      case e:
        s = i - t + 2 * n, s /= 6 * n;
        break;
      case i:
        s = t - e + 4 * n, s /= 6 * n;
    }
    return [s, o, h];
  }
  function R(t, e) {
    var i = V(255 * t[0], 255 * t[1], 255 * t[2]);
    return i[1] += e, i[1] > 1 ? i[1] = 1 : i[1] <= 0 && (i[1] = 0), L(i[0], i[1], i[2]);
  }
  function z(t, e) {
    var i = V(255 * t[0], 255 * t[1], 255 * t[2]);
    return i[2] += e, i[2] > 1 ? i[2] = 1 : i[2] < 0 && (i[2] = 0), L(i[0], i[1], i[2]);
  }
  function O(t, e) {
    var i = V(255 * t[0], 255 * t[1], 255 * t[2]);
    return i[0] += e / 360, i[0] > 1 ? i[0] -= 1 : i[0] < 0 && (i[0] += 1), L(i[0], i[1], i[2]);
  }
  !function () {
    var t,
      e,
      i = [];
    for (t = 0; t < 256; t += 1) e = t.toString(16), i[t] = 1 === e.length ? "0" + e : e;
  }();
  var N = function () {
      return d;
    },
    B = function () {
      return m;
    },
    q = function (t) {
      k = t;
    },
    j = function () {
      return k;
    };
  function W(t) {
    return document.createElementNS("http://www.w3.org/2000/svg", t);
  }
  function X(t) {
    return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, X(t);
  }
  var H = function () {
      var t,
        i,
        s = 1,
        a = [],
        r = {
          onmessage: function () {},
          postMessage: function (e) {
            t({
              data: e
            });
          }
        },
        n = {
          postMessage: function (t) {
            r.onmessage({
              data: t
            });
          }
        };
      function o(i) {
        if (window.Worker && window.Blob && e) {
          var s = new Blob(["var _workerSelf = self; self.onmessage = ", i.toString()], {
              type: "text/javascript"
            }),
            a = URL.createObjectURL(s);
          return new Worker(a);
        }
        return t = i, r;
      }
      function h() {
        i || (i = o(function (t) {
          if (n.dataManager || (n.dataManager = function () {
            function t(a, r) {
              var n,
                o,
                h,
                l,
                p,
                d,
                m = a.length;
              for (o = 0; o < m; o += 1) if ("ks" in (n = a[o]) && !n.completed) {
                if (n.completed = !0, n.hasMask) {
                  var c = n.masksProperties;
                  for (l = c.length, h = 0; h < l; h += 1) if (c[h].pt.k.i) s(c[h].pt.k);else for (d = c[h].pt.k.length, p = 0; p < d; p += 1) c[h].pt.k[p].s && s(c[h].pt.k[p].s[0]), c[h].pt.k[p].e && s(c[h].pt.k[p].e[0]);
                }
                0 === n.ty ? (n.layers = e(n.refId, r), t(n.layers, r)) : 4 === n.ty ? i(n.shapes) : 5 === n.ty && f(n);
              }
            }
            function e(t, e) {
              var i = function (t, e) {
                for (var i = 0, s = e.length; i < s;) {
                  if (e[i].id === t) return e[i];
                  i += 1;
                }
                return null;
              }(t, e);
              return i ? i.layers.__used ? JSON.parse(JSON.stringify(i.layers)) : (i.layers.__used = !0, i.layers) : null;
            }
            function i(t) {
              var e, a, r;
              for (e = t.length - 1; e >= 0; e -= 1) if ("sh" === t[e].ty) {
                if (t[e].ks.k.i) s(t[e].ks.k);else for (r = t[e].ks.k.length, a = 0; a < r; a += 1) t[e].ks.k[a].s && s(t[e].ks.k[a].s[0]), t[e].ks.k[a].e && s(t[e].ks.k[a].e[0]);
              } else "gr" === t[e].ty && i(t[e].it);
            }
            function s(t) {
              var e,
                i = t.i.length;
              for (e = 0; e < i; e += 1) t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
            }
            function a(t, e) {
              var i = e ? e.split(".") : [100, 100, 100];
              return t[0] > i[0] || !(i[0] > t[0]) && (t[1] > i[1] || !(i[1] > t[1]) && (t[2] > i[2] || !(i[2] > t[2]) && null));
            }
            var r,
              n = function () {
                var t = [4, 4, 14];
                function e(t) {
                  var e,
                    i,
                    s,
                    a = t.length;
                  for (e = 0; e < a; e += 1) 5 === t[e].ty && (s = void 0, s = (i = t[e]).t.d, i.t.d = {
                    k: [{
                      s: s,
                      t: 0
                    }]
                  });
                }
                return function (i) {
                  if (a(t, i.v) && (e(i.layers), i.assets)) {
                    var s,
                      r = i.assets.length;
                    for (s = 0; s < r; s += 1) i.assets[s].layers && e(i.assets[s].layers);
                  }
                };
              }(),
              o = (r = [4, 7, 99], function (t) {
                if (t.chars && !a(r, t.v)) {
                  var e,
                    s = t.chars.length;
                  for (e = 0; e < s; e += 1) {
                    var n = t.chars[e];
                    n.data && n.data.shapes && (i(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, t.chars[e].t || (n.data.shapes.push({
                      ty: "no"
                    }), n.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              }),
              h = function () {
                var t = [5, 7, 15];
                function e(t) {
                  var e,
                    i,
                    s = t.length;
                  for (e = 0; e < s; e += 1) 5 === t[e].ty && (i = void 0, "number" == typeof (i = t[e].t.p).a && (i.a = {
                    a: 0,
                    k: i.a
                  }), "number" == typeof i.p && (i.p = {
                    a: 0,
                    k: i.p
                  }), "number" == typeof i.r && (i.r = {
                    a: 0,
                    k: i.r
                  }));
                }
                return function (i) {
                  if (a(t, i.v) && (e(i.layers), i.assets)) {
                    var s,
                      r = i.assets.length;
                    for (s = 0; s < r; s += 1) i.assets[s].layers && e(i.assets[s].layers);
                  }
                };
              }(),
              l = function () {
                var t = [4, 1, 9];
                function e(t) {
                  var i,
                    s,
                    a,
                    r = t.length;
                  for (i = 0; i < r; i += 1) if ("gr" === t[i].ty) e(t[i].it);else if ("fl" === t[i].ty || "st" === t[i].ty) if (t[i].c.k && t[i].c.k[0].i) for (a = t[i].c.k.length, s = 0; s < a; s += 1) t[i].c.k[s].s && (t[i].c.k[s].s[0] /= 255, t[i].c.k[s].s[1] /= 255, t[i].c.k[s].s[2] /= 255, t[i].c.k[s].s[3] /= 255), t[i].c.k[s].e && (t[i].c.k[s].e[0] /= 255, t[i].c.k[s].e[1] /= 255, t[i].c.k[s].e[2] /= 255, t[i].c.k[s].e[3] /= 255);else t[i].c.k[0] /= 255, t[i].c.k[1] /= 255, t[i].c.k[2] /= 255, t[i].c.k[3] /= 255;
                }
                function i(t) {
                  var i,
                    s = t.length;
                  for (i = 0; i < s; i += 1) 4 === t[i].ty && e(t[i].shapes);
                }
                return function (e) {
                  if (a(t, e.v) && (i(e.layers), e.assets)) {
                    var s,
                      r = e.assets.length;
                    for (s = 0; s < r; s += 1) e.assets[s].layers && i(e.assets[s].layers);
                  }
                };
              }(),
              p = function () {
                var t = [4, 4, 18];
                function e(t) {
                  var i, s, a;
                  for (i = t.length - 1; i >= 0; i -= 1) if ("sh" === t[i].ty) {
                    if (t[i].ks.k.i) t[i].ks.k.c = t[i].closed;else for (a = t[i].ks.k.length, s = 0; s < a; s += 1) t[i].ks.k[s].s && (t[i].ks.k[s].s[0].c = t[i].closed), t[i].ks.k[s].e && (t[i].ks.k[s].e[0].c = t[i].closed);
                  } else "gr" === t[i].ty && e(t[i].it);
                }
                function i(t) {
                  var i,
                    s,
                    a,
                    r,
                    n,
                    o,
                    h = t.length;
                  for (s = 0; s < h; s += 1) {
                    if ((i = t[s]).hasMask) {
                      var l = i.masksProperties;
                      for (r = l.length, a = 0; a < r; a += 1) if (l[a].pt.k.i) l[a].pt.k.c = l[a].cl;else for (o = l[a].pt.k.length, n = 0; n < o; n += 1) l[a].pt.k[n].s && (l[a].pt.k[n].s[0].c = l[a].cl), l[a].pt.k[n].e && (l[a].pt.k[n].e[0].c = l[a].cl);
                    }
                    4 === i.ty && e(i.shapes);
                  }
                }
                return function (e) {
                  if (a(t, e.v) && (i(e.layers), e.assets)) {
                    var s,
                      r = e.assets.length;
                    for (s = 0; s < r; s += 1) e.assets[s].layers && i(e.assets[s].layers);
                  }
                };
              }();
            function f(t) {
              0 === t.t.a.length && t.t.p;
            }
            var d = {
              completeData: function (i) {
                i.__complete || (l(i), n(i), o(i), h(i), p(i), t(i.layers, i.assets), function (i, s) {
                  if (i) {
                    var a = 0,
                      r = i.length;
                    for (a = 0; a < r; a += 1) 1 === i[a].t && (i[a].data.layers = e(i[a].data.refId, s), t(i[a].data.layers, s));
                  }
                }(i.chars, i.assets), i.__complete = !0);
              }
            };
            return d.checkColors = l, d.checkChars = o, d.checkPathProperties = h, d.checkShapes = p, d.completeLayers = t, d;
          }()), n.assetLoader || (n.assetLoader = function () {
            function t(t) {
              var e = t.getResponseHeader("content-type");
              return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === X(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
            }
            return {
              load: function (e, i, s, a) {
                var r,
                  n = new XMLHttpRequest();
                try {
                  n.responseType = "json";
                } catch (t) {}
                n.onreadystatechange = function () {
                  if (4 === n.readyState) if (200 === n.status) r = t(n), s(r);else try {
                    r = t(n), s(r);
                  } catch (t) {
                    a && a(t);
                  }
                };
                try {
                  n.open(["G", "E", "T"].join(""), e, !0);
                } catch (t) {
                  n.open(["G", "E", "T"].join(""), i + "/" + e, !0);
                }
                n.send();
              }
            };
          }()), "loadAnimation" === t.data.type) n.assetLoader.load(t.data.path, t.data.fullPath, function (e) {
            n.dataManager.completeData(e), n.postMessage({
              id: t.data.id,
              payload: e,
              status: "success"
            });
          }, function () {
            n.postMessage({
              id: t.data.id,
              status: "error"
            });
          });else if ("complete" === t.data.type) {
            var e = t.data.animation;
            n.dataManager.completeData(e), n.postMessage({
              id: t.data.id,
              payload: e,
              status: "success"
            });
          } else "loadData" === t.data.type && n.assetLoader.load(t.data.path, t.data.fullPath, function (e) {
            n.postMessage({
              id: t.data.id,
              payload: e,
              status: "success"
            });
          }, function () {
            n.postMessage({
              id: t.data.id,
              status: "error"
            });
          });
        }), i.onmessage = function (t) {
          var e = t.data,
            i = e.id,
            s = a[i];
          a[i] = null, "success" === e.status ? s.onComplete(e.payload) : s.onError && s.onError();
        });
      }
      function l(t, e) {
        var i = "processId_" + (s += 1);
        return a[i] = {
          onComplete: t,
          onError: e
        }, i;
      }
      return {
        loadAnimation: function (t, e, s) {
          h();
          var a = l(e, s);
          i.postMessage({
            type: "loadAnimation",
            path: t,
            fullPath: window.location.origin + window.location.pathname,
            id: a
          });
        },
        loadData: function (t, e, s) {
          h();
          var a = l(e, s);
          i.postMessage({
            type: "loadData",
            path: t,
            fullPath: window.location.origin + window.location.pathname,
            id: a
          });
        },
        completeAnimation: function (t, e, s) {
          h();
          var a = l(e, s);
          i.postMessage({
            type: "complete",
            animation: t,
            id: a
          });
        }
      };
    }(),
    Y = function () {
      var t = function () {
        var t = a("canvas");
        t.width = 1, t.height = 1;
        var e = t.getContext("2d");
        return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
      }();
      function e() {
        (this || _global).loadedAssets += 1, (this || _global).loadedAssets === (this || _global).totalImages && (this || _global).loadedFootagesCount === (this || _global).totalFootages && (this || _global).imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function i() {
        (this || _global).loadedFootagesCount += 1, (this || _global).loadedAssets === (this || _global).totalImages && (this || _global).loadedFootagesCount === (this || _global).totalFootages && (this || _global).imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function s(t, e, i) {
        var s = "";
        if (t.e) s = t.p;else if (e) {
          var a = t.p;
          -1 !== a.indexOf("images/") && (a = a.split("/")[1]), s = e + a;
        } else s = i, s += t.u ? t.u : "", s += t.p;
        return s;
      }
      function r(t) {
        var e = 0,
          i = setInterval(function () {
            (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(i)), e += 1;
          }.bind(this || _global), 50);
      }
      function n(t) {
        var e = {
            assetData: t
          },
          i = s(t, (this || _global).assetsPath, (this || _global).path);
        return H.loadData(i, function (t) {
          e.img = t, this._footageLoaded();
        }.bind(this || _global), function () {
          e.img = {}, this._footageLoaded();
        }.bind(this || _global)), e;
      }
      function o() {
        (this || _global)._imageLoaded = e.bind(this || _global), (this || _global)._footageLoaded = i.bind(this || _global), (this || _global).testImageLoaded = r.bind(this || _global), (this || _global).createFootageData = n.bind(this || _global), (this || _global).assetsPath = "", (this || _global).path = "", (this || _global).totalImages = 0, (this || _global).totalFootages = 0, (this || _global).loadedAssets = 0, (this || _global).loadedFootagesCount = 0, (this || _global).imagesLoadedCb = null, (this || _global).images = [];
      }
      return o.prototype = {
        loadAssets: function (t, e) {
          var i;
          (this || _global).imagesLoadedCb = e;
          var s = t.length;
          for (i = 0; i < s; i += 1) t[i].layers || (t[i].t && "seq" !== t[i].t ? 3 === t[i].t && ((this || _global).totalFootages += 1, (this || _global).images.push(this.createFootageData(t[i]))) : ((this || _global).totalImages += 1, (this || _global).images.push(this._createImageData(t[i]))));
        },
        setAssetsPath: function (t) {
          (this || _global).assetsPath = t || "";
        },
        setPath: function (t) {
          (this || _global).path = t || "";
        },
        loadedImages: function () {
          return (this || _global).totalImages === (this || _global).loadedAssets;
        },
        loadedFootages: function () {
          return (this || _global).totalFootages === (this || _global).loadedFootagesCount;
        },
        destroy: function () {
          (this || _global).imagesLoadedCb = null, (this || _global).images.length = 0;
        },
        getAsset: function (t) {
          for (var e = 0, i = (this || _global).images.length; e < i;) {
            if ((this || _global).images[e].assetData === t) return (this || _global).images[e].img;
            e += 1;
          }
          return null;
        },
        createImgData: function (e) {
          var i = s(e, (this || _global).assetsPath, (this || _global).path),
            r = a("img");
          r.crossOrigin = "anonymous", r.addEventListener("load", (this || _global)._imageLoaded, !1), r.addEventListener("error", function () {
            n.img = t, this._imageLoaded();
          }.bind(this || _global), !1), r.src = i;
          var n = {
            img: r,
            assetData: e
          };
          return n;
        },
        createImageData: function (e) {
          var i = s(e, (this || _global).assetsPath, (this || _global).path),
            a = W("image");
          u ? this.testImageLoaded(a) : a.addEventListener("load", (this || _global)._imageLoaded, !1), a.addEventListener("error", function () {
            r.img = t, this._imageLoaded();
          }.bind(this || _global), !1), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", i), (this || _global)._elementHelper.append ? (this || _global)._elementHelper.append(a) : (this || _global)._elementHelper.appendChild(a);
          var r = {
            img: a,
            assetData: e
          };
          return r;
        },
        imageLoaded: e,
        footageLoaded: i,
        setCacheType: function (t, e) {
          "svg" === t ? ((this || _global)._elementHelper = e, (this || _global)._createImageData = (this || _global).createImageData.bind(this || _global)) : (this || _global)._createImageData = (this || _global).createImgData.bind(this || _global);
        }
      }, o;
    }();
  function G() {}
  G.prototype = {
    triggerEvent: function (t, e) {
      if ((this || _global)._cbs[t]) for (var i = (this || _global)._cbs[t], s = 0; s < i.length; s += 1) i[s](e);
    },
    addEventListener: function (t, e) {
      return (this || _global)._cbs[t] || ((this || _global)._cbs[t] = []), (this || _global)._cbs[t].push(e), function () {
        this.removeEventListener(t, e);
      }.bind(this || _global);
    },
    removeEventListener: function (t, e) {
      if (e) {
        if ((this || _global)._cbs[t]) {
          for (var i = 0, s = (this || _global)._cbs[t].length; i < s;) (this || _global)._cbs[t][i] === e && ((this || _global)._cbs[t].splice(i, 1), i -= 1, s -= 1), i += 1;
          (this || _global)._cbs[t].length || ((this || _global)._cbs[t] = null);
        }
      } else (this || _global)._cbs[t] = null;
    }
  };
  var K = function () {
      function t(t) {
        for (var e, i = t.split("\r\n"), s = {}, a = 0, r = 0; r < i.length; r += 1) 2 === (e = i[r].split(":")).length && (s[e[0]] = e[1].trim(), a += 1);
        if (0 === a) throw new Error();
        return s;
      }
      return function (e) {
        for (var i = [], s = 0; s < e.length; s += 1) {
          var a = e[s],
            r = {
              time: a.tm,
              duration: a.dr
            };
          try {
            r.payload = JSON.parse(e[s].cm);
          } catch (i) {
            try {
              r.payload = t(e[s].cm);
            } catch (t) {
              r.payload = {
                name: e[s].cm
              };
            }
          }
          i.push(r);
        }
        return i;
      };
    }(),
    J = function () {
      function t(t) {
        (this || _global).compositions.push(t);
      }
      return function () {
        function e(t) {
          for (var e = 0, i = (this || _global).compositions.length; e < i;) {
            if ((this || _global).compositions[e].data && (this || _global).compositions[e].data.nm === t) return (this || _global).compositions[e].prepareFrame && (this || _global).compositions[e].data.xt && (this || _global).compositions[e].prepareFrame((this || _global).currentFrame), (this || _global).compositions[e].compInterface;
            e += 1;
          }
          return null;
        }
        return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
      };
    }(),
    U = {};
  function Z(t) {
    return Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Z(t);
  }
  var Q = function () {
    (this || _global)._cbs = [], (this || _global).name = "", (this || _global).path = "", (this || _global).isLoaded = !1, (this || _global).currentFrame = 0, (this || _global).currentRawFrame = 0, (this || _global).firstFrame = 0, (this || _global).totalFrames = 0, (this || _global).frameRate = 0, (this || _global).frameMult = 0, (this || _global).playSpeed = 1, (this || _global).playDirection = 1, (this || _global).playCount = 0, (this || _global).animationData = {}, (this || _global).assets = [], (this || _global).isPaused = !0, (this || _global).autoplay = !1, (this || _global).loop = !0, (this || _global).renderer = null, (this || _global).animationID = I(), (this || _global).assetsPath = "", (this || _global).timeCompleted = 0, (this || _global).segmentPos = 0, (this || _global).isSubframeEnabled = f, (this || _global).segments = [], (this || _global)._idle = !0, (this || _global)._completedLoop = !1, (this || _global).projectInterface = J(), (this || _global).imagePreloader = new Y(), (this || _global).audioController = o(), (this || _global).markers = [], (this || _global).configAnimation = (this || _global).configAnimation.bind(this || _global), (this || _global).onSetupError = (this || _global).onSetupError.bind(this || _global), (this || _global).onSegmentComplete = (this || _global).onSegmentComplete.bind(this || _global), (this || _global).drawnFrameEvent = new x("drawnFrame", 0, 0, 0), (this || _global).expressionsPlugin = N();
  };
  r([G], Q), Q.prototype.setParams = function (t) {
    (t.wrapper || t.container) && ((this || _global).wrapper = t.wrapper || t.container);
    var e = "svg";
    t.animType ? e = t.animType : t.renderer && (e = t.renderer);
    var i = U[e];
    (this || _global).renderer = new i(this || _global, t.rendererSettings), (this || _global).imagePreloader.setCacheType(e, (this || _global).renderer.globalData.defs), (this || _global).renderer.setProjectInterface((this || _global).projectInterface), (this || _global).animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? (this || _global).loop = !0 : !1 === t.loop ? (this || _global).loop = !1 : (this || _global).loop = parseInt(t.loop, 10), (this || _global).autoplay = !("autoplay" in t) || t.autoplay, (this || _global).name = t.name ? t.name : "", (this || _global).autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, (this || _global).assetsPath = t.assetsPath, (this || _global).initialSegment = t.initialSegment, t.audioFactory && (this || _global).audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? (this || _global).path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : (this || _global).path = t.path.substr(0, t.path.lastIndexOf("/") + 1), (this || _global).fileName = t.path.substr(t.path.lastIndexOf("/") + 1), (this || _global).fileName = (this || _global).fileName.substr(0, (this || _global).fileName.lastIndexOf(".json")), H.loadAnimation(t.path, (this || _global).configAnimation, (this || _global).onSetupError));
  }, Q.prototype.onSetupError = function () {
    this.trigger("data_failed");
  }, Q.prototype.setupAnimation = function (t) {
    H.completeAnimation(t, (this || _global).configAnimation);
  }, Q.prototype.setData = function (t, e) {
    e && "object" !== Z(e) && (e = JSON.parse(e));
    var i = {
        wrapper: t,
        animationData: e
      },
      s = t.attributes;
    i.path = s.getNamedItem("data-animation-path") ? s.getNamedItem("data-animation-path").value : s.getNamedItem("data-bm-path") ? s.getNamedItem("data-bm-path").value : s.getNamedItem("bm-path") ? s.getNamedItem("bm-path").value : "", i.animType = s.getNamedItem("data-anim-type") ? s.getNamedItem("data-anim-type").value : s.getNamedItem("data-bm-type") ? s.getNamedItem("data-bm-type").value : s.getNamedItem("bm-type") ? s.getNamedItem("bm-type").value : s.getNamedItem("data-bm-renderer") ? s.getNamedItem("data-bm-renderer").value : s.getNamedItem("bm-renderer") ? s.getNamedItem("bm-renderer").value : function () {
      if (U.canvas) return "canvas";
      for (var t in U) if (U[t]) return t;
      return "";
    }() || "canvas";
    var a = s.getNamedItem("data-anim-loop") ? s.getNamedItem("data-anim-loop").value : s.getNamedItem("data-bm-loop") ? s.getNamedItem("data-bm-loop").value : s.getNamedItem("bm-loop") ? s.getNamedItem("bm-loop").value : "";
    "false" === a ? i.loop = !1 : "true" === a ? i.loop = !0 : "" !== a && (i.loop = parseInt(a, 10));
    var r = s.getNamedItem("data-anim-autoplay") ? s.getNamedItem("data-anim-autoplay").value : s.getNamedItem("data-bm-autoplay") ? s.getNamedItem("data-bm-autoplay").value : !s.getNamedItem("bm-autoplay") || s.getNamedItem("bm-autoplay").value;
    i.autoplay = "false" !== r, i.name = s.getNamedItem("data-name") ? s.getNamedItem("data-name").value : s.getNamedItem("data-bm-name") ? s.getNamedItem("data-bm-name").value : s.getNamedItem("bm-name") ? s.getNamedItem("bm-name").value : "", "false" === (s.getNamedItem("data-anim-prerender") ? s.getNamedItem("data-anim-prerender").value : s.getNamedItem("data-bm-prerender") ? s.getNamedItem("data-bm-prerender").value : s.getNamedItem("bm-prerender") ? s.getNamedItem("bm-prerender").value : "") && (i.prerender = !1), i.path ? this.setParams(i) : this.trigger("destroy");
  }, Q.prototype.includeLayers = function (t) {
    t.op > (this || _global).animationData.op && ((this || _global).animationData.op = t.op, (this || _global).totalFrames = Math.floor(t.op - (this || _global).animationData.ip));
    var e,
      i,
      s = (this || _global).animationData.layers,
      a = s.length,
      r = t.layers,
      n = r.length;
    for (i = 0; i < n; i += 1) for (e = 0; e < a;) {
      if (s[e].id === r[i].id) {
        s[e] = r[i];
        break;
      }
      e += 1;
    }
    if ((t.chars || t.fonts) && ((this || _global).renderer.globalData.fontManager.addChars(t.chars), (this || _global).renderer.globalData.fontManager.addFonts(t.fonts, (this || _global).renderer.globalData.defs)), t.assets) for (a = t.assets.length, e = 0; e < a; e += 1) (this || _global).animationData.assets.push(t.assets[e]);
    (this || _global).animationData.__complete = !1, H.completeAnimation((this || _global).animationData, (this || _global).onSegmentComplete);
  }, Q.prototype.onSegmentComplete = function (t) {
    (this || _global).animationData = t;
    var e = N();
    e && e.initExpressions(this || _global), this.loadNextSegment();
  }, Q.prototype.loadNextSegment = function () {
    var t = (this || _global).animationData.segments;
    if (!t || 0 === t.length || !(this || _global).autoloadSegments) return this.trigger("data_ready"), void ((this || _global).timeCompleted = (this || _global).totalFrames);
    var e = t.shift();
    (this || _global).timeCompleted = e.time * (this || _global).frameRate;
    var i = (this || _global).path + (this || _global).fileName + "_" + (this || _global).segmentPos + ".json";
    (this || _global).segmentPos += 1, H.loadData(i, (this || _global).includeLayers.bind(this || _global), function () {
      this.trigger("data_failed");
    }.bind(this || _global));
  }, Q.prototype.loadSegments = function () {
    (this || _global).animationData.segments || ((this || _global).timeCompleted = (this || _global).totalFrames), this.loadNextSegment();
  }, Q.prototype.imagesLoaded = function () {
    this.trigger("loaded_images"), this.checkLoaded();
  }, Q.prototype.preloadImages = function () {
    (this || _global).imagePreloader.setAssetsPath((this || _global).assetsPath), (this || _global).imagePreloader.setPath((this || _global).path), (this || _global).imagePreloader.loadAssets((this || _global).animationData.assets, (this || _global).imagesLoaded.bind(this || _global));
  }, Q.prototype.configAnimation = function (t) {
    if ((this || _global).renderer) try {
      (this || _global).animationData = t, (this || _global).initialSegment ? ((this || _global).totalFrames = Math.floor((this || _global).initialSegment[1] - (this || _global).initialSegment[0]), (this || _global).firstFrame = Math.round((this || _global).initialSegment[0])) : ((this || _global).totalFrames = Math.floor((this || _global).animationData.op - (this || _global).animationData.ip), (this || _global).firstFrame = Math.round((this || _global).animationData.ip)), (this || _global).renderer.configAnimation(t), t.assets || (t.assets = []), (this || _global).assets = (this || _global).animationData.assets, (this || _global).frameRate = (this || _global).animationData.fr, (this || _global).frameMult = (this || _global).animationData.fr / 1000, (this || _global).renderer.searchExtraCompositions(t.assets), (this || _global).markers = K(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), (this || _global).isPaused && (this || _global).audioController.pause();
    } catch (t) {
      this.triggerConfigError(t);
    }
  }, Q.prototype.waitForFontsLoaded = function () {
    (this || _global).renderer && ((this || _global).renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout((this || _global).waitForFontsLoaded.bind(this || _global), 20));
  }, Q.prototype.checkLoaded = function () {
    if (!(this || _global).isLoaded && (this || _global).renderer.globalData.fontManager.isLoaded && ((this || _global).imagePreloader.loadedImages() || "canvas" !== (this || _global).renderer.rendererType) && (this || _global).imagePreloader.loadedFootages()) {
      (this || _global).isLoaded = !0;
      var t = N();
      t && t.initExpressions(this || _global), (this || _global).renderer.initItems(), setTimeout(function () {
        this.trigger("DOMLoaded");
      }.bind(this || _global), 0), this.gotoFrame(), (this || _global).autoplay && this.play();
    }
  }, Q.prototype.resize = function (t, e) {
    var i = "number" == typeof t ? t : void 0,
      s = "number" == typeof e ? e : void 0;
    (this || _global).renderer.updateContainerSize(i, s);
  }, Q.prototype.setSubframe = function (t) {
    (this || _global).isSubframeEnabled = !!t;
  }, Q.prototype.gotoFrame = function () {
    (this || _global).currentFrame = (this || _global).isSubframeEnabled ? (this || _global).currentRawFrame : ~~(this || _global).currentRawFrame, (this || _global).timeCompleted !== (this || _global).totalFrames && (this || _global).currentFrame > (this || _global).timeCompleted && ((this || _global).currentFrame = (this || _global).timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
  }, Q.prototype.renderFrame = function () {
    if (!1 !== (this || _global).isLoaded && (this || _global).renderer) try {
      (this || _global).expressionsPlugin && (this || _global).expressionsPlugin.resetFrame(), (this || _global).renderer.renderFrame((this || _global).currentFrame + (this || _global).firstFrame);
    } catch (t) {
      this.triggerRenderFrameError(t);
    }
  }, Q.prototype.play = function (t) {
    t && (this || _global).name !== t || !0 === (this || _global).isPaused && ((this || _global).isPaused = !1, this.trigger("_play"), (this || _global).audioController.resume(), (this || _global)._idle && ((this || _global)._idle = !1, this.trigger("_active")));
  }, Q.prototype.pause = function (t) {
    t && (this || _global).name !== t || !1 === (this || _global).isPaused && ((this || _global).isPaused = !0, this.trigger("_pause"), (this || _global)._idle = !0, this.trigger("_idle"), (this || _global).audioController.pause());
  }, Q.prototype.togglePause = function (t) {
    t && (this || _global).name !== t || (!0 === (this || _global).isPaused ? this.play() : this.pause());
  }, Q.prototype.stop = function (t) {
    t && (this || _global).name !== t || (this.pause(), (this || _global).playCount = 0, (this || _global)._completedLoop = !1, this.setCurrentRawFrameValue(0));
  }, Q.prototype.getMarkerData = function (t) {
    for (var e, i = 0; i < (this || _global).markers.length; i += 1) if ((e = (this || _global).markers[i]).payload && e.payload.name === t) return e;
    return null;
  }, Q.prototype.goToAndStop = function (t, e, i) {
    if (!i || (this || _global).name === i) {
      var s = Number(t);
      if (isNaN(s)) {
        var a = this.getMarkerData(t);
        a && this.goToAndStop(a.time, !0);
      } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * (this || _global).frameModifier);
      this.pause();
    }
  }, Q.prototype.goToAndPlay = function (t, e, i) {
    if (!i || (this || _global).name === i) {
      var s = Number(t);
      if (isNaN(s)) {
        var a = this.getMarkerData(t);
        a && (a.duration ? this.playSegments([a.time, a.time + a.duration], !0) : this.goToAndStop(a.time, !0));
      } else this.goToAndStop(s, e, i);
      this.play();
    }
  }, Q.prototype.advanceTime = function (t) {
    if (!0 !== (this || _global).isPaused && !1 !== (this || _global).isLoaded) {
      var e = (this || _global).currentRawFrame + t * (this || _global).frameModifier,
        i = !1;
      e >= (this || _global).totalFrames - 1 && (this || _global).frameModifier > 0 ? (this || _global).loop && (this || _global).playCount !== (this || _global).loop ? e >= (this || _global).totalFrames ? ((this || _global).playCount += 1, this.checkSegments(e % (this || _global).totalFrames) || (this.setCurrentRawFrameValue(e % (this || _global).totalFrames), (this || _global)._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > (this || _global).totalFrames ? e % (this || _global).totalFrames : 0) || (i = !0, e = (this || _global).totalFrames - 1) : e < 0 ? this.checkSegments(e % (this || _global).totalFrames) || (!(this || _global).loop || (this || _global).playCount-- <= 0 && !0 !== (this || _global).loop ? (i = !0, e = 0) : (this.setCurrentRawFrameValue((this || _global).totalFrames + e % (this || _global).totalFrames), (this || _global)._completedLoop ? this.trigger("loopComplete") : (this || _global)._completedLoop = !0)) : this.setCurrentRawFrameValue(e), i && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
    }
  }, Q.prototype.adjustSegment = function (t, e) {
    (this || _global).playCount = 0, t[1] < t[0] ? ((this || _global).frameModifier > 0 && ((this || _global).playSpeed < 0 ? this.setSpeed(-(this || _global).playSpeed) : this.setDirection(-1)), (this || _global).totalFrames = t[0] - t[1], (this || _global).timeCompleted = (this || _global).totalFrames, (this || _global).firstFrame = t[1], this.setCurrentRawFrameValue((this || _global).totalFrames - 0.001 - e)) : t[1] > t[0] && ((this || _global).frameModifier < 0 && ((this || _global).playSpeed < 0 ? this.setSpeed(-(this || _global).playSpeed) : this.setDirection(1)), (this || _global).totalFrames = t[1] - t[0], (this || _global).timeCompleted = (this || _global).totalFrames, (this || _global).firstFrame = t[0], this.setCurrentRawFrameValue(0.001 + e)), this.trigger("segmentStart");
  }, Q.prototype.setSegment = function (t, e) {
    var i = -1;
    (this || _global).isPaused && ((this || _global).currentRawFrame + (this || _global).firstFrame < t ? i = t : (this || _global).currentRawFrame + (this || _global).firstFrame > e && (i = e - t)), (this || _global).firstFrame = t, (this || _global).totalFrames = e - t, (this || _global).timeCompleted = (this || _global).totalFrames, -1 !== i && this.goToAndStop(i, !0);
  }, Q.prototype.playSegments = function (t, e) {
    if (e && ((this || _global).segments.length = 0), "object" === Z(t[0])) {
      var i,
        s = t.length;
      for (i = 0; i < s; i += 1) (this || _global).segments.push(t[i]);
    } else (this || _global).segments.push(t);
    (this || _global).segments.length && e && this.adjustSegment((this || _global).segments.shift(), 0), (this || _global).isPaused && this.play();
  }, Q.prototype.resetSegments = function (t) {
    (this || _global).segments.length = 0, (this || _global).segments.push([(this || _global).animationData.ip, (this || _global).animationData.op]), t && this.checkSegments(0);
  }, Q.prototype.checkSegments = function (t) {
    return !!(this || _global).segments.length && (this.adjustSegment((this || _global).segments.shift(), t), !0);
  }, Q.prototype.destroy = function (t) {
    t && (this || _global).name !== t || !(this || _global).renderer || ((this || _global).renderer.destroy(), (this || _global).imagePreloader.destroy(), this.trigger("destroy"), (this || _global)._cbs = null, (this || _global).onEnterFrame = null, (this || _global).onLoopComplete = null, (this || _global).onComplete = null, (this || _global).onSegmentStart = null, (this || _global).onDestroy = null, (this || _global).renderer = null, (this || _global).expressionsPlugin = null, (this || _global).imagePreloader = null, (this || _global).projectInterface = null);
  }, Q.prototype.setCurrentRawFrameValue = function (t) {
    (this || _global).currentRawFrame = t, this.gotoFrame();
  }, Q.prototype.setSpeed = function (t) {
    (this || _global).playSpeed = t, this.updaFrameModifier();
  }, Q.prototype.setDirection = function (t) {
    (this || _global).playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
  }, Q.prototype.setLoop = function (t) {
    (this || _global).loop = t;
  }, Q.prototype.setVolume = function (t, e) {
    e && (this || _global).name !== e || (this || _global).audioController.setVolume(t);
  }, Q.prototype.getVolume = function () {
    return (this || _global).audioController.getVolume();
  }, Q.prototype.mute = function (t) {
    t && (this || _global).name !== t || (this || _global).audioController.mute();
  }, Q.prototype.unmute = function (t) {
    t && (this || _global).name !== t || (this || _global).audioController.unmute();
  }, Q.prototype.updaFrameModifier = function () {
    (this || _global).frameModifier = (this || _global).frameMult * (this || _global).playSpeed * (this || _global).playDirection, (this || _global).audioController.setRate((this || _global).playSpeed * (this || _global).playDirection);
  }, Q.prototype.getPath = function () {
    return (this || _global).path;
  }, Q.prototype.getAssetsPath = function (t) {
    var e = "";
    if (t.e) e = t.p;else if ((this || _global).assetsPath) {
      var i = t.p;
      -1 !== i.indexOf("images/") && (i = i.split("/")[1]), e = (this || _global).assetsPath + i;
    } else e = (this || _global).path, e += t.u ? t.u : "", e += t.p;
    return e;
  }, Q.prototype.getAssetData = function (t) {
    for (var e = 0, i = (this || _global).assets.length; e < i;) {
      if (t === (this || _global).assets[e].id) return (this || _global).assets[e];
      e += 1;
    }
    return null;
  }, Q.prototype.hide = function () {
    (this || _global).renderer.hide();
  }, Q.prototype.show = function () {
    (this || _global).renderer.show();
  }, Q.prototype.getDuration = function (t) {
    return t ? (this || _global).totalFrames : (this || _global).totalFrames / (this || _global).frameRate;
  }, Q.prototype.updateDocumentData = function (t, e, i) {
    try {
      (this || _global).renderer.getElementByPath(t).updateDocumentData(e, i);
    } catch (t) {}
  }, Q.prototype.trigger = function (t) {
    if ((this || _global)._cbs && (this || _global)._cbs[t]) switch (t) {
      case "enterFrame":
        this.triggerEvent(t, new x(t, (this || _global).currentFrame, (this || _global).totalFrames, (this || _global).frameModifier));
        break;
      case "drawnFrame":
        (this || _global).drawnFrameEvent.currentTime = (this || _global).currentFrame, (this || _global).drawnFrameEvent.totalTime = (this || _global).totalFrames, (this || _global).drawnFrameEvent.direction = (this || _global).frameModifier, this.triggerEvent(t, (this || _global).drawnFrameEvent);
        break;
      case "loopComplete":
        this.triggerEvent(t, new D(t, (this || _global).loop, (this || _global).playCount, (this || _global).frameMult));
        break;
      case "complete":
        this.triggerEvent(t, new w(t, (this || _global).frameMult));
        break;
      case "segmentStart":
        this.triggerEvent(t, new C(t, (this || _global).firstFrame, (this || _global).totalFrames));
        break;
      case "destroy":
        this.triggerEvent(t, new M(t, this || _global));
        break;
      default:
        this.triggerEvent(t);
    }
    "enterFrame" === t && (this || _global).onEnterFrame && (this || _global).onEnterFrame.call(this || _global, new x(t, (this || _global).currentFrame, (this || _global).totalFrames, (this || _global).frameMult)), "loopComplete" === t && (this || _global).onLoopComplete && (this || _global).onLoopComplete.call(this || _global, new D(t, (this || _global).loop, (this || _global).playCount, (this || _global).frameMult)), "complete" === t && (this || _global).onComplete && (this || _global).onComplete.call(this || _global, new w(t, (this || _global).frameMult)), "segmentStart" === t && (this || _global).onSegmentStart && (this || _global).onSegmentStart.call(this || _global, new C(t, (this || _global).firstFrame, (this || _global).totalFrames)), "destroy" === t && (this || _global).onDestroy && (this || _global).onDestroy.call(this || _global, new M(t, this || _global));
  }, Q.prototype.triggerRenderFrameError = function (t) {
    var e = new T(t, (this || _global).currentFrame);
    this.triggerEvent("error", e), (this || _global).onError && (this || _global).onError.call(this || _global, e);
  }, Q.prototype.triggerConfigError = function (t) {
    var e = new F(t, (this || _global).currentFrame);
    this.triggerEvent("error", e), (this || _global).onError && (this || _global).onError.call(this || _global, e);
  };
  var $ = function () {
      var t = {},
        e = [],
        i = 0,
        s = 0,
        r = 0,
        n = !0,
        o = !1;
      function h(t) {
        for (var i = 0, a = t.target; i < s;) e[i].animation === a && (e.splice(i, 1), i -= 1, s -= 1, a.isPaused || f()), i += 1;
      }
      function l(t, i) {
        if (!t) return null;
        for (var a = 0; a < s;) {
          if (e[a].elem === t && null !== e[a].elem) return e[a].animation;
          a += 1;
        }
        var r = new Q();
        return d(r, t), r.setData(t, i), r;
      }
      function p() {
        r += 1, u();
      }
      function f() {
        r -= 1;
      }
      function d(t, i) {
        t.addEventListener("destroy", h), t.addEventListener("_active", p), t.addEventListener("_idle", f), e.push({
          elem: i,
          animation: t
        }), s += 1;
      }
      function m(t) {
        var a,
          h = t - i;
        for (a = 0; a < s; a += 1) e[a].animation.advanceTime(h);
        i = t, r && !o ? window.requestAnimationFrame(m) : n = !0;
      }
      function c(t) {
        i = t, window.requestAnimationFrame(m);
      }
      function u() {
        !o && r && n && (window.requestAnimationFrame(c), n = !1);
      }
      return t.registerAnimation = l, t.loadAnimation = function (t) {
        var e = new Q();
        return d(e, null), e.setParams(t), e;
      }, t.setSpeed = function (t, i) {
        var a;
        for (a = 0; a < s; a += 1) e[a].animation.setSpeed(t, i);
      }, t.setDirection = function (t, i) {
        var a;
        for (a = 0; a < s; a += 1) e[a].animation.setDirection(t, i);
      }, t.play = function (t) {
        var i;
        for (i = 0; i < s; i += 1) e[i].animation.play(t);
      }, t.pause = function (t) {
        var i;
        for (i = 0; i < s; i += 1) e[i].animation.pause(t);
      }, t.stop = function (t) {
        var i;
        for (i = 0; i < s; i += 1) e[i].animation.stop(t);
      }, t.togglePause = function (t) {
        var i;
        for (i = 0; i < s; i += 1) e[i].animation.togglePause(t);
      }, t.searchAnimations = function (t, e, i) {
        var s,
          r = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
          n = r.length;
        for (s = 0; s < n; s += 1) i && r[s].setAttribute("data-bm-type", i), l(r[s], t);
        if (e && 0 === n) {
          i || (i = "svg");
          var o = document.getElementsByTagName("body")[0];
          o.innerText = "";
          var h = a("div");
          h.style.width = "100%", h.style.height = "100%", h.setAttribute("data-bm-type", i), o.appendChild(h), l(h, t);
        }
      }, t.resize = function () {
        var t;
        for (t = 0; t < s; t += 1) e[t].animation.resize();
      }, t.goToAndStop = function (t, i, a) {
        var r;
        for (r = 0; r < s; r += 1) e[r].animation.goToAndStop(t, i, a);
      }, t.destroy = function (t) {
        var i;
        for (i = s - 1; i >= 0; i -= 1) e[i].animation.destroy(t);
      }, t.freeze = function () {
        o = !0;
      }, t.unfreeze = function () {
        o = !1, u();
      }, t.setVolume = function (t, i) {
        var a;
        for (a = 0; a < s; a += 1) e[a].animation.setVolume(t, i);
      }, t.mute = function (t) {
        var i;
        for (i = 0; i < s; i += 1) e[i].animation.mute(t);
      }, t.unmute = function (t) {
        var i;
        for (i = 0; i < s; i += 1) e[i].animation.unmute(t);
      }, t.getRegisteredAnimations = function () {
        var t,
          i = e.length,
          s = [];
        for (t = 0; t < i; t += 1) s.push(e[t].animation);
        return s;
      }, t;
    }(),
    tt = function () {
      var t = {
          getBezierEasing: function (t, i, s, a, r) {
            var n = r || ("bez_" + t + "_" + i + "_" + s + "_" + a).replace(/\./g, "p");
            if (e[n]) return e[n];
            var o = new l([t, i, s, a]);
            return e[n] = o, o;
          }
        },
        e = {};
      var i = 0.1,
        s = "function" == typeof Float32Array;
      function a(t, e) {
        return 1 - 3 * e + 3 * t;
      }
      function r(t, e) {
        return 3 * e - 6 * t;
      }
      function n(t) {
        return 3 * t;
      }
      function o(t, e, i) {
        return ((a(e, i) * t + r(e, i)) * t + n(e)) * t;
      }
      function h(t, e, i) {
        return 3 * a(e, i) * t * t + 2 * r(e, i) * t + n(e);
      }
      function l(t) {
        (this || _global)._p = t, (this || _global)._mSampleValues = s ? new Float32Array(11) : new Array(11), (this || _global)._precomputed = !1, (this || _global).get = (this || _global).get.bind(this || _global);
      }
      return l.prototype = {
        get: function (t) {
          var e = (this || _global)._p[0],
            i = (this || _global)._p[1],
            s = (this || _global)._p[2],
            a = (this || _global)._p[3];
          return (this || _global)._precomputed || this._precompute(), e === i && s === a ? t : 0 === t ? 0 : 1 === t ? 1 : o(this._getTForX(t), i, a);
        },
        _precompute: function () {
          var t = (this || _global)._p[0],
            e = (this || _global)._p[1],
            i = (this || _global)._p[2],
            s = (this || _global)._p[3];
          (this || _global)._precomputed = !0, t === e && i === s || this._calcSampleValues();
        },
        _calcSampleValues: function () {
          for (var t = (this || _global)._p[0], e = (this || _global)._p[2], s = 0; s < 11; ++s) (this || _global)._mSampleValues[s] = o(s * i, t, e);
        },
        _getTForX: function (t) {
          for (var e = (this || _global)._p[0], s = (this || _global)._p[2], a = (this || _global)._mSampleValues, r = 0, n = 1; 10 !== n && a[n] <= t; ++n) r += i;
          var l = r + (t - a[--n]) / (a[n + 1] - a[n]) * i,
            p = h(l, e, s);
          return p >= 0.001 ? function (t, e, i, s) {
            for (var a = 0; a < 4; ++a) {
              var r = h(e, i, s);
              if (0 === r) return e;
              e -= (o(e, i, s) - t) / r;
            }
            return e;
          }(t, l, e, s) : 0 === p ? l : function (t, e, i, s, a) {
            var r,
              n,
              h = 0;
            do {
              (r = o(n = e + (i - e) / 2, s, a) - t) > 0 ? i = n : e = n;
            } while (Math.abs(r) > 1e-7 && ++h < 10);
            return n;
          }(t, r, r + i, e, s);
        }
      }, t;
    }(),
    et = {
      double: function (t) {
        return t.concat(l(t.length));
      }
    },
    it = function (t, e, i) {
      var s = 0,
        a = t,
        r = l(a);
      return {
        newElement: function () {
          return s ? r[s -= 1] : e();
        },
        release: function (t) {
          s === a && (r = et.double(r), a *= 2), i && i(t), r[s] = t, s += 1;
        }
      };
    },
    st = it(8, function () {
      return {
        addedLength: 0,
        percents: h("float32", j()),
        lengths: h("float32", j())
      };
    }),
    at = it(8, function () {
      return {
        lengths: [],
        totalLength: 0
      };
    }, function (t) {
      var e,
        i = t.lengths.length;
      for (e = 0; e < i; e += 1) st.release(t.lengths[e]);
      t.lengths.length = 0;
    });
  var rt = function () {
      var t = Math;
      function e(t, e, i, s, a, r) {
        var n = t * s + e * a + i * r - a * s - r * t - i * e;
        return n > -0.001 && n < 0.001;
      }
      var i = function (t, e, i, s) {
        var a,
          r,
          n,
          o,
          h,
          l,
          p = j(),
          f = 0,
          d = [],
          m = [],
          c = st.newElement();
        for (n = i.length, a = 0; a < p; a += 1) {
          for (h = a / (p - 1), l = 0, r = 0; r < n; r += 1) o = g(1 - h, 3) * t[r] + 3 * g(1 - h, 2) * h * i[r] + 3 * (1 - h) * g(h, 2) * s[r] + g(h, 3) * e[r], d[r] = o, null !== m[r] && (l += g(d[r] - m[r], 2)), m[r] = d[r];
          l && (f += l = y(l)), c.percents[a] = h, c.lengths[a] = f;
        }
        return c.addedLength = f, c;
      };
      function s(t) {
        (this || _global).segmentLength = 0, (this || _global).points = new Array(t);
      }
      function a(t, e) {
        (this || _global).partialLength = t, (this || _global).point = e;
      }
      var r,
        n = (r = {}, function (t, i, n, o) {
          var h = (t[0] + "_" + t[1] + "_" + i[0] + "_" + i[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
          if (!r[h]) {
            var p,
              f,
              d,
              m,
              c,
              u,
              v,
              b = j(),
              _ = 0,
              k = null;
            2 === t.length && (t[0] !== i[0] || t[1] !== i[1]) && e(t[0], t[1], i[0], i[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], i[0], i[1], i[0] + o[0], i[1] + o[1]) && (b = 2);
            var P = new s(b);
            for (d = n.length, p = 0; p < b; p += 1) {
              for (v = l(d), c = p / (b - 1), u = 0, f = 0; f < d; f += 1) m = g(1 - c, 3) * t[f] + 3 * g(1 - c, 2) * c * (t[f] + n[f]) + 3 * (1 - c) * g(c, 2) * (i[f] + o[f]) + g(c, 3) * i[f], v[f] = m, null !== k && (u += g(v[f] - k[f], 2));
              _ += u = y(u), P.points[p] = new a(u, v), k = v;
            }
            P.segmentLength = _, r[h] = P;
          }
          return r[h];
        });
      function o(t, e) {
        var i = e.percents,
          s = e.lengths,
          a = i.length,
          r = v((a - 1) * t),
          n = t * e.addedLength,
          o = 0;
        if (r === a - 1 || 0 === r || n === s[r]) return i[r];
        for (var h = s[r] > n ? -1 : 1, l = !0; l;) if (s[r] <= n && s[r + 1] > n ? (o = (n - s[r]) / (s[r + 1] - s[r]), l = !1) : r += h, r < 0 || r >= a - 1) {
          if (r === a - 1) return i[r];
          l = !1;
        }
        return i[r] + (i[r + 1] - i[r]) * o;
      }
      var p = h("float32", 8);
      return {
        getSegmentsLength: function (t) {
          var e,
            s = at.newElement(),
            a = t.c,
            r = t.v,
            n = t.o,
            o = t.i,
            h = t._length,
            l = s.lengths,
            p = 0;
          for (e = 0; e < h - 1; e += 1) l[e] = i(r[e], r[e + 1], n[e], o[e + 1]), p += l[e].addedLength;
          return a && h && (l[e] = i(r[e], r[0], n[e], o[0]), p += l[e].addedLength), s.totalLength = p, s;
        },
        getNewSegment: function (e, i, s, a, r, n, h) {
          r < 0 ? r = 0 : r > 1 && (r = 1);
          var l,
            f = o(r, h),
            d = o(n = n > 1 ? 1 : n, h),
            m = e.length,
            c = 1 - f,
            u = 1 - d,
            g = c * c * c,
            y = f * c * c * 3,
            v = f * f * c * 3,
            b = f * f * f,
            _ = c * c * u,
            k = f * c * u + c * f * u + c * c * d,
            P = f * f * u + c * f * d + f * c * d,
            A = f * f * d,
            S = c * u * u,
            x = f * u * u + c * d * u + c * u * d,
            w = f * d * u + c * d * d + f * u * d,
            D = f * d * d,
            C = u * u * u,
            M = d * u * u + u * d * u + u * u * d,
            T = d * d * u + u * d * d + d * u * d,
            F = d * d * d;
          for (l = 0; l < m; l += 1) p[4 * l] = t.round(1000 * (g * e[l] + y * s[l] + v * a[l] + b * i[l])) / 1000, p[4 * l + 1] = t.round(1000 * (_ * e[l] + k * s[l] + P * a[l] + A * i[l])) / 1000, p[4 * l + 2] = t.round(1000 * (S * e[l] + x * s[l] + w * a[l] + D * i[l])) / 1000, p[4 * l + 3] = t.round(1000 * (C * e[l] + M * s[l] + T * a[l] + F * i[l])) / 1000;
          return p;
        },
        getPointInSegment: function (e, i, s, a, r, n) {
          var h = o(r, n),
            l = 1 - h;
          return [t.round(1000 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * s[0] + (h * h * l + l * h * h + h * l * h) * a[0] + h * h * h * i[0])) / 1000, t.round(1000 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * s[1] + (h * h * l + l * h * h + h * l * h) * a[1] + h * h * h * i[1])) / 1000];
        },
        buildBezierData: n,
        pointOnLine2D: e,
        pointOnLine3D: function (i, s, a, r, n, o, h, l, p) {
          if (0 === a && 0 === o && 0 === p) return e(i, s, r, n, h, l);
          var f,
            d = t.sqrt(t.pow(r - i, 2) + t.pow(n - s, 2) + t.pow(o - a, 2)),
            m = t.sqrt(t.pow(h - i, 2) + t.pow(l - s, 2) + t.pow(p - a, 2)),
            c = t.sqrt(t.pow(h - r, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
          return (f = d > m ? d > c ? d - m - c : c - m - d : c > m ? c - m - d : m - d - c) > -0.0001 && f < 0.0001;
        }
      };
    }(),
    nt = i,
    ot = Math.abs;
  function ht(t, e) {
    var i,
      s = (this || _global).offsetTime;
    "multidimensional" === (this || _global).propType && (i = h("float32", (this || _global).pv.length));
    for (var a, r, n, o, l, p, f, d, m, c = e.lastIndex, u = c, g = (this || _global).keyframes.length - 1, y = !0; y;) {
      if (a = (this || _global).keyframes[u], r = (this || _global).keyframes[u + 1], u === g - 1 && t >= r.t - s) {
        a.h && (a = r), c = 0;
        break;
      }
      if (r.t - s > t) {
        c = u;
        break;
      }
      u < g - 1 ? u += 1 : (c = 0, y = !1);
    }
    n = (this || _global).keyframesMetadata[u] || {};
    var v,
      b,
      _,
      k,
      A,
      S,
      x,
      w,
      D,
      C,
      M = r.t - s,
      T = a.t - s;
    if (a.to) {
      n.bezierData || (n.bezierData = rt.buildBezierData(a.s, r.s || a.e, a.to, a.ti));
      var F = n.bezierData;
      if (t >= M || t < T) {
        var E = t >= M ? F.points.length - 1 : 0;
        for (l = F.points[E].point.length, o = 0; o < l; o += 1) i[o] = F.points[E].point[o];
      } else {
        n.__fnct ? m = n.__fnct : (m = tt.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get, n.__fnct = m), p = m((t - T) / (M - T));
        var I,
          L = F.segmentLength * p,
          V = e.lastFrame < t && e._lastKeyframeIndex === u ? e._lastAddedLength : 0;
        for (d = e.lastFrame < t && e._lastKeyframeIndex === u ? e._lastPoint : 0, y = !0, f = F.points.length; y;) {
          if (V += F.points[d].partialLength, 0 === L || 0 === p || d === F.points.length - 1) {
            for (l = F.points[d].point.length, o = 0; o < l; o += 1) i[o] = F.points[d].point[o];
            break;
          }
          if (L >= V && L < V + F.points[d + 1].partialLength) {
            for (I = (L - V) / F.points[d + 1].partialLength, l = F.points[d].point.length, o = 0; o < l; o += 1) i[o] = F.points[d].point[o] + (F.points[d + 1].point[o] - F.points[d].point[o]) * I;
            break;
          }
          d < f - 1 ? d += 1 : y = !1;
        }
        e._lastPoint = d, e._lastAddedLength = V - F.points[d].partialLength, e._lastKeyframeIndex = u;
      }
    } else {
      var R, z, O, N, B;
      if (g = a.s.length, v = r.s || a.e, (this || _global).sh && 1 !== a.h) {
        if (t >= M) i[0] = v[0], i[1] = v[1], i[2] = v[2];else if (t <= T) i[0] = a.s[0], i[1] = a.s[1], i[2] = a.s[2];else {
          var q = lt(a.s),
            j = lt(v);
          b = i, _ = function (t, e, i) {
            var s,
              a,
              r,
              n,
              o,
              h = [],
              l = t[0],
              p = t[1],
              f = t[2],
              d = t[3],
              m = e[0],
              c = e[1],
              u = e[2],
              g = e[3];
            return (a = l * m + p * c + f * u + d * g) < 0 && (a = -a, m = -m, c = -c, u = -u, g = -g), 1 - a > 0.000001 ? (s = Math.acos(a), r = Math.sin(s), n = Math.sin((1 - i) * s) / r, o = Math.sin(i * s) / r) : (n = 1 - i, o = i), h[0] = n * l + o * m, h[1] = n * p + o * c, h[2] = n * f + o * u, h[3] = n * d + o * g, h;
          }(q, j, (t - T) / (M - T)), k = _[0], A = _[1], S = _[2], x = _[3], w = Math.atan2(2 * A * x - 2 * k * S, 1 - 2 * A * A - 2 * S * S), D = Math.asin(2 * k * A + 2 * S * x), C = Math.atan2(2 * k * x - 2 * A * S, 1 - 2 * k * k - 2 * S * S), b[0] = w / P, b[1] = D / P, b[2] = C / P;
        }
      } else for (u = 0; u < g; u += 1) 1 !== a.h && (t >= M ? p = 1 : t < T ? p = 0 : (a.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[u] ? m = n.__fnct[u] : (R = void 0 === a.o.x[u] ? a.o.x[0] : a.o.x[u], z = void 0 === a.o.y[u] ? a.o.y[0] : a.o.y[u], O = void 0 === a.i.x[u] ? a.i.x[0] : a.i.x[u], N = void 0 === a.i.y[u] ? a.i.y[0] : a.i.y[u], m = tt.getBezierEasing(R, z, O, N).get, n.__fnct[u] = m)) : n.__fnct ? m = n.__fnct : (R = a.o.x, z = a.o.y, O = a.i.x, N = a.i.y, m = tt.getBezierEasing(R, z, O, N).get, a.keyframeMetadata = m), p = m((t - T) / (M - T)))), v = r.s || a.e, B = 1 === a.h ? a.s[u] : a.s[u] + (v[u] - a.s[u]) * p, "multidimensional" === (this || _global).propType ? i[u] = B : i = B;
    }
    return e.lastIndex = c, i;
  }
  function lt(t) {
    var e = t[0] * P,
      i = t[1] * P,
      s = t[2] * P,
      a = Math.cos(e / 2),
      r = Math.cos(i / 2),
      n = Math.cos(s / 2),
      o = Math.sin(e / 2),
      h = Math.sin(i / 2),
      l = Math.sin(s / 2);
    return [o * h * n + a * r * l, o * r * n + a * h * l, a * h * n - o * r * l, a * r * n - o * h * l];
  }
  function pt() {
    var t = (this || _global).comp.renderedFrame - (this || _global).offsetTime,
      e = (this || _global).keyframes[0].t - (this || _global).offsetTime,
      i = (this || _global).keyframes[(this || _global).keyframes.length - 1].t - (this || _global).offsetTime;
    if (!(t === (this || _global)._caching.lastFrame || (this || _global)._caching.lastFrame !== nt && ((this || _global)._caching.lastFrame >= i && t >= i || (this || _global)._caching.lastFrame < e && t < e))) {
      (this || _global)._caching.lastFrame >= t && ((this || _global)._caching._lastKeyframeIndex = -1, (this || _global)._caching.lastIndex = 0);
      var s = this.interpolateValue(t, (this || _global)._caching);
      (this || _global).pv = s;
    }
    return (this || _global)._caching.lastFrame = t, (this || _global).pv;
  }
  function ft(t) {
    var e;
    if ("unidimensional" === (this || _global).propType) e = t * (this || _global).mult, ot((this || _global).v - e) > 0.00001 && ((this || _global).v = e, (this || _global)._mdf = !0);else for (var i = 0, s = (this || _global).v.length; i < s;) e = t[i] * (this || _global).mult, ot((this || _global).v[i] - e) > 0.00001 && ((this || _global).v[i] = e, (this || _global)._mdf = !0), i += 1;
  }
  function dt() {
    if ((this || _global).elem.globalData.frameId !== (this || _global).frameId && (this || _global).effectsSequence.length) if ((this || _global).lock) this.setVValue((this || _global).pv);else {
      var t;
      (this || _global).lock = !0, (this || _global)._mdf = (this || _global)._isFirstFrame;
      var e = (this || _global).effectsSequence.length,
        i = (this || _global).kf ? (this || _global).pv : (this || _global).data.k;
      for (t = 0; t < e; t += 1) i = (this || _global).effectsSequence[t](i);
      this.setVValue(i), (this || _global)._isFirstFrame = !1, (this || _global).lock = !1, (this || _global).frameId = (this || _global).elem.globalData.frameId;
    }
  }
  function mt(t) {
    (this || _global).effectsSequence.push(t), (this || _global).container.addDynamicProperty(this || _global);
  }
  function ct(t, e, i, s) {
    (this || _global).propType = "unidimensional", (this || _global).mult = i || 1, (this || _global).data = e, (this || _global).v = i ? e.k * i : e.k, (this || _global).pv = e.k, (this || _global)._mdf = !1, (this || _global).elem = t, (this || _global).container = s, (this || _global).comp = t.comp, (this || _global).k = !1, (this || _global).kf = !1, (this || _global).vel = 0, (this || _global).effectsSequence = [], (this || _global)._isFirstFrame = !0, (this || _global).getValue = dt, (this || _global).setVValue = ft, (this || _global).addEffect = mt;
  }
  function ut(t, e, i, s) {
    var a;
    (this || _global).propType = "multidimensional", (this || _global).mult = i || 1, (this || _global).data = e, (this || _global)._mdf = !1, (this || _global).elem = t, (this || _global).container = s, (this || _global).comp = t.comp, (this || _global).k = !1, (this || _global).kf = !1, (this || _global).frameId = -1;
    var r = e.k.length;
    for ((this || _global).v = h("float32", r), (this || _global).pv = h("float32", r), (this || _global).vel = h("float32", r), a = 0; a < r; a += 1) (this || _global).v[a] = e.k[a] * (this || _global).mult, (this || _global).pv[a] = e.k[a];
    (this || _global)._isFirstFrame = !0, (this || _global).effectsSequence = [], (this || _global).getValue = dt, (this || _global).setVValue = ft, (this || _global).addEffect = mt;
  }
  function gt(t, e, i, s) {
    (this || _global).propType = "unidimensional", (this || _global).keyframes = e.k, (this || _global).keyframesMetadata = [], (this || _global).offsetTime = t.data.st, (this || _global).frameId = -1, (this || _global)._caching = {
      lastFrame: nt,
      lastIndex: 0,
      value: 0,
      _lastKeyframeIndex: -1
    }, (this || _global).k = !0, (this || _global).kf = !0, (this || _global).data = e, (this || _global).mult = i || 1, (this || _global).elem = t, (this || _global).container = s, (this || _global).comp = t.comp, (this || _global).v = nt, (this || _global).pv = nt, (this || _global)._isFirstFrame = !0, (this || _global).getValue = dt, (this || _global).setVValue = ft, (this || _global).interpolateValue = ht, (this || _global).effectsSequence = [pt.bind(this || _global)], (this || _global).addEffect = mt;
  }
  function yt(t, e, i, s) {
    var a;
    (this || _global).propType = "multidimensional";
    var r,
      n,
      o,
      l,
      p = e.k.length;
    for (a = 0; a < p - 1; a += 1) e.k[a].to && e.k[a].s && e.k[a + 1] && e.k[a + 1].s && (r = e.k[a].s, n = e.k[a + 1].s, o = e.k[a].to, l = e.k[a].ti, (2 === r.length && (r[0] !== n[0] || r[1] !== n[1]) && rt.pointOnLine2D(r[0], r[1], n[0], n[1], r[0] + o[0], r[1] + o[1]) && rt.pointOnLine2D(r[0], r[1], n[0], n[1], n[0] + l[0], n[1] + l[1]) || 3 === r.length && (r[0] !== n[0] || r[1] !== n[1] || r[2] !== n[2]) && rt.pointOnLine3D(r[0], r[1], r[2], n[0], n[1], n[2], r[0] + o[0], r[1] + o[1], r[2] + o[2]) && rt.pointOnLine3D(r[0], r[1], r[2], n[0], n[1], n[2], n[0] + l[0], n[1] + l[1], n[2] + l[2])) && (e.k[a].to = null, e.k[a].ti = null), r[0] === n[0] && r[1] === n[1] && 0 === o[0] && 0 === o[1] && 0 === l[0] && 0 === l[1] && (2 === r.length || r[2] === n[2] && 0 === o[2] && 0 === l[2]) && (e.k[a].to = null, e.k[a].ti = null));
    (this || _global).effectsSequence = [pt.bind(this || _global)], (this || _global).data = e, (this || _global).keyframes = e.k, (this || _global).keyframesMetadata = [], (this || _global).offsetTime = t.data.st, (this || _global).k = !0, (this || _global).kf = !0, (this || _global)._isFirstFrame = !0, (this || _global).mult = i || 1, (this || _global).elem = t, (this || _global).container = s, (this || _global).comp = t.comp, (this || _global).getValue = dt, (this || _global).setVValue = ft, (this || _global).interpolateValue = ht, (this || _global).frameId = -1;
    var f = e.k[0].s.length;
    for ((this || _global).v = h("float32", f), (this || _global).pv = h("float32", f), a = 0; a < f; a += 1) (this || _global).v[a] = nt, (this || _global).pv[a] = nt;
    (this || _global)._caching = {
      lastFrame: nt,
      lastIndex: 0,
      value: h("float32", f)
    }, (this || _global).addEffect = mt;
  }
  var vt = {
    getProp: function (t, e, i, s, a) {
      var r;
      if (e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length) {
        if ("number" == typeof e.k[0]) r = new ut(t, e, s, a);else switch (i) {
          case 0:
            r = new gt(t, e, s, a);
            break;
          case 1:
            r = new yt(t, e, s, a);
        }
      } else r = new ct(t, e, s, a);
      return r.effectsSequence.length && a.addDynamicProperty(r), r;
    }
  };
  function bt() {}
  bt.prototype = {
    addDynamicProperty: function (t) {
      -1 === (this || _global).dynamicProperties.indexOf(t) && ((this || _global).dynamicProperties.push(t), (this || _global).container.addDynamicProperty(this || _global), (this || _global)._isAnimated = !0);
    },
    iterateDynamicProperties: function () {
      var t;
      (this || _global)._mdf = !1;
      var e = (this || _global).dynamicProperties.length;
      for (t = 0; t < e; t += 1) (this || _global).dynamicProperties[t].getValue(), (this || _global).dynamicProperties[t]._mdf && ((this || _global)._mdf = !0);
    },
    initDynamicPropertyContainer: function (t) {
      (this || _global).container = t, (this || _global).dynamicProperties = [], (this || _global)._mdf = !1, (this || _global)._isAnimated = !1;
    }
  };
  var _t = it(8, function () {
    return h("float32", 2);
  });
  function kt() {
    (this || _global).c = !1, (this || _global)._length = 0, (this || _global)._maxLength = 8, (this || _global).v = l((this || _global)._maxLength), (this || _global).o = l((this || _global)._maxLength), (this || _global).i = l((this || _global)._maxLength);
  }
  kt.prototype.setPathData = function (t, e) {
    (this || _global).c = t, this.setLength(e);
    for (var i = 0; i < e;) (this || _global).v[i] = _t.newElement(), (this || _global).o[i] = _t.newElement(), (this || _global).i[i] = _t.newElement(), i += 1;
  }, kt.prototype.setLength = function (t) {
    for (; (this || _global)._maxLength < t;) this.doubleArrayLength();
    (this || _global)._length = t;
  }, kt.prototype.doubleArrayLength = function () {
    (this || _global).v = (this || _global).v.concat(l((this || _global)._maxLength)), (this || _global).i = (this || _global).i.concat(l((this || _global)._maxLength)), (this || _global).o = (this || _global).o.concat(l((this || _global)._maxLength)), (this || _global)._maxLength *= 2;
  }, kt.prototype.setXYAt = function (t, e, i, s, a) {
    var r;
    switch ((this || _global)._length = Math.max((this || _global)._length, s + 1), (this || _global)._length >= (this || _global)._maxLength && this.doubleArrayLength(), i) {
      case "v":
        r = (this || _global).v;
        break;
      case "i":
        r = (this || _global).i;
        break;
      case "o":
        r = (this || _global).o;
        break;
      default:
        r = [];
    }
    (!r[s] || r[s] && !a) && (r[s] = _t.newElement()), r[s][0] = t, r[s][1] = e;
  }, kt.prototype.setTripleAt = function (t, e, i, s, a, r, n, o) {
    this.setXYAt(t, e, "v", n, o), this.setXYAt(i, s, "o", n, o), this.setXYAt(a, r, "i", n, o);
  }, kt.prototype.reverse = function () {
    var t = new kt();
    t.setPathData((this || _global).c, (this || _global)._length);
    var e = (this || _global).v,
      i = (this || _global).o,
      s = (this || _global).i,
      a = 0;
    (this || _global).c && (t.setTripleAt(e[0][0], e[0][1], s[0][0], s[0][1], i[0][0], i[0][1], 0, !1), a = 1);
    var r,
      n = (this || _global)._length - 1,
      o = (this || _global)._length;
    for (r = a; r < o; r += 1) t.setTripleAt(e[n][0], e[n][1], s[n][0], s[n][1], i[n][0], i[n][1], r, !1), n -= 1;
    return t;
  }, kt.prototype.length = function () {
    return (this || _global)._length;
  };
  var Pt,
    At = ((Pt = it(4, function () {
      return new kt();
    }, function (t) {
      var e,
        i = t._length;
      for (e = 0; e < i; e += 1) _t.release(t.v[e]), _t.release(t.i[e]), _t.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
      t._length = 0, t.c = !1;
    })).clone = function (t) {
      var e,
        i = Pt.newElement(),
        s = void 0 === t._length ? t.v.length : t._length;
      for (i.setLength(s), i.c = t.c, e = 0; e < s; e += 1) i.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
      return i;
    }, Pt);
  function St() {
    (this || _global)._length = 0, (this || _global)._maxLength = 4, (this || _global).shapes = l((this || _global)._maxLength);
  }
  St.prototype.addShape = function (t) {
    (this || _global)._length === (this || _global)._maxLength && ((this || _global).shapes = (this || _global).shapes.concat(l((this || _global)._maxLength)), (this || _global)._maxLength *= 2), (this || _global).shapes[(this || _global)._length] = t, (this || _global)._length += 1;
  }, St.prototype.releaseShapes = function () {
    var t;
    for (t = 0; t < (this || _global)._length; t += 1) At.release((this || _global).shapes[t]);
    (this || _global)._length = 0;
  };
  var xt,
    wt,
    Dt,
    Ct,
    Mt = (xt = {
      newShapeCollection: function () {
        return wt ? Ct[wt -= 1] : new St();
      },
      release: function (t) {
        var e,
          i = t._length;
        for (e = 0; e < i; e += 1) At.release(t.shapes[e]);
        t._length = 0, wt === Dt && (Ct = et.double(Ct), Dt *= 2), Ct[wt] = t, wt += 1;
      }
    }, wt = 0, Ct = l(Dt = 4), xt),
    Tt = function () {
      var t = -999999;
      function e(t, e, i) {
        var s,
          a,
          r,
          n,
          o,
          h,
          l,
          p,
          f,
          d = i.lastIndex,
          m = (this || _global).keyframes;
        if (t < m[0].t - (this || _global).offsetTime) s = m[0].s[0], r = !0, d = 0;else if (t >= m[m.length - 1].t - (this || _global).offsetTime) s = m[m.length - 1].s ? m[m.length - 1].s[0] : m[m.length - 2].e[0], r = !0;else {
          for (var c, u, g, y = d, v = m.length - 1, b = !0; b && (c = m[y], !((u = m[y + 1]).t - (this || _global).offsetTime > t));) y < v - 1 ? y += 1 : b = !1;
          if (g = (this || _global).keyframesMetadata[y] || {}, d = y, !(r = 1 === c.h)) {
            if (t >= u.t - (this || _global).offsetTime) p = 1;else if (t < c.t - (this || _global).offsetTime) p = 0;else {
              var _;
              g.__fnct ? _ = g.__fnct : (_ = tt.getBezierEasing(c.o.x, c.o.y, c.i.x, c.i.y).get, g.__fnct = _), p = _((t - (c.t - (this || _global).offsetTime)) / (u.t - (this || _global).offsetTime - (c.t - (this || _global).offsetTime)));
            }
            a = u.s ? u.s[0] : c.e[0];
          }
          s = c.s[0];
        }
        for (h = e._length, l = s.i[0].length, i.lastIndex = d, n = 0; n < h; n += 1) for (o = 0; o < l; o += 1) f = r ? s.i[n][o] : s.i[n][o] + (a.i[n][o] - s.i[n][o]) * p, e.i[n][o] = f, f = r ? s.o[n][o] : s.o[n][o] + (a.o[n][o] - s.o[n][o]) * p, e.o[n][o] = f, f = r ? s.v[n][o] : s.v[n][o] + (a.v[n][o] - s.v[n][o]) * p, e.v[n][o] = f;
      }
      function i() {
        var e = (this || _global).comp.renderedFrame - (this || _global).offsetTime,
          i = (this || _global).keyframes[0].t - (this || _global).offsetTime,
          s = (this || _global).keyframes[(this || _global).keyframes.length - 1].t - (this || _global).offsetTime,
          a = (this || _global)._caching.lastFrame;
        return a !== t && (a < i && e < i || a > s && e > s) || ((this || _global)._caching.lastIndex = a < e ? (this || _global)._caching.lastIndex : 0, this.interpolateShape(e, (this || _global).pv, (this || _global)._caching)), (this || _global)._caching.lastFrame = e, (this || _global).pv;
      }
      function s() {
        (this || _global).paths = (this || _global).localShapeCollection;
      }
      function a(t) {
        (function (t, e) {
          if (t._length !== e._length || t.c !== e.c) return !1;
          var i,
            s = t._length;
          for (i = 0; i < s; i += 1) if (t.v[i][0] !== e.v[i][0] || t.v[i][1] !== e.v[i][1] || t.o[i][0] !== e.o[i][0] || t.o[i][1] !== e.o[i][1] || t.i[i][0] !== e.i[i][0] || t.i[i][1] !== e.i[i][1]) return !1;
          return !0;
        })((this || _global).v, t) || ((this || _global).v = At.clone(t), (this || _global).localShapeCollection.releaseShapes(), (this || _global).localShapeCollection.addShape((this || _global).v), (this || _global)._mdf = !0, (this || _global).paths = (this || _global).localShapeCollection);
      }
      function n() {
        if ((this || _global).elem.globalData.frameId !== (this || _global).frameId) if ((this || _global).effectsSequence.length) {
          if ((this || _global).lock) this.setVValue((this || _global).pv);else {
            var t, e;
            (this || _global).lock = !0, (this || _global)._mdf = !1, t = (this || _global).kf ? (this || _global).pv : (this || _global).data.ks ? (this || _global).data.ks.k : (this || _global).data.pt.k;
            var i = (this || _global).effectsSequence.length;
            for (e = 0; e < i; e += 1) t = (this || _global).effectsSequence[e](t);
            this.setVValue(t), (this || _global).lock = !1, (this || _global).frameId = (this || _global).elem.globalData.frameId;
          }
        } else (this || _global)._mdf = !1;
      }
      function o(t, e, i) {
        (this || _global).propType = "shape", (this || _global).comp = t.comp, (this || _global).container = t, (this || _global).elem = t, (this || _global).data = e, (this || _global).k = !1, (this || _global).kf = !1, (this || _global)._mdf = !1;
        var a = 3 === i ? e.pt.k : e.ks.k;
        (this || _global).v = At.clone(a), (this || _global).pv = At.clone((this || _global).v), (this || _global).localShapeCollection = Mt.newShapeCollection(), (this || _global).paths = (this || _global).localShapeCollection, (this || _global).paths.addShape((this || _global).v), (this || _global).reset = s, (this || _global).effectsSequence = [];
      }
      function h(t) {
        (this || _global).effectsSequence.push(t), (this || _global).container.addDynamicProperty(this || _global);
      }
      function l(e, a, r) {
        (this || _global).propType = "shape", (this || _global).comp = e.comp, (this || _global).elem = e, (this || _global).container = e, (this || _global).offsetTime = e.data.st, (this || _global).keyframes = 3 === r ? a.pt.k : a.ks.k, (this || _global).keyframesMetadata = [], (this || _global).k = !0, (this || _global).kf = !0;
        var n = (this || _global).keyframes[0].s[0].i.length;
        (this || _global).v = At.newElement(), (this || _global).v.setPathData((this || _global).keyframes[0].s[0].c, n), (this || _global).pv = At.clone((this || _global).v), (this || _global).localShapeCollection = Mt.newShapeCollection(), (this || _global).paths = (this || _global).localShapeCollection, (this || _global).paths.addShape((this || _global).v), (this || _global).lastFrame = t, (this || _global).reset = s, (this || _global)._caching = {
          lastFrame: t,
          lastIndex: 0
        }, (this || _global).effectsSequence = [i.bind(this || _global)];
      }
      o.prototype.interpolateShape = e, o.prototype.getValue = n, o.prototype.setVValue = a, o.prototype.addEffect = h, l.prototype.getValue = n, l.prototype.interpolateShape = e, l.prototype.setVValue = a, l.prototype.addEffect = h;
      var p = function () {
          var t = A;
          function e(t, e) {
            (this || _global).v = At.newElement(), (this || _global).v.setPathData(!0, 4), (this || _global).localShapeCollection = Mt.newShapeCollection(), (this || _global).paths = (this || _global).localShapeCollection, (this || _global).localShapeCollection.addShape((this || _global).v), (this || _global).d = e.d, (this || _global).elem = t, (this || _global).comp = t.comp, (this || _global).frameId = -1, this.initDynamicPropertyContainer(t), (this || _global).p = vt.getProp(t, e.p, 1, 0, this || _global), (this || _global).s = vt.getProp(t, e.s, 1, 0, this || _global), (this || _global).dynamicProperties.length ? (this || _global).k = !0 : ((this || _global).k = !1, this.convertEllToPath());
          }
          return e.prototype = {
            reset: s,
            getValue: function () {
              (this || _global).elem.globalData.frameId !== (this || _global).frameId && ((this || _global).frameId = (this || _global).elem.globalData.frameId, this.iterateDynamicProperties(), (this || _global)._mdf && this.convertEllToPath());
            },
            convertEllToPath: function () {
              var e = (this || _global).p.v[0],
                i = (this || _global).p.v[1],
                s = (this || _global).s.v[0] / 2,
                a = (this || _global).s.v[1] / 2,
                r = 3 !== (this || _global).d,
                n = (this || _global).v;
              n.v[0][0] = e, n.v[0][1] = i - a, n.v[1][0] = r ? e + s : e - s, n.v[1][1] = i, n.v[2][0] = e, n.v[2][1] = i + a, n.v[3][0] = r ? e - s : e + s, n.v[3][1] = i, n.i[0][0] = r ? e - s * t : e + s * t, n.i[0][1] = i - a, n.i[1][0] = r ? e + s : e - s, n.i[1][1] = i - a * t, n.i[2][0] = r ? e + s * t : e - s * t, n.i[2][1] = i + a, n.i[3][0] = r ? e - s : e + s, n.i[3][1] = i + a * t, n.o[0][0] = r ? e + s * t : e - s * t, n.o[0][1] = i - a, n.o[1][0] = r ? e + s : e - s, n.o[1][1] = i + a * t, n.o[2][0] = r ? e - s * t : e + s * t, n.o[2][1] = i + a, n.o[3][0] = r ? e - s : e + s, n.o[3][1] = i - a * t;
            }
          }, r([bt], e), e;
        }(),
        f = function () {
          function t(t, e) {
            (this || _global).v = At.newElement(), (this || _global).v.setPathData(!0, 0), (this || _global).elem = t, (this || _global).comp = t.comp, (this || _global).data = e, (this || _global).frameId = -1, (this || _global).d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? ((this || _global).ir = vt.getProp(t, e.ir, 0, 0, this || _global), (this || _global).is = vt.getProp(t, e.is, 0, 0.01, this || _global), (this || _global).convertToPath = (this || _global).convertStarToPath) : (this || _global).convertToPath = (this || _global).convertPolygonToPath, (this || _global).pt = vt.getProp(t, e.pt, 0, 0, this || _global), (this || _global).p = vt.getProp(t, e.p, 1, 0, this || _global), (this || _global).r = vt.getProp(t, e.r, 0, P, this || _global), (this || _global).or = vt.getProp(t, e.or, 0, 0, this || _global), (this || _global).os = vt.getProp(t, e.os, 0, 0.01, this || _global), (this || _global).localShapeCollection = Mt.newShapeCollection(), (this || _global).localShapeCollection.addShape((this || _global).v), (this || _global).paths = (this || _global).localShapeCollection, (this || _global).dynamicProperties.length ? (this || _global).k = !0 : ((this || _global).k = !1, this.convertToPath());
          }
          return t.prototype = {
            reset: s,
            getValue: function () {
              (this || _global).elem.globalData.frameId !== (this || _global).frameId && ((this || _global).frameId = (this || _global).elem.globalData.frameId, this.iterateDynamicProperties(), (this || _global)._mdf && this.convertToPath());
            },
            convertStarToPath: function () {
              var t,
                e,
                i,
                s,
                a = 2 * Math.floor((this || _global).pt.v),
                r = 2 * Math.PI / a,
                n = !0,
                o = (this || _global).or.v,
                h = (this || _global).ir.v,
                l = (this || _global).os.v,
                p = (this || _global).is.v,
                f = 2 * Math.PI * o / (2 * a),
                d = 2 * Math.PI * h / (2 * a),
                m = -Math.PI / 2;
              m += (this || _global).r.v;
              var c = 3 === (this || _global).data.d ? -1 : 1;
              for ((this || _global).v._length = 0, t = 0; t < a; t += 1) {
                i = n ? l : p, s = n ? f : d;
                var u = (e = n ? o : h) * Math.cos(m),
                  g = e * Math.sin(m),
                  y = 0 === u && 0 === g ? 0 : g / Math.sqrt(u * u + g * g),
                  v = 0 === u && 0 === g ? 0 : -u / Math.sqrt(u * u + g * g);
                u += +(this || _global).p.v[0], g += +(this || _global).p.v[1], (this || _global).v.setTripleAt(u, g, u - y * s * i * c, g - v * s * i * c, u + y * s * i * c, g + v * s * i * c, t, !0), n = !n, m += r * c;
              }
            },
            convertPolygonToPath: function () {
              var t,
                e = Math.floor((this || _global).pt.v),
                i = 2 * Math.PI / e,
                s = (this || _global).or.v,
                a = (this || _global).os.v,
                r = 2 * Math.PI * s / (4 * e),
                n = 0.5 * -Math.PI,
                o = 3 === (this || _global).data.d ? -1 : 1;
              for (n += (this || _global).r.v, (this || _global).v._length = 0, t = 0; t < e; t += 1) {
                var h = s * Math.cos(n),
                  l = s * Math.sin(n),
                  p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l),
                  f = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                h += +(this || _global).p.v[0], l += +(this || _global).p.v[1], (this || _global).v.setTripleAt(h, l, h - p * r * a * o, l - f * r * a * o, h + p * r * a * o, l + f * r * a * o, t, !0), n += i * o;
              }
              (this || _global).paths.length = 0, (this || _global).paths[0] = (this || _global).v;
            }
          }, r([bt], t), t;
        }(),
        d = function () {
          function t(t, e) {
            (this || _global).v = At.newElement(), (this || _global).v.c = !0, (this || _global).localShapeCollection = Mt.newShapeCollection(), (this || _global).localShapeCollection.addShape((this || _global).v), (this || _global).paths = (this || _global).localShapeCollection, (this || _global).elem = t, (this || _global).comp = t.comp, (this || _global).frameId = -1, (this || _global).d = e.d, this.initDynamicPropertyContainer(t), (this || _global).p = vt.getProp(t, e.p, 1, 0, this || _global), (this || _global).s = vt.getProp(t, e.s, 1, 0, this || _global), (this || _global).r = vt.getProp(t, e.r, 0, 0, this || _global), (this || _global).dynamicProperties.length ? (this || _global).k = !0 : ((this || _global).k = !1, this.convertRectToPath());
          }
          return t.prototype = {
            convertRectToPath: function () {
              var t = (this || _global).p.v[0],
                e = (this || _global).p.v[1],
                i = (this || _global).s.v[0] / 2,
                s = (this || _global).s.v[1] / 2,
                a = b(i, s, (this || _global).r.v),
                r = a * (1 - A);
              (this || _global).v._length = 0, 2 === (this || _global).d || 1 === (this || _global).d ? ((this || _global).v.setTripleAt(t + i, e - s + a, t + i, e - s + a, t + i, e - s + r, 0, !0), (this || _global).v.setTripleAt(t + i, e + s - a, t + i, e + s - r, t + i, e + s - a, 1, !0), 0 !== a ? ((this || _global).v.setTripleAt(t + i - a, e + s, t + i - a, e + s, t + i - r, e + s, 2, !0), (this || _global).v.setTripleAt(t - i + a, e + s, t - i + r, e + s, t - i + a, e + s, 3, !0), (this || _global).v.setTripleAt(t - i, e + s - a, t - i, e + s - a, t - i, e + s - r, 4, !0), (this || _global).v.setTripleAt(t - i, e - s + a, t - i, e - s + r, t - i, e - s + a, 5, !0), (this || _global).v.setTripleAt(t - i + a, e - s, t - i + a, e - s, t - i + r, e - s, 6, !0), (this || _global).v.setTripleAt(t + i - a, e - s, t + i - r, e - s, t + i - a, e - s, 7, !0)) : ((this || _global).v.setTripleAt(t - i, e + s, t - i + r, e + s, t - i, e + s, 2), (this || _global).v.setTripleAt(t - i, e - s, t - i, e - s + r, t - i, e - s, 3))) : ((this || _global).v.setTripleAt(t + i, e - s + a, t + i, e - s + r, t + i, e - s + a, 0, !0), 0 !== a ? ((this || _global).v.setTripleAt(t + i - a, e - s, t + i - a, e - s, t + i - r, e - s, 1, !0), (this || _global).v.setTripleAt(t - i + a, e - s, t - i + r, e - s, t - i + a, e - s, 2, !0), (this || _global).v.setTripleAt(t - i, e - s + a, t - i, e - s + a, t - i, e - s + r, 3, !0), (this || _global).v.setTripleAt(t - i, e + s - a, t - i, e + s - r, t - i, e + s - a, 4, !0), (this || _global).v.setTripleAt(t - i + a, e + s, t - i + a, e + s, t - i + r, e + s, 5, !0), (this || _global).v.setTripleAt(t + i - a, e + s, t + i - r, e + s, t + i - a, e + s, 6, !0), (this || _global).v.setTripleAt(t + i, e + s - a, t + i, e + s - a, t + i, e + s - r, 7, !0)) : ((this || _global).v.setTripleAt(t - i, e - s, t - i + r, e - s, t - i, e - s, 1, !0), (this || _global).v.setTripleAt(t - i, e + s, t - i, e + s - r, t - i, e + s, 2, !0), (this || _global).v.setTripleAt(t + i, e + s, t + i - r, e + s, t + i, e + s, 3, !0)));
            },
            getValue: function () {
              (this || _global).elem.globalData.frameId !== (this || _global).frameId && ((this || _global).frameId = (this || _global).elem.globalData.frameId, this.iterateDynamicProperties(), (this || _global)._mdf && this.convertRectToPath());
            },
            reset: s
          }, r([bt], t), t;
        }();
      var m = {
        getShapeProp: function (t, e, i) {
          var s;
          return 3 === i || 4 === i ? s = (3 === i ? e.pt : e.ks).k.length ? new l(t, e, i) : new o(t, e, i) : 5 === i ? s = new d(t, e) : 6 === i ? s = new p(t, e) : 7 === i && (s = new f(t, e)), s.k && t.addDynamicProperty(s), s;
        },
        getConstructorFunction: function () {
          return o;
        },
        getKeyframedConstructorFunction: function () {
          return l;
        }
      };
      return m;
    }(),
    Ft = function () {
      var t = Math.cos,
        e = Math.sin,
        i = Math.tan,
        s = Math.round;
      function a() {
        return (this || _global).props[0] = 1, (this || _global).props[1] = 0, (this || _global).props[2] = 0, (this || _global).props[3] = 0, (this || _global).props[4] = 0, (this || _global).props[5] = 1, (this || _global).props[6] = 0, (this || _global).props[7] = 0, (this || _global).props[8] = 0, (this || _global).props[9] = 0, (this || _global).props[10] = 1, (this || _global).props[11] = 0, (this || _global).props[12] = 0, (this || _global).props[13] = 0, (this || _global).props[14] = 0, (this || _global).props[15] = 1, this || _global;
      }
      function r(i) {
        if (0 === i) return this || _global;
        var s = t(i),
          a = e(i);
        return this._t(s, -a, 0, 0, a, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function n(i) {
        if (0 === i) return this || _global;
        var s = t(i),
          a = e(i);
        return this._t(1, 0, 0, 0, 0, s, -a, 0, 0, a, s, 0, 0, 0, 0, 1);
      }
      function o(i) {
        if (0 === i) return this || _global;
        var s = t(i),
          a = e(i);
        return this._t(s, 0, a, 0, 0, 1, 0, 0, -a, 0, s, 0, 0, 0, 0, 1);
      }
      function l(i) {
        if (0 === i) return this || _global;
        var s = t(i),
          a = e(i);
        return this._t(s, -a, 0, 0, a, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function p(t, e) {
        return this._t(1, e, t, 1, 0, 0);
      }
      function f(t, e) {
        return this.shear(i(t), i(e));
      }
      function d(s, a) {
        var r = t(a),
          n = e(a);
        return this._t(r, n, 0, 0, -n, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i(s), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(r, -n, 0, 0, n, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function m(t, e, i) {
        return i || 0 === i || (i = 1), 1 === t && 1 === e && 1 === i ? this || _global : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1);
      }
      function c(t, e, i, s, a, r, n, o, h, l, p, f, d, m, c, u) {
        return (this || _global).props[0] = t, (this || _global).props[1] = e, (this || _global).props[2] = i, (this || _global).props[3] = s, (this || _global).props[4] = a, (this || _global).props[5] = r, (this || _global).props[6] = n, (this || _global).props[7] = o, (this || _global).props[8] = h, (this || _global).props[9] = l, (this || _global).props[10] = p, (this || _global).props[11] = f, (this || _global).props[12] = d, (this || _global).props[13] = m, (this || _global).props[14] = c, (this || _global).props[15] = u, this || _global;
      }
      function u(t, e, i) {
        return i = i || 0, 0 !== t || 0 !== e || 0 !== i ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, i, 1) : this || _global;
      }
      function g(t, e, i, s, a, r, n, o, h, l, p, f, d, m, c, u) {
        var g = (this || _global).props;
        if (1 === t && 0 === e && 0 === i && 0 === s && 0 === a && 1 === r && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === f) return g[12] = g[12] * t + g[15] * d, g[13] = g[13] * r + g[15] * m, g[14] = g[14] * p + g[15] * c, g[15] *= u, (this || _global)._identityCalculated = !1, this || _global;
        var y = g[0],
          v = g[1],
          b = g[2],
          _ = g[3],
          k = g[4],
          P = g[5],
          A = g[6],
          S = g[7],
          x = g[8],
          w = g[9],
          D = g[10],
          C = g[11],
          M = g[12],
          T = g[13],
          F = g[14],
          E = g[15];
        return g[0] = y * t + v * a + b * h + _ * d, g[1] = y * e + v * r + b * l + _ * m, g[2] = y * i + v * n + b * p + _ * c, g[3] = y * s + v * o + b * f + _ * u, g[4] = k * t + P * a + A * h + S * d, g[5] = k * e + P * r + A * l + S * m, g[6] = k * i + P * n + A * p + S * c, g[7] = k * s + P * o + A * f + S * u, g[8] = x * t + w * a + D * h + C * d, g[9] = x * e + w * r + D * l + C * m, g[10] = x * i + w * n + D * p + C * c, g[11] = x * s + w * o + D * f + C * u, g[12] = M * t + T * a + F * h + E * d, g[13] = M * e + T * r + F * l + E * m, g[14] = M * i + T * n + F * p + E * c, g[15] = M * s + T * o + F * f + E * u, (this || _global)._identityCalculated = !1, this || _global;
      }
      function y(t) {
        var e = t.props;
        return this.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
      }
      function v() {
        return (this || _global)._identityCalculated || ((this || _global)._identity = !(1 !== (this || _global).props[0] || 0 !== (this || _global).props[1] || 0 !== (this || _global).props[2] || 0 !== (this || _global).props[3] || 0 !== (this || _global).props[4] || 1 !== (this || _global).props[5] || 0 !== (this || _global).props[6] || 0 !== (this || _global).props[7] || 0 !== (this || _global).props[8] || 0 !== (this || _global).props[9] || 1 !== (this || _global).props[10] || 0 !== (this || _global).props[11] || 0 !== (this || _global).props[12] || 0 !== (this || _global).props[13] || 0 !== (this || _global).props[14] || 1 !== (this || _global).props[15]), (this || _global)._identityCalculated = !0), (this || _global)._identity;
      }
      function b(t) {
        for (var e = 0; e < 16;) {
          if (t.props[e] !== (this || _global).props[e]) return !1;
          e += 1;
        }
        return !0;
      }
      function _(t) {
        var e;
        for (e = 0; e < 16; e += 1) t.props[e] = (this || _global).props[e];
        return t;
      }
      function k(t) {
        var e;
        for (e = 0; e < 16; e += 1) (this || _global).props[e] = t[e];
      }
      function P(t, e, i) {
        return {
          x: t * (this || _global).props[0] + e * (this || _global).props[4] + i * (this || _global).props[8] + (this || _global).props[12],
          y: t * (this || _global).props[1] + e * (this || _global).props[5] + i * (this || _global).props[9] + (this || _global).props[13],
          z: t * (this || _global).props[2] + e * (this || _global).props[6] + i * (this || _global).props[10] + (this || _global).props[14]
        };
      }
      function A(t, e, i) {
        return t * (this || _global).props[0] + e * (this || _global).props[4] + i * (this || _global).props[8] + (this || _global).props[12];
      }
      function S(t, e, i) {
        return t * (this || _global).props[1] + e * (this || _global).props[5] + i * (this || _global).props[9] + (this || _global).props[13];
      }
      function x(t, e, i) {
        return t * (this || _global).props[2] + e * (this || _global).props[6] + i * (this || _global).props[10] + (this || _global).props[14];
      }
      function w() {
        var t = (this || _global).props[0] * (this || _global).props[5] - (this || _global).props[1] * (this || _global).props[4],
          e = (this || _global).props[5] / t,
          i = -(this || _global).props[1] / t,
          s = -(this || _global).props[4] / t,
          a = (this || _global).props[0] / t,
          r = ((this || _global).props[4] * (this || _global).props[13] - (this || _global).props[5] * (this || _global).props[12]) / t,
          n = -((this || _global).props[0] * (this || _global).props[13] - (this || _global).props[1] * (this || _global).props[12]) / t,
          o = new Ft();
        return o.props[0] = e, o.props[1] = i, o.props[4] = s, o.props[5] = a, o.props[12] = r, o.props[13] = n, o;
      }
      function D(t) {
        return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
      }
      function C(t) {
        var e,
          i = t.length,
          s = [];
        for (e = 0; e < i; e += 1) s[e] = D(t[e]);
        return s;
      }
      function M(t, e, i) {
        var s = h("float32", 6);
        if (this.isIdentity()) s[0] = t[0], s[1] = t[1], s[2] = e[0], s[3] = e[1], s[4] = i[0], s[5] = i[1];else {
          var a = (this || _global).props[0],
            r = (this || _global).props[1],
            n = (this || _global).props[4],
            o = (this || _global).props[5],
            l = (this || _global).props[12],
            p = (this || _global).props[13];
          s[0] = t[0] * a + t[1] * n + l, s[1] = t[0] * r + t[1] * o + p, s[2] = e[0] * a + e[1] * n + l, s[3] = e[0] * r + e[1] * o + p, s[4] = i[0] * a + i[1] * n + l, s[5] = i[0] * r + i[1] * o + p;
        }
        return s;
      }
      function T(t, e, i) {
        return this.isIdentity() ? [t, e, i] : [t * (this || _global).props[0] + e * (this || _global).props[4] + i * (this || _global).props[8] + (this || _global).props[12], t * (this || _global).props[1] + e * (this || _global).props[5] + i * (this || _global).props[9] + (this || _global).props[13], t * (this || _global).props[2] + e * (this || _global).props[6] + i * (this || _global).props[10] + (this || _global).props[14]];
      }
      function F(t, e) {
        if (this.isIdentity()) return t + "," + e;
        var i = (this || _global).props;
        return Math.round(100 * (t * i[0] + e * i[4] + i[12])) / 100 + "," + Math.round(100 * (t * i[1] + e * i[5] + i[13])) / 100;
      }
      function E() {
        for (var t = 0, e = (this || _global).props, i = "matrix3d("; t < 16;) i += s(10000 * e[t]) / 10000, i += 15 === t ? ")" : ",", t += 1;
        return i;
      }
      function I(t) {
        return t < 0.000001 && t > 0 || t > -0.000001 && t < 0 ? s(10000 * t) / 10000 : t;
      }
      function L() {
        var t = (this || _global).props;
        return "matrix(" + I(t[0]) + "," + I(t[1]) + "," + I(t[4]) + "," + I(t[5]) + "," + I(t[12]) + "," + I(t[13]) + ")";
      }
      return function () {
        (this || _global).reset = a, (this || _global).rotate = r, (this || _global).rotateX = n, (this || _global).rotateY = o, (this || _global).rotateZ = l, (this || _global).skew = f, (this || _global).skewFromAxis = d, (this || _global).shear = p, (this || _global).scale = m, (this || _global).setTransform = c, (this || _global).translate = u, (this || _global).transform = g, (this || _global).multiply = y, (this || _global).applyToPoint = P, (this || _global).applyToX = A, (this || _global).applyToY = S, (this || _global).applyToZ = x, (this || _global).applyToPointArray = T, (this || _global).applyToTriplePoints = M, (this || _global).applyToPointStringified = F, (this || _global).toCSS = E, (this || _global).to2dCSS = L, (this || _global).clone = _, (this || _global).cloneFromProps = k, (this || _global).equals = b, (this || _global).inversePoints = C, (this || _global).inversePoint = D, (this || _global).getInverseMatrix = w, (this || _global)._t = (this || _global).transform, (this || _global).isIdentity = v, (this || _global)._identity = !0, (this || _global)._identityCalculated = !1, (this || _global).props = h("float32", 16), this.reset();
      };
    }();
  function Et(t) {
    return Et = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Et(t);
  }
  var It = {};
  function Lt() {
    $.searchAnimations();
  }
  It.play = $.play, It.pause = $.pause, It.setLocationHref = function (e) {
    t = e;
  }, It.togglePause = $.togglePause, It.setSpeed = $.setSpeed, It.setDirection = $.setDirection, It.stop = $.stop, It.searchAnimations = Lt, It.registerAnimation = $.registerAnimation, It.loadAnimation = function (t) {
    return $.loadAnimation(t);
  }, It.setSubframeRendering = function (t) {
    !function (t) {
      f = !!t;
    }(t);
  }, It.resize = $.resize, It.goToAndStop = $.goToAndStop, It.destroy = $.destroy, It.setQuality = function (t) {
    if ("string" == typeof t) switch (t) {
      case "high":
        q(200);
        break;
      default:
      case "medium":
        q(50);
        break;
      case "low":
        q(10);
    } else !isNaN(t) && t > 1 && q(t);
    j() >= 50 ? S(!1) : S(!0);
  }, It.inBrowser = function () {
    return "undefined" != typeof navigator;
  }, It.installPlugin = function (t, e) {
    "expressions" === t && (d = e);
  }, It.freeze = $.freeze, It.unfreeze = $.unfreeze, It.setVolume = $.setVolume, It.mute = $.mute, It.unmute = $.unmute, It.getRegisteredAnimations = $.getRegisteredAnimations, It.useWebWorker = function (t) {
    e = !!t;
  }, It.setIDPrefix = function (t) {
    c = t;
  }, It.__getFactory = function (t) {
    switch (t) {
      case "propertyFactory":
        return vt;
      case "shapePropertyFactory":
        return Tt;
      case "matrix":
        return Ft;
      default:
        return null;
    }
  }, It.version = "5.12.2";
  var Vt = "",
    Rt = document.getElementsByTagName("script"),
    zt = Rt[Rt.length - 1] || {
      src: ""
    };
  Vt = zt.src ? zt.src.replace(/^[^\?]+\??/, "") : "", function (t) {
    for (var e = Vt.split("&"), i = 0; i < e.length; i += 1) {
      var s = e[i].split("=");
      if (decodeURIComponent(s[0]) == t) return decodeURIComponent(s[1]);
    }
  }("renderer");
  var Ot = setInterval(function () {
    "complete" === document.readyState && (clearInterval(Ot), Lt());
  }, 100);
  try {
    "object" === Et(exports) && true || false || (window.bodymovin = It);
  } catch (t) {}
  var Nt = function () {
    var t = {},
      e = {};
    return t.registerModifier = function (t, i) {
      e[t] || (e[t] = i);
    }, t.getModifier = function (t, i, s) {
      return new e[t](i, s);
    }, t;
  }();
  function Bt() {}
  function qt() {}
  function jt() {}
  Bt.prototype.initModifierProperties = function () {}, Bt.prototype.addShapeToModifier = function () {}, Bt.prototype.addShape = function (t) {
    if (!(this || _global).closed) {
      t.sh.container.addDynamicProperty(t.sh);
      var e = {
        shape: t.sh,
        data: t,
        localShapeCollection: Mt.newShapeCollection()
      };
      (this || _global).shapes.push(e), this.addShapeToModifier(e), (this || _global)._isAnimated && t.setAsAnimated();
    }
  }, Bt.prototype.init = function (t, e) {
    (this || _global).shapes = [], (this || _global).elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), (this || _global).frameId = i, (this || _global).closed = !1, (this || _global).k = !1, (this || _global).dynamicProperties.length ? (this || _global).k = !0 : this.getValue(!0);
  }, Bt.prototype.processKeys = function () {
    (this || _global).elem.globalData.frameId !== (this || _global).frameId && ((this || _global).frameId = (this || _global).elem.globalData.frameId, this.iterateDynamicProperties());
  }, r([bt], Bt), r([Bt], qt), qt.prototype.initModifierProperties = function (t, e) {
    (this || _global).s = vt.getProp(t, e.s, 0, 0.01, this || _global), (this || _global).e = vt.getProp(t, e.e, 0, 0.01, this || _global), (this || _global).o = vt.getProp(t, e.o, 0, 0, this || _global), (this || _global).sValue = 0, (this || _global).eValue = 0, (this || _global).getValue = (this || _global).processKeys, (this || _global).m = e.m, (this || _global)._isAnimated = !!(this || _global).s.effectsSequence.length || !!(this || _global).e.effectsSequence.length || !!(this || _global).o.effectsSequence.length;
  }, qt.prototype.addShapeToModifier = function (t) {
    t.pathsData = [];
  }, qt.prototype.calculateShapeEdges = function (t, e, i, s, a) {
    var r = [];
    e <= 1 ? r.push({
      s: t,
      e: e
    }) : t >= 1 ? r.push({
      s: t - 1,
      e: e - 1
    }) : (r.push({
      s: t,
      e: 1
    }), r.push({
      s: 0,
      e: e - 1
    }));
    var n,
      o,
      h = [],
      l = r.length;
    for (n = 0; n < l; n += 1) {
      var p, f;
      if (!((o = r[n]).e * a < s || o.s * a > s + i)) p = o.s * a <= s ? 0 : (o.s * a - s) / i, f = o.e * a >= s + i ? 1 : (o.e * a - s) / i, h.push([p, f]);
    }
    return h.length || h.push([0, 0]), h;
  }, qt.prototype.releasePathsData = function (t) {
    var e,
      i = t.length;
    for (e = 0; e < i; e += 1) at.release(t[e]);
    return t.length = 0, t;
  }, qt.prototype.processShapes = function (t) {
    var e, i, s, a;
    if ((this || _global)._mdf || t) {
      var r = (this || _global).o.v % 360 / 360;
      if (r < 0 && (r += 1), (e = (this || _global).s.v > 1 ? 1 + r : (this || _global).s.v < 0 ? 0 + r : (this || _global).s.v + r) > (i = (this || _global).e.v > 1 ? 1 + r : (this || _global).e.v < 0 ? 0 + r : (this || _global).e.v + r)) {
        var n = e;
        e = i, i = n;
      }
      e = 0.0001 * Math.round(10000 * e), i = 0.0001 * Math.round(10000 * i), (this || _global).sValue = e, (this || _global).eValue = i;
    } else e = (this || _global).sValue, i = (this || _global).eValue;
    var o,
      h,
      l,
      p,
      f,
      d = (this || _global).shapes.length,
      m = 0;
    if (i === e) for (a = 0; a < d; a += 1) (this || _global).shapes[a].localShapeCollection.releaseShapes(), (this || _global).shapes[a].shape._mdf = !0, (this || _global).shapes[a].shape.paths = (this || _global).shapes[a].localShapeCollection, (this || _global)._mdf && ((this || _global).shapes[a].pathsData.length = 0);else if (1 === i && 0 === e || 0 === i && 1 === e) {
      if ((this || _global)._mdf) for (a = 0; a < d; a += 1) (this || _global).shapes[a].pathsData.length = 0, (this || _global).shapes[a].shape._mdf = !0;
    } else {
      var c,
        u,
        g = [];
      for (a = 0; a < d; a += 1) if ((c = (this || _global).shapes[a]).shape._mdf || (this || _global)._mdf || t || 2 === (this || _global).m) {
        if (h = (s = c.shape.paths)._length, f = 0, !c.shape._mdf && c.pathsData.length) f = c.totalShapeLength;else {
          for (l = this.releasePathsData(c.pathsData), o = 0; o < h; o += 1) p = rt.getSegmentsLength(s.shapes[o]), l.push(p), f += p.totalLength;
          c.totalShapeLength = f, c.pathsData = l;
        }
        m += f, c.shape._mdf = !0;
      } else c.shape.paths = c.localShapeCollection;
      var y,
        v = e,
        b = i,
        _ = 0;
      for (a = d - 1; a >= 0; a -= 1) if ((c = (this || _global).shapes[a]).shape._mdf) {
        for ((u = c.localShapeCollection).releaseShapes(), 2 === (this || _global).m && d > 1 ? (y = this.calculateShapeEdges(e, i, c.totalShapeLength, _, m), _ += c.totalShapeLength) : y = [[v, b]], h = y.length, o = 0; o < h; o += 1) {
          v = y[o][0], b = y[o][1], g.length = 0, b <= 1 ? g.push({
            s: c.totalShapeLength * v,
            e: c.totalShapeLength * b
          }) : v >= 1 ? g.push({
            s: c.totalShapeLength * (v - 1),
            e: c.totalShapeLength * (b - 1)
          }) : (g.push({
            s: c.totalShapeLength * v,
            e: c.totalShapeLength
          }), g.push({
            s: 0,
            e: c.totalShapeLength * (b - 1)
          }));
          var k = this.addShapes(c, g[0]);
          if (g[0].s !== g[0].e) {
            if (g.length > 1) if (c.shape.paths.shapes[c.shape.paths._length - 1].c) {
              var P = k.pop();
              this.addPaths(k, u), k = this.addShapes(c, g[1], P);
            } else this.addPaths(k, u), k = this.addShapes(c, g[1]);
            this.addPaths(k, u);
          }
        }
        c.shape.paths = u;
      }
    }
  }, qt.prototype.addPaths = function (t, e) {
    var i,
      s = t.length;
    for (i = 0; i < s; i += 1) e.addShape(t[i]);
  }, qt.prototype.addSegment = function (t, e, i, s, a, r, n) {
    a.setXYAt(e[0], e[1], "o", r), a.setXYAt(i[0], i[1], "i", r + 1), n && a.setXYAt(t[0], t[1], "v", r), a.setXYAt(s[0], s[1], "v", r + 1);
  }, qt.prototype.addSegmentFromArray = function (t, e, i, s) {
    e.setXYAt(t[1], t[5], "o", i), e.setXYAt(t[2], t[6], "i", i + 1), s && e.setXYAt(t[0], t[4], "v", i), e.setXYAt(t[3], t[7], "v", i + 1);
  }, qt.prototype.addShapes = function (t, e, i) {
    var s,
      a,
      r,
      n,
      o,
      h,
      l,
      p,
      f = t.pathsData,
      d = t.shape.paths.shapes,
      m = t.shape.paths._length,
      c = 0,
      u = [],
      g = !0;
    for (i ? (o = i._length, p = i._length) : (i = At.newElement(), o = 0, p = 0), u.push(i), s = 0; s < m; s += 1) {
      for (h = f[s].lengths, i.c = d[s].c, r = d[s].c ? h.length : h.length + 1, a = 1; a < r; a += 1) if (c + (n = h[a - 1]).addedLength < e.s) c += n.addedLength, i.c = !1;else {
        if (c > e.e) {
          i.c = !1;
          break;
        }
        e.s <= c && e.e >= c + n.addedLength ? (this.addSegment(d[s].v[a - 1], d[s].o[a - 1], d[s].i[a], d[s].v[a], i, o, g), g = !1) : (l = rt.getNewSegment(d[s].v[a - 1], d[s].v[a], d[s].o[a - 1], d[s].i[a], (e.s - c) / n.addedLength, (e.e - c) / n.addedLength, h[a - 1]), this.addSegmentFromArray(l, i, o, g), g = !1, i.c = !1), c += n.addedLength, o += 1;
      }
      if (d[s].c && h.length) {
        if (n = h[a - 1], c <= e.e) {
          var y = h[a - 1].addedLength;
          e.s <= c && e.e >= c + y ? (this.addSegment(d[s].v[a - 1], d[s].o[a - 1], d[s].i[0], d[s].v[0], i, o, g), g = !1) : (l = rt.getNewSegment(d[s].v[a - 1], d[s].v[0], d[s].o[a - 1], d[s].i[0], (e.s - c) / y, (e.e - c) / y, h[a - 1]), this.addSegmentFromArray(l, i, o, g), g = !1, i.c = !1);
        } else i.c = !1;
        c += n.addedLength, o += 1;
      }
      if (i._length && (i.setXYAt(i.v[p][0], i.v[p][1], "i", p), i.setXYAt(i.v[i._length - 1][0], i.v[i._length - 1][1], "o", i._length - 1)), c > e.e) break;
      s < m - 1 && (i = At.newElement(), g = !0, u.push(i), o = 0);
    }
    return u;
  }, r([Bt], jt), jt.prototype.initModifierProperties = function (t, e) {
    (this || _global).getValue = (this || _global).processKeys, (this || _global).amount = vt.getProp(t, e.a, 0, null, this || _global), (this || _global)._isAnimated = !!(this || _global).amount.effectsSequence.length;
  }, jt.prototype.processPath = function (t, e) {
    var i = e / 100,
      s = [0, 0],
      a = t._length,
      r = 0;
    for (r = 0; r < a; r += 1) s[0] += t.v[r][0], s[1] += t.v[r][1];
    s[0] /= a, s[1] /= a;
    var n,
      o,
      h,
      l,
      p,
      f,
      d = At.newElement();
    for (d.c = t.c, r = 0; r < a; r += 1) n = t.v[r][0] + (s[0] - t.v[r][0]) * i, o = t.v[r][1] + (s[1] - t.v[r][1]) * i, h = t.o[r][0] + (s[0] - t.o[r][0]) * -i, l = t.o[r][1] + (s[1] - t.o[r][1]) * -i, p = t.i[r][0] + (s[0] - t.i[r][0]) * -i, f = t.i[r][1] + (s[1] - t.i[r][1]) * -i, d.setTripleAt(n, o, h, l, p, f, r);
    return d;
  }, jt.prototype.processShapes = function (t) {
    var e,
      i,
      s,
      a,
      r,
      n,
      o = (this || _global).shapes.length,
      h = (this || _global).amount.v;
    if (0 !== h) for (i = 0; i < o; i += 1) {
      if (n = (r = (this || _global).shapes[i]).localShapeCollection, r.shape._mdf || (this || _global)._mdf || t) for (n.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, a = r.shape.paths._length, s = 0; s < a; s += 1) n.addShape(this.processPath(e[s], h));
      r.shape.paths = r.localShapeCollection;
    }
    (this || _global).dynamicProperties.length || ((this || _global)._mdf = !1);
  };
  var Wt = function () {
    var t = [0, 0];
    function e(t, e, i) {
      if ((this || _global).elem = t, (this || _global).frameId = -1, (this || _global).propType = "transform", (this || _global).data = e, (this || _global).v = new Ft(), (this || _global).pre = new Ft(), (this || _global).appliedTransformations = 0, this.initDynamicPropertyContainer(i || t), e.p && e.p.s ? ((this || _global).px = vt.getProp(t, e.p.x, 0, 0, this || _global), (this || _global).py = vt.getProp(t, e.p.y, 0, 0, this || _global), e.p.z && ((this || _global).pz = vt.getProp(t, e.p.z, 0, 0, this || _global))) : (this || _global).p = vt.getProp(t, e.p || {
        k: [0, 0, 0]
      }, 1, 0, this || _global), e.rx) {
        if ((this || _global).rx = vt.getProp(t, e.rx, 0, P, this || _global), (this || _global).ry = vt.getProp(t, e.ry, 0, P, this || _global), (this || _global).rz = vt.getProp(t, e.rz, 0, P, this || _global), e.or.k[0].ti) {
          var s,
            a = e.or.k.length;
          for (s = 0; s < a; s += 1) e.or.k[s].to = null, e.or.k[s].ti = null;
        }
        (this || _global).or = vt.getProp(t, e.or, 1, P, this || _global), (this || _global).or.sh = !0;
      } else (this || _global).r = vt.getProp(t, e.r || {
        k: 0
      }, 0, P, this || _global);
      e.sk && ((this || _global).sk = vt.getProp(t, e.sk, 0, P, this || _global), (this || _global).sa = vt.getProp(t, e.sa, 0, P, this || _global)), (this || _global).a = vt.getProp(t, e.a || {
        k: [0, 0, 0]
      }, 1, 0, this || _global), (this || _global).s = vt.getProp(t, e.s || {
        k: [100, 100, 100]
      }, 1, 0.01, this || _global), e.o ? (this || _global).o = vt.getProp(t, e.o, 0, 0.01, t) : (this || _global).o = {
        _mdf: !1,
        v: 1
      }, (this || _global)._isDirty = !0, (this || _global).dynamicProperties.length || this.getValue(!0);
    }
    return e.prototype = {
      applyToMatrix: function (t) {
        var e = (this || _global)._mdf;
        this.iterateDynamicProperties(), (this || _global)._mdf = (this || _global)._mdf || e, (this || _global).a && t.translate(-(this || _global).a.v[0], -(this || _global).a.v[1], (this || _global).a.v[2]), (this || _global).s && t.scale((this || _global).s.v[0], (this || _global).s.v[1], (this || _global).s.v[2]), (this || _global).sk && t.skewFromAxis(-(this || _global).sk.v, (this || _global).sa.v), (this || _global).r ? t.rotate(-(this || _global).r.v) : t.rotateZ(-(this || _global).rz.v).rotateY((this || _global).ry.v).rotateX((this || _global).rx.v).rotateZ(-(this || _global).or.v[2]).rotateY((this || _global).or.v[1]).rotateX((this || _global).or.v[0]), (this || _global).data.p.s ? (this || _global).data.p.z ? t.translate((this || _global).px.v, (this || _global).py.v, -(this || _global).pz.v) : t.translate((this || _global).px.v, (this || _global).py.v, 0) : t.translate((this || _global).p.v[0], (this || _global).p.v[1], -(this || _global).p.v[2]);
      },
      getValue: function (e) {
        if ((this || _global).elem.globalData.frameId !== (this || _global).frameId) {
          if ((this || _global)._isDirty && (this.precalculateMatrix(), (this || _global)._isDirty = !1), this.iterateDynamicProperties(), (this || _global)._mdf || e) {
            var i;
            if ((this || _global).v.cloneFromProps((this || _global).pre.props), (this || _global).appliedTransformations < 1 && (this || _global).v.translate(-(this || _global).a.v[0], -(this || _global).a.v[1], (this || _global).a.v[2]), (this || _global).appliedTransformations < 2 && (this || _global).v.scale((this || _global).s.v[0], (this || _global).s.v[1], (this || _global).s.v[2]), (this || _global).sk && (this || _global).appliedTransformations < 3 && (this || _global).v.skewFromAxis(-(this || _global).sk.v, (this || _global).sa.v), (this || _global).r && (this || _global).appliedTransformations < 4 ? (this || _global).v.rotate(-(this || _global).r.v) : !(this || _global).r && (this || _global).appliedTransformations < 4 && (this || _global).v.rotateZ(-(this || _global).rz.v).rotateY((this || _global).ry.v).rotateX((this || _global).rx.v).rotateZ(-(this || _global).or.v[2]).rotateY((this || _global).or.v[1]).rotateX((this || _global).or.v[0]), (this || _global).autoOriented) {
              var s, a;
              if (i = (this || _global).elem.globalData.frameRate, (this || _global).p && (this || _global).p.keyframes && (this || _global).p.getValueAtTime) (this || _global).p._caching.lastFrame + (this || _global).p.offsetTime <= (this || _global).p.keyframes[0].t ? (s = (this || _global).p.getValueAtTime(((this || _global).p.keyframes[0].t + 0.01) / i, 0), a = (this || _global).p.getValueAtTime((this || _global).p.keyframes[0].t / i, 0)) : (this || _global).p._caching.lastFrame + (this || _global).p.offsetTime >= (this || _global).p.keyframes[(this || _global).p.keyframes.length - 1].t ? (s = (this || _global).p.getValueAtTime((this || _global).p.keyframes[(this || _global).p.keyframes.length - 1].t / i, 0), a = (this || _global).p.getValueAtTime(((this || _global).p.keyframes[(this || _global).p.keyframes.length - 1].t - 0.05) / i, 0)) : (s = (this || _global).p.pv, a = (this || _global).p.getValueAtTime(((this || _global).p._caching.lastFrame + (this || _global).p.offsetTime - 0.01) / i, (this || _global).p.offsetTime));else if ((this || _global).px && (this || _global).px.keyframes && (this || _global).py.keyframes && (this || _global).px.getValueAtTime && (this || _global).py.getValueAtTime) {
                s = [], a = [];
                var r = (this || _global).px,
                  n = (this || _global).py;
                r._caching.lastFrame + r.offsetTime <= r.keyframes[0].t ? (s[0] = r.getValueAtTime((r.keyframes[0].t + 0.01) / i, 0), s[1] = n.getValueAtTime((n.keyframes[0].t + 0.01) / i, 0), a[0] = r.getValueAtTime(r.keyframes[0].t / i, 0), a[1] = n.getValueAtTime(n.keyframes[0].t / i, 0)) : r._caching.lastFrame + r.offsetTime >= r.keyframes[r.keyframes.length - 1].t ? (s[0] = r.getValueAtTime(r.keyframes[r.keyframes.length - 1].t / i, 0), s[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / i, 0), a[0] = r.getValueAtTime((r.keyframes[r.keyframes.length - 1].t - 0.01) / i, 0), a[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - 0.01) / i, 0)) : (s = [r.pv, n.pv], a[0] = r.getValueAtTime((r._caching.lastFrame + r.offsetTime - 0.01) / i, r.offsetTime), a[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - 0.01) / i, n.offsetTime));
              } else s = a = t;
              (this || _global).v.rotate(-Math.atan2(s[1] - a[1], s[0] - a[0]));
            }
            (this || _global).data.p && (this || _global).data.p.s ? (this || _global).data.p.z ? (this || _global).v.translate((this || _global).px.v, (this || _global).py.v, -(this || _global).pz.v) : (this || _global).v.translate((this || _global).px.v, (this || _global).py.v, 0) : (this || _global).v.translate((this || _global).p.v[0], (this || _global).p.v[1], -(this || _global).p.v[2]);
          }
          (this || _global).frameId = (this || _global).elem.globalData.frameId;
        }
      },
      precalculateMatrix: function () {
        if ((this || _global).appliedTransformations = 0, (this || _global).pre.reset(), !(this || _global).a.effectsSequence.length && ((this || _global).pre.translate(-(this || _global).a.v[0], -(this || _global).a.v[1], (this || _global).a.v[2]), (this || _global).appliedTransformations = 1, !(this || _global).s.effectsSequence.length)) {
          if ((this || _global).pre.scale((this || _global).s.v[0], (this || _global).s.v[1], (this || _global).s.v[2]), (this || _global).appliedTransformations = 2, (this || _global).sk) {
            if ((this || _global).sk.effectsSequence.length || (this || _global).sa.effectsSequence.length) return;
            (this || _global).pre.skewFromAxis(-(this || _global).sk.v, (this || _global).sa.v), (this || _global).appliedTransformations = 3;
          }
          (this || _global).r ? (this || _global).r.effectsSequence.length || ((this || _global).pre.rotate(-(this || _global).r.v), (this || _global).appliedTransformations = 4) : (this || _global).rz.effectsSequence.length || (this || _global).ry.effectsSequence.length || (this || _global).rx.effectsSequence.length || (this || _global).or.effectsSequence.length || ((this || _global).pre.rotateZ(-(this || _global).rz.v).rotateY((this || _global).ry.v).rotateX((this || _global).rx.v).rotateZ(-(this || _global).or.v[2]).rotateY((this || _global).or.v[1]).rotateX((this || _global).or.v[0]), (this || _global).appliedTransformations = 4);
        }
      },
      autoOrient: function () {}
    }, r([bt], e), e.prototype.addDynamicProperty = function (t) {
      this._addDynamicProperty(t), (this || _global).elem.addDynamicProperty(t), (this || _global)._isDirty = !0;
    }, e.prototype._addDynamicProperty = bt.prototype.addDynamicProperty, {
      getTransformProperty: function (t, i, s) {
        return new e(t, i, s);
      }
    };
  }();
  function Xt() {}
  function Ht() {}
  function Yt(t, e) {
    return 100000 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
  }
  function Gt(t) {
    return Math.abs(t) <= 0.00001;
  }
  function Kt(t, e, i) {
    return t * (1 - i) + e * i;
  }
  function Jt(t, e, i) {
    return [Kt(t[0], e[0], i), Kt(t[1], e[1], i)];
  }
  function Ut(t, e, i, s) {
    return [3 * e - t - 3 * i + s, 3 * t - 6 * e + 3 * i, -3 * t + 3 * e, t];
  }
  function Zt(t) {
    return new Qt(t, t, t, t, !1);
  }
  function Qt(t, e, i, s, a) {
    a && oe(t, e) && (e = Jt(t, s, 1 / 3)), a && oe(i, s) && (i = Jt(t, s, 2 / 3));
    var r = Ut(t[0], e[0], i[0], s[0]),
      n = Ut(t[1], e[1], i[1], s[1]);
    (this || _global).a = [r[0], n[0]], (this || _global).b = [r[1], n[1]], (this || _global).c = [r[2], n[2]], (this || _global).d = [r[3], n[3]], (this || _global).points = [t, e, i, s];
  }
  function $t(t, e) {
    var i = t.points[0][e],
      s = t.points[t.points.length - 1][e];
    if (i > s) {
      var a = s;
      s = i, i = a;
    }
    for (var r = function (t, e, i) {
        if (0 === t) return [];
        var s = e * e - 4 * t * i;
        if (s < 0) return [];
        var a = -e / (2 * t);
        if (0 === s) return [a];
        var r = Math.sqrt(s) / (2 * t);
        return [a - r, a + r];
      }(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < r.length; n += 1) if (r[n] > 0 && r[n] < 1) {
      var o = t.point(r[n])[e];
      o < i ? i = o : o > s && (s = o);
    }
    return {
      min: i,
      max: s
    };
  }
  function te(t, e, i) {
    var s = t.boundingBox();
    return {
      cx: s.cx,
      cy: s.cy,
      width: s.width,
      height: s.height,
      bez: t,
      t: (e + i) / 2,
      t1: e,
      t2: i
    };
  }
  function ee(t) {
    var e = t.bez.split(0.5);
    return [te(e[0], t.t1, t.t), te(e[1], t.t, t.t2)];
  }
  function ie(t, e, i, s, a, r) {
    var n, o;
    if (n = t, o = e, 2 * Math.abs(n.cx - o.cx) < n.width + o.width && 2 * Math.abs(n.cy - o.cy) < n.height + o.height) if (i >= r || t.width <= s && t.height <= s && e.width <= s && e.height <= s) a.push([t.t, e.t]);else {
      var h = ee(t),
        l = ee(e);
      ie(h[0], l[0], i + 1, s, a, r), ie(h[0], l[1], i + 1, s, a, r), ie(h[1], l[0], i + 1, s, a, r), ie(h[1], l[1], i + 1, s, a, r);
    }
  }
  function se(t, e) {
    return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
  }
  function ae(t, e, i, s) {
    var a = [t[0], t[1], 1],
      r = [e[0], e[1], 1],
      n = [i[0], i[1], 1],
      o = [s[0], s[1], 1],
      h = se(se(a, r), se(n, o));
    return Gt(h[2]) ? null : [h[0] / h[2], h[1] / h[2]];
  }
  function re(t, e, i) {
    return [t[0] + Math.cos(e) * i, t[1] - Math.sin(e) * i];
  }
  function ne(t, e) {
    return Math.hypot(t[0] - e[0], t[1] - e[1]);
  }
  function oe(t, e) {
    return Yt(t[0], e[0]) && Yt(t[1], e[1]);
  }
  function he() {}
  function le(t, e, i, s, a, r, n) {
    var o = i - Math.PI / 2,
      h = i + Math.PI / 2,
      l = e[0] + Math.cos(i) * s * a,
      p = e[1] - Math.sin(i) * s * a;
    t.setTripleAt(l, p, l + Math.cos(o) * r, p - Math.sin(o) * r, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
  }
  function pe(t, e) {
    var i,
      s,
      a,
      r,
      n = 0 === e ? t.length() - 1 : e - 1,
      o = (e + 1) % t.length(),
      h = t.v[n],
      l = t.v[o],
      p = (i = h, a = [(s = l)[0] - i[0], s[1] - i[1]], r = 0.5 * -Math.PI, [Math.cos(r) * a[0] - Math.sin(r) * a[1], Math.sin(r) * a[0] + Math.cos(r) * a[1]]);
    return Math.atan2(0, 1) - Math.atan2(p[1], p[0]);
  }
  function fe(t, e, i, s, a, r, n) {
    var o = pe(e, i),
      h = e.v[i % e._length],
      l = e.v[0 === i ? e._length - 1 : i - 1],
      p = e.v[(i + 1) % e._length],
      f = 2 === r ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0,
      d = 2 === r ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
    le(t, e.v[i % e._length], o, n, s, d / (2 * (a + 1)), f / (2 * (a + 1)));
  }
  function de(t, e, i, s, a, r) {
    for (var n = 0; n < s; n += 1) {
      var o = (n + 1) / (s + 1),
        h = 2 === a ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0,
        l = e.normalAngle(o);
      le(t, e.point(o), l, r, i, h / (2 * (s + 1)), h / (2 * (s + 1))), r = -r;
    }
    return r;
  }
  function me(t, e, i) {
    var s = Math.atan2(e[0] - t[0], e[1] - t[1]);
    return [re(t, s, i), re(e, s, i)];
  }
  function ce(t, e) {
    var i, s, a, r, n, o, h;
    i = (h = me(t.points[0], t.points[1], e))[0], s = h[1], a = (h = me(t.points[1], t.points[2], e))[0], r = h[1], n = (h = me(t.points[2], t.points[3], e))[0], o = h[1];
    var l = ae(i, s, a, r);
    null === l && (l = s);
    var p = ae(n, o, a, r);
    return null === p && (p = n), new Qt(i, l, p, o);
  }
  function ue(t, e, i, s, a) {
    var r = e.points[3],
      n = i.points[0];
    if (3 === s) return r;
    if (oe(r, n)) return r;
    if (2 === s) {
      var o = -e.tangentAngle(1),
        h = -i.tangentAngle(0) + Math.PI,
        l = ae(r, re(r, o + Math.PI / 2, 100), n, re(n, o + Math.PI / 2, 100)),
        p = l ? ne(l, r) : ne(r, n) / 2,
        f = re(r, o, 2 * p * A);
      return t.setXYAt(f[0], f[1], "o", t.length() - 1), f = re(n, h, 2 * p * A), t.setTripleAt(n[0], n[1], n[0], n[1], f[0], f[1], t.length()), n;
    }
    var d = ae(oe(r, e.points[2]) ? e.points[0] : e.points[2], r, n, oe(n, i.points[1]) ? i.points[3] : i.points[1]);
    return d && ne(d, r) < a ? (t.setTripleAt(d[0], d[1], d[0], d[1], d[0], d[1], t.length()), d) : r;
  }
  function ge(t, e) {
    var i = t.intersections(e);
    return i.length && Yt(i[0][0], 1) && i.shift(), i.length ? i[0] : null;
  }
  function ye(t, e) {
    var i = t.slice(),
      s = e.slice(),
      a = ge(t[t.length - 1], e[0]);
    return a && (i[t.length - 1] = t[t.length - 1].split(a[0])[0], s[0] = e[0].split(a[1])[1]), t.length > 1 && e.length > 1 && (a = ge(t[0], e[e.length - 1])) ? [[t[0].split(a[0])[0]], [e[e.length - 1].split(a[1])[1]]] : [i, s];
  }
  function ve(t, e) {
    var i,
      s,
      a,
      r,
      n = t.inflectionPoints();
    if (0 === n.length) return [ce(t, e)];
    if (1 === n.length || Yt(n[1], 1)) return i = (a = t.split(n[0]))[0], s = a[1], [ce(i, e), ce(s, e)];
    i = (a = t.split(n[0]))[0];
    var o = (n[1] - n[0]) / (1 - n[0]);
    return r = (a = a[1].split(o))[0], s = a[1], [ce(i, e), ce(r, e), ce(s, e)];
  }
  function be() {}
  function _e(t) {
    for (var e = t.fStyle ? t.fStyle.split(" ") : [], i = "normal", s = "normal", a = e.length, r = 0; r < a; r += 1) switch (e[r].toLowerCase()) {
      case "italic":
        s = "italic";
        break;
      case "bold":
        i = "700";
        break;
      case "black":
        i = "900";
        break;
      case "medium":
        i = "500";
        break;
      case "regular":
      case "normal":
        i = "400";
        break;
      case "light":
      case "thin":
        i = "200";
    }
    return {
      style: s,
      weight: t.fWeight || i
    };
  }
  r([Bt], Xt), Xt.prototype.initModifierProperties = function (t, e) {
    (this || _global).getValue = (this || _global).processKeys, (this || _global).c = vt.getProp(t, e.c, 0, null, this || _global), (this || _global).o = vt.getProp(t, e.o, 0, null, this || _global), (this || _global).tr = Wt.getTransformProperty(t, e.tr, this || _global), (this || _global).so = vt.getProp(t, e.tr.so, 0, 0.01, this || _global), (this || _global).eo = vt.getProp(t, e.tr.eo, 0, 0.01, this || _global), (this || _global).data = e, (this || _global).dynamicProperties.length || this.getValue(!0), (this || _global)._isAnimated = !!(this || _global).dynamicProperties.length, (this || _global).pMatrix = new Ft(), (this || _global).rMatrix = new Ft(), (this || _global).sMatrix = new Ft(), (this || _global).tMatrix = new Ft(), (this || _global).matrix = new Ft();
  }, Xt.prototype.applyTransforms = function (t, e, i, s, a, r) {
    var n = r ? -1 : 1,
      o = s.s.v[0] + (1 - s.s.v[0]) * (1 - a),
      h = s.s.v[1] + (1 - s.s.v[1]) * (1 - a);
    t.translate(s.p.v[0] * n * a, s.p.v[1] * n * a, s.p.v[2]), e.translate(-s.a.v[0], -s.a.v[1], s.a.v[2]), e.rotate(-s.r.v * n * a), e.translate(s.a.v[0], s.a.v[1], s.a.v[2]), i.translate(-s.a.v[0], -s.a.v[1], s.a.v[2]), i.scale(r ? 1 / o : o, r ? 1 / h : h), i.translate(s.a.v[0], s.a.v[1], s.a.v[2]);
  }, Xt.prototype.init = function (t, e, i, s) {
    for ((this || _global).elem = t, (this || _global).arr = e, (this || _global).pos = i, (this || _global).elemsData = s, (this || _global)._currentCopies = 0, (this || _global)._elements = [], (this || _global)._groups = [], (this || _global).frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[i]); i > 0;) i -= 1, (this || _global)._elements.unshift(e[i]);
    (this || _global).dynamicProperties.length ? (this || _global).k = !0 : this.getValue(!0);
  }, Xt.prototype.resetElements = function (t) {
    var e,
      i = t.length;
    for (e = 0; e < i; e += 1) t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
  }, Xt.prototype.cloneElements = function (t) {
    var e = JSON.parse(JSON.stringify(t));
    return this.resetElements(e), e;
  }, Xt.prototype.changeGroupRender = function (t, e) {
    var i,
      s = t.length;
    for (i = 0; i < s; i += 1) t[i]._render = e, "gr" === t[i].ty && this.changeGroupRender(t[i].it, e);
  }, Xt.prototype.processShapes = function (t) {
    var e,
      i,
      s,
      a,
      r,
      n = !1;
    if ((this || _global)._mdf || t) {
      var o,
        h = Math.ceil((this || _global).c.v);
      if ((this || _global)._groups.length < h) {
        for (; (this || _global)._groups.length < h;) {
          var l = {
            it: this.cloneElements((this || _global)._elements),
            ty: "gr"
          };
          l.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: "Transform",
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: "tr"
          }), (this || _global).arr.splice(0, 0, l), (this || _global)._groups.splice(0, 0, l), (this || _global)._currentCopies += 1;
        }
        (this || _global).elem.reloadShapes(), n = !0;
      }
      for (r = 0, s = 0; s <= (this || _global)._groups.length - 1; s += 1) {
        if (o = r < h, (this || _global)._groups[s]._render = o, this.changeGroupRender((this || _global)._groups[s].it, o), !o) {
          var p = (this || _global).elemsData[s].it,
            f = p[p.length - 1];
          0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
        }
        r += 1;
      }
      (this || _global)._currentCopies = h;
      var d = (this || _global).o.v,
        m = d % 1,
        c = d > 0 ? Math.floor(d) : Math.ceil(d),
        u = (this || _global).pMatrix.props,
        g = (this || _global).rMatrix.props,
        y = (this || _global).sMatrix.props;
      (this || _global).pMatrix.reset(), (this || _global).rMatrix.reset(), (this || _global).sMatrix.reset(), (this || _global).tMatrix.reset(), (this || _global).matrix.reset();
      var v,
        b,
        _ = 0;
      if (d > 0) {
        for (; _ < c;) this.applyTransforms((this || _global).pMatrix, (this || _global).rMatrix, (this || _global).sMatrix, (this || _global).tr, 1, !1), _ += 1;
        m && (this.applyTransforms((this || _global).pMatrix, (this || _global).rMatrix, (this || _global).sMatrix, (this || _global).tr, m, !1), _ += m);
      } else if (d < 0) {
        for (; _ > c;) this.applyTransforms((this || _global).pMatrix, (this || _global).rMatrix, (this || _global).sMatrix, (this || _global).tr, 1, !0), _ -= 1;
        m && (this.applyTransforms((this || _global).pMatrix, (this || _global).rMatrix, (this || _global).sMatrix, (this || _global).tr, -m, !0), _ -= m);
      }
      for (s = 1 === (this || _global).data.m ? 0 : (this || _global)._currentCopies - 1, a = 1 === (this || _global).data.m ? 1 : -1, r = (this || _global)._currentCopies; r;) {
        if (b = (i = (e = (this || _global).elemsData[s].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === (this || _global)._currentCopies ? (this || _global).so.v : (this || _global).so.v + ((this || _global).eo.v - (this || _global).so.v) * (s / ((this || _global)._currentCopies - 1)), 0 !== _) {
          for ((0 !== s && 1 === a || s !== (this || _global)._currentCopies - 1 && -1 === a) && this.applyTransforms((this || _global).pMatrix, (this || _global).rMatrix, (this || _global).sMatrix, (this || _global).tr, 1, !1), (this || _global).matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), (this || _global).matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), (this || _global).matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), v = 0; v < b; v += 1) i[v] = (this || _global).matrix.props[v];
          (this || _global).matrix.reset();
        } else for ((this || _global).matrix.reset(), v = 0; v < b; v += 1) i[v] = (this || _global).matrix.props[v];
        _ += 1, r -= 1, s += a;
      }
    } else for (r = (this || _global)._currentCopies, s = 0, a = 1; r;) i = (e = (this || _global).elemsData[s].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, r -= 1, s += a;
    return n;
  }, Xt.prototype.addShape = function () {}, r([Bt], Ht), Ht.prototype.initModifierProperties = function (t, e) {
    (this || _global).getValue = (this || _global).processKeys, (this || _global).rd = vt.getProp(t, e.r, 0, null, this || _global), (this || _global)._isAnimated = !!(this || _global).rd.effectsSequence.length;
  }, Ht.prototype.processPath = function (t, e) {
    var i,
      s = At.newElement();
    s.c = t.c;
    var a,
      r,
      n,
      o,
      h,
      l,
      p,
      f,
      d,
      m,
      c,
      u,
      g = t._length,
      y = 0;
    for (i = 0; i < g; i += 1) a = t.v[i], n = t.o[i], r = t.i[i], a[0] === n[0] && a[1] === n[1] && a[0] === r[0] && a[1] === r[1] ? 0 !== i && i !== g - 1 || t.c ? (o = 0 === i ? t.v[g - 1] : t.v[i - 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = c = a[0] + (o[0] - a[0]) * l, f = u = a[1] - (a[1] - o[1]) * l, d = p - (p - a[0]) * A, m = f - (f - a[1]) * A, s.setTripleAt(p, f, d, m, c, u, y), y += 1, o = i === g - 1 ? t.v[0] : t.v[i + 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = a[0] + (o[0] - a[0]) * l, f = m = a[1] + (o[1] - a[1]) * l, c = p - (p - a[0]) * A, u = f - (f - a[1]) * A, s.setTripleAt(p, f, d, m, c, u, y), y += 1) : (s.setTripleAt(a[0], a[1], n[0], n[1], r[0], r[1], y), y += 1) : (s.setTripleAt(t.v[i][0], t.v[i][1], t.o[i][0], t.o[i][1], t.i[i][0], t.i[i][1], y), y += 1);
    return s;
  }, Ht.prototype.processShapes = function (t) {
    var e,
      i,
      s,
      a,
      r,
      n,
      o = (this || _global).shapes.length,
      h = (this || _global).rd.v;
    if (0 !== h) for (i = 0; i < o; i += 1) {
      if (n = (r = (this || _global).shapes[i]).localShapeCollection, r.shape._mdf || (this || _global)._mdf || t) for (n.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, a = r.shape.paths._length, s = 0; s < a; s += 1) n.addShape(this.processPath(e[s], h));
      r.shape.paths = r.localShapeCollection;
    }
    (this || _global).dynamicProperties.length || ((this || _global)._mdf = !1);
  }, Qt.prototype.point = function (t) {
    return [(((this || _global).a[0] * t + (this || _global).b[0]) * t + (this || _global).c[0]) * t + (this || _global).d[0], (((this || _global).a[1] * t + (this || _global).b[1]) * t + (this || _global).c[1]) * t + (this || _global).d[1]];
  }, Qt.prototype.derivative = function (t) {
    return [(3 * t * (this || _global).a[0] + 2 * (this || _global).b[0]) * t + (this || _global).c[0], (3 * t * (this || _global).a[1] + 2 * (this || _global).b[1]) * t + (this || _global).c[1]];
  }, Qt.prototype.tangentAngle = function (t) {
    var e = this.derivative(t);
    return Math.atan2(e[1], e[0]);
  }, Qt.prototype.normalAngle = function (t) {
    var e = this.derivative(t);
    return Math.atan2(e[0], e[1]);
  }, Qt.prototype.inflectionPoints = function () {
    var t = (this || _global).a[1] * (this || _global).b[0] - (this || _global).a[0] * (this || _global).b[1];
    if (Gt(t)) return [];
    var e = -0.5 * ((this || _global).a[1] * (this || _global).c[0] - (this || _global).a[0] * (this || _global).c[1]) / t,
      i = e * e - 1 / 3 * ((this || _global).b[1] * (this || _global).c[0] - (this || _global).b[0] * (this || _global).c[1]) / t;
    if (i < 0) return [];
    var s = Math.sqrt(i);
    return Gt(s) ? s > 0 && s < 1 ? [e] : [] : [e - s, e + s].filter(function (t) {
      return t > 0 && t < 1;
    });
  }, Qt.prototype.split = function (t) {
    if (t <= 0) return [Zt((this || _global).points[0]), this || _global];
    if (t >= 1) return [this || _global, Zt((this || _global).points[(this || _global).points.length - 1])];
    var e = Jt((this || _global).points[0], (this || _global).points[1], t),
      i = Jt((this || _global).points[1], (this || _global).points[2], t),
      s = Jt((this || _global).points[2], (this || _global).points[3], t),
      a = Jt(e, i, t),
      r = Jt(i, s, t),
      n = Jt(a, r, t);
    return [new Qt((this || _global).points[0], e, a, n, !0), new Qt(n, r, s, (this || _global).points[3], !0)];
  }, Qt.prototype.bounds = function () {
    return {
      x: $t(this || _global, 0),
      y: $t(this || _global, 1)
    };
  }, Qt.prototype.boundingBox = function () {
    var t = this.bounds();
    return {
      left: t.x.min,
      right: t.x.max,
      top: t.y.min,
      bottom: t.y.max,
      width: t.x.max - t.x.min,
      height: t.y.max - t.y.min,
      cx: (t.x.max + t.x.min) / 2,
      cy: (t.y.max + t.y.min) / 2
    };
  }, Qt.prototype.intersections = function (t, e, i) {
    void 0 === e && (e = 2), void 0 === i && (i = 7);
    var s = [];
    return ie(te(this || _global, 0, 1), te(t, 0, 1), 0, e, s, i), s;
  }, Qt.shapeSegment = function (t, e) {
    var i = (e + 1) % t.length();
    return new Qt(t.v[e], t.o[e], t.i[i], t.v[i], !0);
  }, Qt.shapeSegmentInverted = function (t, e) {
    var i = (e + 1) % t.length();
    return new Qt(t.v[i], t.i[i], t.o[e], t.v[e], !0);
  }, r([Bt], he), he.prototype.initModifierProperties = function (t, e) {
    (this || _global).getValue = (this || _global).processKeys, (this || _global).amplitude = vt.getProp(t, e.s, 0, null, this || _global), (this || _global).frequency = vt.getProp(t, e.r, 0, null, this || _global), (this || _global).pointsType = vt.getProp(t, e.pt, 0, null, this || _global), (this || _global)._isAnimated = 0 !== (this || _global).amplitude.effectsSequence.length || 0 !== (this || _global).frequency.effectsSequence.length || 0 !== (this || _global).pointsType.effectsSequence.length;
  }, he.prototype.processPath = function (t, e, i, s) {
    var a = t._length,
      r = At.newElement();
    if (r.c = t.c, t.c || (a -= 1), 0 === a) return r;
    var n = -1,
      o = Qt.shapeSegment(t, 0);
    fe(r, t, 0, e, i, s, n);
    for (var h = 0; h < a; h += 1) n = de(r, o, e, i, s, -n), o = h !== a - 1 || t.c ? Qt.shapeSegment(t, (h + 1) % a) : null, fe(r, t, h + 1, e, i, s, n);
    return r;
  }, he.prototype.processShapes = function (t) {
    var e,
      i,
      s,
      a,
      r,
      n,
      o = (this || _global).shapes.length,
      h = (this || _global).amplitude.v,
      l = Math.max(0, Math.round((this || _global).frequency.v)),
      p = (this || _global).pointsType.v;
    if (0 !== h) for (i = 0; i < o; i += 1) {
      if (n = (r = (this || _global).shapes[i]).localShapeCollection, r.shape._mdf || (this || _global)._mdf || t) for (n.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, a = r.shape.paths._length, s = 0; s < a; s += 1) n.addShape(this.processPath(e[s], h, l, p));
      r.shape.paths = r.localShapeCollection;
    }
    (this || _global).dynamicProperties.length || ((this || _global)._mdf = !1);
  }, r([Bt], be), be.prototype.initModifierProperties = function (t, e) {
    (this || _global).getValue = (this || _global).processKeys, (this || _global).amount = vt.getProp(t, e.a, 0, null, this || _global), (this || _global).miterLimit = vt.getProp(t, e.ml, 0, null, this || _global), (this || _global).lineJoin = e.lj, (this || _global)._isAnimated = 0 !== (this || _global).amount.effectsSequence.length;
  }, be.prototype.processPath = function (t, e, i, s) {
    var a = At.newElement();
    a.c = t.c;
    var r,
      n,
      o,
      h = t.length();
    t.c || (h -= 1);
    var l = [];
    for (r = 0; r < h; r += 1) o = Qt.shapeSegment(t, r), l.push(ve(o, e));
    if (!t.c) for (r = h - 1; r >= 0; r -= 1) o = Qt.shapeSegmentInverted(t, r), l.push(ve(o, e));
    l = function (t) {
      for (var e, i = 1; i < t.length; i += 1) e = ye(t[i - 1], t[i]), t[i - 1] = e[0], t[i] = e[1];
      return t.length > 1 && (e = ye(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
    }(l);
    var p = null,
      f = null;
    for (r = 0; r < l.length; r += 1) {
      var d = l[r];
      for (f && (p = ue(a, f, d[0], i, s)), f = d[d.length - 1], n = 0; n < d.length; n += 1) o = d[n], p && oe(o.points[0], p) ? a.setXYAt(o.points[1][0], o.points[1][1], "o", a.length() - 1) : a.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], a.length()), a.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], a.length()), p = o.points[3];
    }
    return l.length && ue(a, f, l[0][0], i, s), a;
  }, be.prototype.processShapes = function (t) {
    var e,
      i,
      s,
      a,
      r,
      n,
      o = (this || _global).shapes.length,
      h = (this || _global).amount.v,
      l = (this || _global).miterLimit.v,
      p = (this || _global).lineJoin;
    if (0 !== h) for (i = 0; i < o; i += 1) {
      if (n = (r = (this || _global).shapes[i]).localShapeCollection, r.shape._mdf || (this || _global)._mdf || t) for (n.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, a = r.shape.paths._length, s = 0; s < a; s += 1) n.addShape(this.processPath(e[s], h, p, l));
      r.shape.paths = r.localShapeCollection;
    }
    (this || _global).dynamicProperties.length || ((this || _global)._mdf = !1);
  };
  var ke = function () {
    var t = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      },
      e = [];
    e = e.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
    var i = 127988,
      s = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
    function r(t, e) {
      var i = a("span");
      i.setAttribute("aria-hidden", !0), i.style.fontFamily = e;
      var s = a("span");
      s.innerText = "giItT1WQy@!-/#", i.style.position = "absolute", i.style.left = "-10000px", i.style.top = "-10000px", i.style.fontSize = "300px", i.style.fontVariant = "normal", i.style.fontStyle = "normal", i.style.fontWeight = "normal", i.style.letterSpacing = "0", i.appendChild(s), document.body.appendChild(i);
      var r = s.offsetWidth;
      return s.style.fontFamily = function (t) {
        var e,
          i = t.split(","),
          s = i.length,
          a = [];
        for (e = 0; e < s; e += 1) "sans-serif" !== i[e] && "monospace" !== i[e] && a.push(i[e]);
        return a.join(",");
      }(t) + ", " + e, {
        node: s,
        w: r,
        parent: i
      };
    }
    function n(t, e) {
      var i,
        s = document.body && e ? "svg" : "canvas",
        a = _e(t);
      if ("svg" === s) {
        var r = W("text");
        r.style.fontSize = "100px", r.setAttribute("font-family", t.fFamily), r.setAttribute("font-style", a.style), r.setAttribute("font-weight", a.weight), r.textContent = "1", t.fClass ? (r.style.fontFamily = "inherit", r.setAttribute("class", t.fClass)) : r.style.fontFamily = t.fFamily, e.appendChild(r), i = r;
      } else {
        var n = new OffscreenCanvas(500, 500).getContext("2d");
        n.font = a.style + " " + a.weight + " 100px " + t.fFamily, i = n;
      }
      return {
        measureText: function (t) {
          return "svg" === s ? (i.textContent = t, i.getComputedTextLength()) : i.measureText(t).width;
        }
      };
    }
    function o(t) {
      var e = 0,
        i = t.charCodeAt(0);
      if (i >= 55296 && i <= 56319) {
        var s = t.charCodeAt(1);
        s >= 56320 && s <= 57343 && (e = 1024 * (i - 55296) + s - 56320 + 65536);
      }
      return e;
    }
    function h(t) {
      var e = o(t);
      return e >= 127462 && e <= 127487;
    }
    var l = function () {
      (this || _global).fonts = [], (this || _global).chars = null, (this || _global).typekitLoaded = 0, (this || _global).isLoaded = !1, (this || _global)._warned = !1, (this || _global).initTime = Date.now(), (this || _global).setIsLoadedBinded = (this || _global).setIsLoaded.bind(this || _global), (this || _global).checkLoadedFontsBinded = (this || _global).checkLoadedFonts.bind(this || _global);
    };
    l.isModifier = function (t, e) {
      var i = t.toString(16) + e.toString(16);
      return -1 !== s.indexOf(i);
    }, l.isZeroWidthJoiner = function (t) {
      return 8205 === t;
    }, l.isFlagEmoji = function (t) {
      return h(t.substr(0, 2)) && h(t.substr(2, 2));
    }, l.isRegionalCode = h, l.isCombinedCharacter = function (t) {
      return -1 !== e.indexOf(t);
    }, l.isRegionalFlag = function (t, e) {
      var s = o(t.substr(e, 2));
      if (s !== i) return !1;
      var a = 0;
      for (e += 2; a < 5;) {
        if ((s = o(t.substr(e, 2))) < 917601 || s > 917626) return !1;
        a += 1, e += 2;
      }
      return 917631 === o(t.substr(e, 2));
    }, l.isVariationSelector = function (t) {
      return 65039 === t;
    }, l.BLACK_FLAG_CODE_POINT = i;
    var p = {
      addChars: function (t) {
        if (t) {
          var e;
          (this || _global).chars || ((this || _global).chars = []);
          var i,
            s,
            a = t.length,
            r = (this || _global).chars.length;
          for (e = 0; e < a; e += 1) {
            for (i = 0, s = !1; i < r;) (this || _global).chars[i].style === t[e].style && (this || _global).chars[i].fFamily === t[e].fFamily && (this || _global).chars[i].ch === t[e].ch && (s = !0), i += 1;
            s || ((this || _global).chars.push(t[e]), r += 1);
          }
        }
      },
      addFonts: function (t, e) {
        if (t) {
          if ((this || _global).chars) return (this || _global).isLoaded = !0, void ((this || _global).fonts = t.list);
          if (!document.body) return (this || _global).isLoaded = !0, t.list.forEach(function (t) {
            t.helper = n(t), t.cache = {};
          }), void ((this || _global).fonts = t.list);
          var i,
            s = t.list,
            o = s.length,
            h = o;
          for (i = 0; i < o; i += 1) {
            var l,
              p,
              f = !0;
            if (s[i].loaded = !1, s[i].monoCase = r(s[i].fFamily, "monospace"), s[i].sansCase = r(s[i].fFamily, "sans-serif"), s[i].fPath) {
              if ("p" === s[i].fOrigin || 3 === s[i].origin) {
                if ((l = document.querySelectorAll("style[f-forigin=\"p\"][f-family=\"" + s[i].fFamily + "\"], style[f-origin=\"3\"][f-family=\"" + s[i].fFamily + "\"]")).length > 0 && (f = !1), f) {
                  var d = a("style");
                  d.setAttribute("f-forigin", s[i].fOrigin), d.setAttribute("f-origin", s[i].origin), d.setAttribute("f-family", s[i].fFamily), d.type = "text/css", d.innerText = "@font-face {font-family: " + s[i].fFamily + "; font-style: normal; src: url('" + s[i].fPath + "');}", e.appendChild(d);
                }
              } else if ("g" === s[i].fOrigin || 1 === s[i].origin) {
                for (l = document.querySelectorAll("link[f-forigin=\"g\"], link[f-origin=\"1\"]"), p = 0; p < l.length; p += 1) -1 !== l[p].href.indexOf(s[i].fPath) && (f = !1);
                if (f) {
                  var m = a("link");
                  m.setAttribute("f-forigin", s[i].fOrigin), m.setAttribute("f-origin", s[i].origin), m.type = "text/css", m.rel = "stylesheet", m.href = s[i].fPath, document.body.appendChild(m);
                }
              } else if ("t" === s[i].fOrigin || 2 === s[i].origin) {
                for (l = document.querySelectorAll("script[f-forigin=\"t\"], script[f-origin=\"2\"]"), p = 0; p < l.length; p += 1) s[i].fPath === l[p].src && (f = !1);
                if (f) {
                  var c = a("link");
                  c.setAttribute("f-forigin", s[i].fOrigin), c.setAttribute("f-origin", s[i].origin), c.setAttribute("rel", "stylesheet"), c.setAttribute("href", s[i].fPath), e.appendChild(c);
                }
              }
            } else s[i].loaded = !0, h -= 1;
            s[i].helper = n(s[i], e), s[i].cache = {}, (this || _global).fonts.push(s[i]);
          }
          0 === h ? (this || _global).isLoaded = !0 : setTimeout((this || _global).checkLoadedFonts.bind(this || _global), 100);
        } else (this || _global).isLoaded = !0;
      },
      getCharData: function (e, i, s) {
        for (var a = 0, r = (this || _global).chars.length; a < r;) {
          if ((this || _global).chars[a].ch === e && (this || _global).chars[a].style === i && (this || _global).chars[a].fFamily === s) return (this || _global).chars[a];
          a += 1;
        }
        return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !(this || _global)._warned && ((this || _global)._warned = !0, console.warn("Missing character from exported characters list: ", e, i, s)), t;
      },
      getFontByName: function (t) {
        for (var e = 0, i = (this || _global).fonts.length; e < i;) {
          if ((this || _global).fonts[e].fName === t) return (this || _global).fonts[e];
          e += 1;
        }
        return (this || _global).fonts[0];
      },
      measureText: function (t, e, i) {
        var s = this.getFontByName(e),
          a = t;
        if (!s.cache[a]) {
          var r = s.helper;
          if (" " === t) {
            var n = r.measureText("|" + t + "|"),
              o = r.measureText("||");
            s.cache[a] = (n - o) / 100;
          } else s.cache[a] = r.measureText(t) / 100;
        }
        return s.cache[a] * i;
      },
      checkLoadedFonts: function () {
        var t,
          e,
          i,
          s = (this || _global).fonts.length,
          a = s;
        for (t = 0; t < s; t += 1) (this || _global).fonts[t].loaded ? a -= 1 : "n" === (this || _global).fonts[t].fOrigin || 0 === (this || _global).fonts[t].origin ? (this || _global).fonts[t].loaded = !0 : (e = (this || _global).fonts[t].monoCase.node, i = (this || _global).fonts[t].monoCase.w, e.offsetWidth !== i ? (a -= 1, (this || _global).fonts[t].loaded = !0) : (e = (this || _global).fonts[t].sansCase.node, i = (this || _global).fonts[t].sansCase.w, e.offsetWidth !== i && (a -= 1, (this || _global).fonts[t].loaded = !0)), (this || _global).fonts[t].loaded && ((this || _global).fonts[t].sansCase.parent.parentNode.removeChild((this || _global).fonts[t].sansCase.parent), (this || _global).fonts[t].monoCase.parent.parentNode.removeChild((this || _global).fonts[t].monoCase.parent)));
        0 !== a && Date.now() - (this || _global).initTime < 5000 ? setTimeout((this || _global).checkLoadedFontsBinded, 20) : setTimeout((this || _global).setIsLoadedBinded, 10);
      },
      setIsLoaded: function () {
        (this || _global).isLoaded = !0;
      }
    };
    return l.prototype = p, l;
  }();
  function Pe(t) {
    (this || _global).animationData = t;
  }
  function Ae() {}
  Pe.prototype.getProp = function (t) {
    return (this || _global).animationData.slots && (this || _global).animationData.slots[t.sid] ? Object.assign(t, (this || _global).animationData.slots[t.sid].p) : t;
  }, Ae.prototype = {
    initRenderable: function () {
      (this || _global).isInRange = !1, (this || _global).hidden = !1, (this || _global).isTransparent = !1, (this || _global).renderableComponents = [];
    },
    addRenderableComponent: function (t) {
      -1 === (this || _global).renderableComponents.indexOf(t) && (this || _global).renderableComponents.push(t);
    },
    removeRenderableComponent: function (t) {
      -1 !== (this || _global).renderableComponents.indexOf(t) && (this || _global).renderableComponents.splice((this || _global).renderableComponents.indexOf(t), 1);
    },
    prepareRenderableFrame: function (t) {
      this.checkLayerLimits(t);
    },
    checkTransparency: function () {
      (this || _global).finalTransform.mProp.o.v <= 0 ? !(this || _global).isTransparent && (this || _global).globalData.renderConfig.hideOnTransparent && ((this || _global).isTransparent = !0, this.hide()) : (this || _global).isTransparent && ((this || _global).isTransparent = !1, this.show());
    },
    checkLayerLimits: function (t) {
      (this || _global).data.ip - (this || _global).data.st <= t && (this || _global).data.op - (this || _global).data.st > t ? !0 !== (this || _global).isInRange && ((this || _global).globalData._mdf = !0, (this || _global)._mdf = !0, (this || _global).isInRange = !0, this.show()) : !1 !== (this || _global).isInRange && ((this || _global).globalData._mdf = !0, (this || _global).isInRange = !1, this.hide());
    },
    renderRenderable: function () {
      var t,
        e = (this || _global).renderableComponents.length;
      for (t = 0; t < e; t += 1) (this || _global).renderableComponents[t].renderFrame((this || _global)._isFirstFrame);
    },
    sourceRectAtTime: function () {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function () {
      return 5 === (this || _global).data.ty ? {
        w: (this || _global).data.textData.width,
        h: (this || _global).data.textData.height
      } : {
        w: (this || _global).data.width,
        h: (this || _global).data.height
      };
    }
  };
  var Se,
    xe = (Se = {
      0: "source-over",
      1: "multiply",
      2: "screen",
      3: "overlay",
      4: "darken",
      5: "lighten",
      6: "color-dodge",
      7: "color-burn",
      8: "hard-light",
      9: "soft-light",
      10: "difference",
      11: "exclusion",
      12: "hue",
      13: "saturation",
      14: "color",
      15: "luminosity"
    }, function (t) {
      return Se[t] || "";
    });
  function we(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 0, 0, i);
  }
  function De(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 0, 0, i);
  }
  function Ce(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 1, 0, i);
  }
  function Me(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 1, 0, i);
  }
  function Te(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 0, 0, i);
  }
  function Fe(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 0, 0, i);
  }
  function Ee(t, e, i) {
    (this || _global).p = vt.getProp(e, t.v, 0, 0, i);
  }
  function Ie() {
    (this || _global).p = {};
  }
  function Le(t, e) {
    var i,
      s = t.ef || [];
    (this || _global).effectElements = [];
    var a,
      r = s.length;
    for (i = 0; i < r; i += 1) a = new Ve(s[i], e), (this || _global).effectElements.push(a);
  }
  function Ve(t, e) {
    this.init(t, e);
  }
  function Re() {}
  function ze() {}
  function Oe(t, e, i) {
    this.initFrame(), this.initRenderable(), (this || _global).assetData = e.getAssetData(t.refId), (this || _global).footageData = e.imageLoader.getAsset((this || _global).assetData), this.initBaseData(t, e, i);
  }
  function Ne(t, e, i) {
    this.initFrame(), this.initRenderable(), (this || _global).assetData = e.getAssetData(t.refId), this.initBaseData(t, e, i), (this || _global)._isPlaying = !1, (this || _global)._canPlay = !1;
    var s = (this || _global).globalData.getAssetsPath((this || _global).assetData);
    (this || _global).audio = (this || _global).globalData.audioController.createAudio(s), (this || _global)._currentTime = 0, (this || _global).globalData.audioController.addAudio(this || _global), (this || _global)._volumeMultiplier = 1, (this || _global)._volume = 1, (this || _global)._previousVolume = null, (this || _global).tm = t.tm ? vt.getProp(this || _global, t.tm, 0, e.frameRate, this || _global) : {
      _placeholder: !0
    }, (this || _global).lv = vt.getProp(this || _global, t.au && t.au.lv ? t.au.lv : {
      k: [100]
    }, 1, 0.01, this || _global);
  }
  function Be() {}
  r([bt], Ve), Ve.prototype.getValue = Ve.prototype.iterateDynamicProperties, Ve.prototype.init = function (t, e) {
    var i;
    (this || _global).data = t, (this || _global).effectElements = [], this.initDynamicPropertyContainer(e);
    var s,
      a = (this || _global).data.ef.length,
      r = (this || _global).data.ef;
    for (i = 0; i < a; i += 1) {
      switch (s = null, r[i].ty) {
        case 0:
          s = new we(r[i], e, this || _global);
          break;
        case 1:
          s = new De(r[i], e, this || _global);
          break;
        case 2:
          s = new Ce(r[i], e, this || _global);
          break;
        case 3:
          s = new Me(r[i], e, this || _global);
          break;
        case 4:
        case 7:
          s = new Ee(r[i], e, this || _global);
          break;
        case 10:
          s = new Te(r[i], e, this || _global);
          break;
        case 11:
          s = new Fe(r[i], e, this || _global);
          break;
        case 5:
          s = new Le(r[i], e, this || _global);
          break;
        default:
          s = new Ie(r[i], e, this || _global);
      }
      s && (this || _global).effectElements.push(s);
    }
  }, Re.prototype = {
    checkMasks: function () {
      if (!(this || _global).data.hasMask) return !1;
      for (var t = 0, e = (this || _global).data.masksProperties.length; t < e;) {
        if ("n" !== (this || _global).data.masksProperties[t].mode && !1 !== (this || _global).data.masksProperties[t].cl) return !0;
        t += 1;
      }
      return !1;
    },
    initExpressions: function () {
      var t = B();
      if (t) {
        var e = t("layer"),
          i = t("effects"),
          s = t("shape"),
          a = t("text"),
          r = t("comp");
        (this || _global).layerInterface = e(this || _global), (this || _global).data.hasMask && (this || _global).maskManager && (this || _global).layerInterface.registerMaskInterface((this || _global).maskManager);
        var n = i.createEffectsInterface(this || _global, (this || _global).layerInterface);
        (this || _global).layerInterface.registerEffectsInterface(n), 0 === (this || _global).data.ty || (this || _global).data.xt ? (this || _global).compInterface = r(this || _global) : 4 === (this || _global).data.ty ? ((this || _global).layerInterface.shapeInterface = s((this || _global).shapesData, (this || _global).itemsData, (this || _global).layerInterface), (this || _global).layerInterface.content = (this || _global).layerInterface.shapeInterface) : 5 === (this || _global).data.ty && ((this || _global).layerInterface.textInterface = a(this || _global), (this || _global).layerInterface.text = (this || _global).layerInterface.textInterface);
      }
    },
    setBlendMode: function () {
      var t = xe((this || _global).data.bm);
      ((this || _global).baseElement || (this || _global).layerElement).style["mix-blend-mode"] = t;
    },
    initBaseData: function (t, e, i) {
      (this || _global).globalData = e, (this || _global).comp = i, (this || _global).data = t, (this || _global).layerId = I(), (this || _global).data.sr || ((this || _global).data.sr = 1), (this || _global).effectsManager = new Le((this || _global).data, this || _global, (this || _global).dynamicProperties);
    },
    getType: function () {
      return (this || _global).type;
    },
    sourceRectAtTime: function () {}
  }, ze.prototype = {
    initFrame: function () {
      (this || _global)._isFirstFrame = !1, (this || _global).dynamicProperties = [], (this || _global)._mdf = !1;
    },
    prepareProperties: function (t, e) {
      var i,
        s = (this || _global).dynamicProperties.length;
      for (i = 0; i < s; i += 1) (e || (this || _global)._isParent && "transform" === (this || _global).dynamicProperties[i].propType) && ((this || _global).dynamicProperties[i].getValue(), (this || _global).dynamicProperties[i]._mdf && ((this || _global).globalData._mdf = !0, (this || _global)._mdf = !0));
    },
    addDynamicProperty: function (t) {
      -1 === (this || _global).dynamicProperties.indexOf(t) && (this || _global).dynamicProperties.push(t);
    }
  }, Oe.prototype.prepareFrame = function () {}, r([Ae, Re, ze], Oe), Oe.prototype.getBaseElement = function () {
    return null;
  }, Oe.prototype.renderFrame = function () {}, Oe.prototype.destroy = function () {}, Oe.prototype.initExpressions = function () {
    var t = B();
    if (t) {
      var e = t("footage");
      (this || _global).layerInterface = e(this || _global);
    }
  }, Oe.prototype.getFootageData = function () {
    return (this || _global).footageData;
  }, Ne.prototype.prepareFrame = function (t) {
    if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), (this || _global).tm._placeholder) (this || _global)._currentTime = t / (this || _global).data.sr;else {
      var e = (this || _global).tm.v;
      (this || _global)._currentTime = e;
    }
    (this || _global)._volume = (this || _global).lv.v[0];
    var i = (this || _global)._volume * (this || _global)._volumeMultiplier;
    (this || _global)._previousVolume !== i && ((this || _global)._previousVolume = i, (this || _global).audio.volume(i));
  }, r([Ae, Re, ze], Ne), Ne.prototype.renderFrame = function () {
    (this || _global).isInRange && (this || _global)._canPlay && ((this || _global)._isPlaying ? (!(this || _global).audio.playing() || Math.abs((this || _global)._currentTime / (this || _global).globalData.frameRate - (this || _global).audio.seek()) > 0.1) && (this || _global).audio.seek((this || _global)._currentTime / (this || _global).globalData.frameRate) : ((this || _global).audio.play(), (this || _global).audio.seek((this || _global)._currentTime / (this || _global).globalData.frameRate), (this || _global)._isPlaying = !0));
  }, Ne.prototype.show = function () {}, Ne.prototype.hide = function () {
    (this || _global).audio.pause(), (this || _global)._isPlaying = !1;
  }, Ne.prototype.pause = function () {
    (this || _global).audio.pause(), (this || _global)._isPlaying = !1, (this || _global)._canPlay = !1;
  }, Ne.prototype.resume = function () {
    (this || _global)._canPlay = !0;
  }, Ne.prototype.setRate = function (t) {
    (this || _global).audio.rate(t);
  }, Ne.prototype.volume = function (t) {
    (this || _global)._volumeMultiplier = t, (this || _global)._previousVolume = t * (this || _global)._volume, (this || _global).audio.volume((this || _global)._previousVolume);
  }, Ne.prototype.getBaseElement = function () {
    return null;
  }, Ne.prototype.destroy = function () {}, Ne.prototype.sourceRectAtTime = function () {}, Ne.prototype.initExpressions = function () {}, Be.prototype.checkLayers = function (t) {
    var e,
      i,
      s = (this || _global).layers.length;
    for ((this || _global).completeLayers = !0, e = s - 1; e >= 0; e -= 1) (this || _global).elements[e] || (i = (this || _global).layers[e]).ip - i.st <= t - (this || _global).layers[e].st && i.op - i.st > t - (this || _global).layers[e].st && this.buildItem(e), (this || _global).completeLayers = !!(this || _global).elements[e] && (this || _global).completeLayers;
    this.checkPendingElements();
  }, Be.prototype.createItem = function (t) {
    switch (t.ty) {
      case 2:
        return this.createImage(t);
      case 0:
        return this.createComp(t);
      case 1:
        return this.createSolid(t);
      case 3:
      default:
        return this.createNull(t);
      case 4:
        return this.createShape(t);
      case 5:
        return this.createText(t);
      case 6:
        return this.createAudio(t);
      case 13:
        return this.createCamera(t);
      case 15:
        return this.createFootage(t);
    }
  }, Be.prototype.createCamera = function () {
    throw new Error("You're using a 3d camera. Try the html renderer.");
  }, Be.prototype.createAudio = function (t) {
    return new Ne(t, (this || _global).globalData, this || _global);
  }, Be.prototype.createFootage = function (t) {
    return new Oe(t, (this || _global).globalData, this || _global);
  }, Be.prototype.buildAllItems = function () {
    var t,
      e = (this || _global).layers.length;
    for (t = 0; t < e; t += 1) this.buildItem(t);
    this.checkPendingElements();
  }, Be.prototype.includeLayers = function (t) {
    var e;
    (this || _global).completeLayers = !1;
    var i,
      s = t.length,
      a = (this || _global).layers.length;
    for (e = 0; e < s; e += 1) for (i = 0; i < a;) {
      if ((this || _global).layers[i].id === t[e].id) {
        (this || _global).layers[i] = t[e];
        break;
      }
      i += 1;
    }
  }, Be.prototype.setProjectInterface = function (t) {
    (this || _global).globalData.projectInterface = t;
  }, Be.prototype.initItems = function () {
    (this || _global).globalData.progressiveLoad || this.buildAllItems();
  }, Be.prototype.buildElementParenting = function (t, e, i) {
    for (var s = (this || _global).elements, a = (this || _global).layers, r = 0, n = a.length; r < n;) a[r].ind == e && (s[r] && !0 !== s[r] ? (i.push(s[r]), s[r].setAsParent(), void 0 !== a[r].parent ? this.buildElementParenting(t, a[r].parent, i) : t.setHierarchy(i)) : (this.buildItem(r), this.addPendingElement(t))), r += 1;
  }, Be.prototype.addPendingElement = function (t) {
    (this || _global).pendingElements.push(t);
  }, Be.prototype.searchExtraCompositions = function (t) {
    var e,
      i = t.length;
    for (e = 0; e < i; e += 1) if (t[e].xt) {
      var s = this.createComp(t[e]);
      s.initExpressions(), (this || _global).globalData.projectInterface.registerComposition(s);
    }
  }, Be.prototype.getElementById = function (t) {
    var e,
      i = (this || _global).elements.length;
    for (e = 0; e < i; e += 1) if ((this || _global).elements[e].data.ind === t) return (this || _global).elements[e];
    return null;
  }, Be.prototype.getElementByPath = function (t) {
    var e,
      i = t.shift();
    if ("number" == typeof i) e = (this || _global).elements[i];else {
      var s,
        a = (this || _global).elements.length;
      for (s = 0; s < a; s += 1) if ((this || _global).elements[s].data.nm === i) {
        e = (this || _global).elements[s];
        break;
      }
    }
    return 0 === t.length ? e : e.getElementByPath(t);
  }, Be.prototype.setupGlobalData = function (t, e) {
    (this || _global).globalData.fontManager = new ke(), (this || _global).globalData.slotManager = function (t) {
      return new Pe(t);
    }(t), (this || _global).globalData.fontManager.addChars(t.chars), (this || _global).globalData.fontManager.addFonts(t.fonts, e), (this || _global).globalData.getAssetData = (this || _global).animationItem.getAssetData.bind((this || _global).animationItem), (this || _global).globalData.getAssetsPath = (this || _global).animationItem.getAssetsPath.bind((this || _global).animationItem), (this || _global).globalData.imageLoader = (this || _global).animationItem.imagePreloader, (this || _global).globalData.audioController = (this || _global).animationItem.audioController, (this || _global).globalData.frameId = 0, (this || _global).globalData.frameRate = t.fr, (this || _global).globalData.nm = t.nm, (this || _global).globalData.compSize = {
      w: t.w,
      h: t.h
    };
  };
  var qe = "transformEFfect";
  function je() {}
  function We(t, e, i) {
    (this || _global).data = t, (this || _global).element = e, (this || _global).globalData = i, (this || _global).storedData = [], (this || _global).masksProperties = (this || _global).data.masksProperties || [], (this || _global).maskElement = null;
    var a,
      r,
      n = (this || _global).globalData.defs,
      o = (this || _global).masksProperties ? (this || _global).masksProperties.length : 0;
    (this || _global).viewData = l(o), (this || _global).solidPath = "";
    var h,
      p,
      f,
      d,
      m,
      c,
      u = (this || _global).masksProperties,
      g = 0,
      y = [],
      v = I(),
      b = "clipPath",
      _ = "clip-path";
    for (a = 0; a < o; a += 1) if (("a" !== u[a].mode && "n" !== u[a].mode || u[a].inv || 100 !== u[a].o.k || u[a].o.x) && (b = "mask", _ = "mask"), "s" !== u[a].mode && "i" !== u[a].mode || 0 !== g ? f = null : ((f = W("rect")).setAttribute("fill", "#ffffff"), f.setAttribute("width", (this || _global).element.comp.data.w || 0), f.setAttribute("height", (this || _global).element.comp.data.h || 0), y.push(f)), r = W("path"), "n" === u[a].mode) (this || _global).viewData[a] = {
      op: vt.getProp((this || _global).element, u[a].o, 0, 0.01, (this || _global).element),
      prop: Tt.getShapeProp((this || _global).element, u[a], 3),
      elem: r,
      lastPath: ""
    }, n.appendChild(r);else {
      var k;
      if (g += 1, r.setAttribute("fill", "s" === u[a].mode ? "#000000" : "#ffffff"), r.setAttribute("clip-rule", "nonzero"), 0 !== u[a].x.k ? (b = "mask", _ = "mask", c = vt.getProp((this || _global).element, u[a].x, 0, null, (this || _global).element), k = I(), (d = W("filter")).setAttribute("id", k), (m = W("feMorphology")).setAttribute("operator", "erode"), m.setAttribute("in", "SourceGraphic"), m.setAttribute("radius", "0"), d.appendChild(m), n.appendChild(d), r.setAttribute("stroke", "s" === u[a].mode ? "#000000" : "#ffffff")) : (m = null, c = null), (this || _global).storedData[a] = {
        elem: r,
        x: c,
        expan: m,
        lastPath: "",
        lastOperator: "",
        filterId: k,
        lastRadius: 0
      }, "i" === u[a].mode) {
        p = y.length;
        var P = W("g");
        for (h = 0; h < p; h += 1) P.appendChild(y[h]);
        var A = W("mask");
        A.setAttribute("mask-type", "alpha"), A.setAttribute("id", v + "_" + g), A.appendChild(r), n.appendChild(A), P.setAttribute("mask", "url(" + s() + "#" + v + "_" + g + ")"), y.length = 0, y.push(P);
      } else y.push(r);
      u[a].inv && !(this || _global).solidPath && ((this || _global).solidPath = this.createLayerSolidPath()), (this || _global).viewData[a] = {
        elem: r,
        lastPath: "",
        op: vt.getProp((this || _global).element, u[a].o, 0, 0.01, (this || _global).element),
        prop: Tt.getShapeProp((this || _global).element, u[a], 3),
        invRect: f
      }, (this || _global).viewData[a].prop.k || this.drawPath(u[a], (this || _global).viewData[a].prop.v, (this || _global).viewData[a]);
    }
    for ((this || _global).maskElement = W(b), o = y.length, a = 0; a < o; a += 1) (this || _global).maskElement.appendChild(y[a]);
    g > 0 && ((this || _global).maskElement.setAttribute("id", v), (this || _global).element.maskedElement.setAttribute(_, "url(" + s() + "#" + v + ")"), n.appendChild((this || _global).maskElement)), (this || _global).viewData.length && (this || _global).element.addRenderableComponent(this || _global);
  }
  je.prototype = {
    initTransform: function () {
      var t = new Ft();
      (this || _global).finalTransform = {
        mProp: (this || _global).data.ks ? Wt.getTransformProperty(this || _global, (this || _global).data.ks, this || _global) : {
          o: 0
        },
        _matMdf: !1,
        _localMatMdf: !1,
        _opMdf: !1,
        mat: t,
        localMat: t,
        localOpacity: 1
      }, (this || _global).data.ao && ((this || _global).finalTransform.mProp.autoOriented = !0), (this || _global).data.ty;
    },
    renderTransform: function () {
      if ((this || _global).finalTransform._opMdf = (this || _global).finalTransform.mProp.o._mdf || (this || _global)._isFirstFrame, (this || _global).finalTransform._matMdf = (this || _global).finalTransform.mProp._mdf || (this || _global)._isFirstFrame, (this || _global).hierarchy) {
        var t,
          e = (this || _global).finalTransform.mat,
          i = 0,
          s = (this || _global).hierarchy.length;
        if (!(this || _global).finalTransform._matMdf) for (; i < s;) {
          if ((this || _global).hierarchy[i].finalTransform.mProp._mdf) {
            (this || _global).finalTransform._matMdf = !0;
            break;
          }
          i += 1;
        }
        if ((this || _global).finalTransform._matMdf) for (t = (this || _global).finalTransform.mProp.v.props, e.cloneFromProps(t), i = 0; i < s; i += 1) e.multiply((this || _global).hierarchy[i].finalTransform.mProp.v);
      }
      (this || _global).finalTransform._matMdf && ((this || _global).finalTransform._localMatMdf = (this || _global).finalTransform._matMdf), (this || _global).finalTransform._opMdf && ((this || _global).finalTransform.localOpacity = (this || _global).finalTransform.mProp.o.v);
    },
    renderLocalTransform: function () {
      if ((this || _global).localTransforms) {
        var t = 0,
          e = (this || _global).localTransforms.length;
        if ((this || _global).finalTransform._localMatMdf = (this || _global).finalTransform._matMdf, !(this || _global).finalTransform._localMatMdf || !(this || _global).finalTransform._opMdf) for (; t < e;) (this || _global).localTransforms[t]._mdf && ((this || _global).finalTransform._localMatMdf = !0), (this || _global).localTransforms[t]._opMdf && !(this || _global).finalTransform._opMdf && ((this || _global).finalTransform.localOpacity = (this || _global).finalTransform.mProp.o.v, (this || _global).finalTransform._opMdf = !0), t += 1;
        if ((this || _global).finalTransform._localMatMdf) {
          var i = (this || _global).finalTransform.localMat;
          for ((this || _global).localTransforms[0].matrix.clone(i), t = 1; t < e; t += 1) {
            var s = (this || _global).localTransforms[t].matrix;
            i.multiply(s);
          }
          i.multiply((this || _global).finalTransform.mat);
        }
        if ((this || _global).finalTransform._opMdf) {
          var a = (this || _global).finalTransform.localOpacity;
          for (t = 0; t < e; t += 1) a *= 0.01 * (this || _global).localTransforms[t].opacity;
          (this || _global).finalTransform.localOpacity = a;
        }
      }
    },
    searchEffectTransforms: function () {
      if ((this || _global).renderableEffectsManager) {
        var t = (this || _global).renderableEffectsManager.getEffects(qe);
        if (t.length) {
          (this || _global).localTransforms = [], (this || _global).finalTransform.localMat = new Ft();
          var e = 0,
            i = t.length;
          for (e = 0; e < i; e += 1) (this || _global).localTransforms.push(t[e]);
        }
      }
    },
    globalToLocal: function (t) {
      var e = [];
      e.push((this || _global).finalTransform);
      for (var i, s = !0, a = (this || _global).comp; s;) a.finalTransform ? (a.data.hasMask && e.splice(0, 0, a.finalTransform), a = a.comp) : s = !1;
      var r,
        n = e.length;
      for (i = 0; i < n; i += 1) r = e[i].mat.applyToPointArray(0, 0, 0), t = [t[0] - r[0], t[1] - r[1], 0];
      return t;
    },
    mHelper: new Ft()
  }, We.prototype.getMaskProperty = function (t) {
    return (this || _global).viewData[t].prop;
  }, We.prototype.renderFrame = function (t) {
    var e,
      i = (this || _global).element.finalTransform.mat,
      a = (this || _global).masksProperties.length;
    for (e = 0; e < a; e += 1) if (((this || _global).viewData[e].prop._mdf || t) && this.drawPath((this || _global).masksProperties[e], (this || _global).viewData[e].prop.v, (this || _global).viewData[e]), ((this || _global).viewData[e].op._mdf || t) && (this || _global).viewData[e].elem.setAttribute("fill-opacity", (this || _global).viewData[e].op.v), "n" !== (this || _global).masksProperties[e].mode && ((this || _global).viewData[e].invRect && ((this || _global).element.finalTransform.mProp._mdf || t) && (this || _global).viewData[e].invRect.setAttribute("transform", i.getInverseMatrix().to2dCSS()), (this || _global).storedData[e].x && ((this || _global).storedData[e].x._mdf || t))) {
      var r = (this || _global).storedData[e].expan;
      (this || _global).storedData[e].x.v < 0 ? ("erode" !== (this || _global).storedData[e].lastOperator && ((this || _global).storedData[e].lastOperator = "erode", (this || _global).storedData[e].elem.setAttribute("filter", "url(" + s() + "#" + (this || _global).storedData[e].filterId + ")")), r.setAttribute("radius", -(this || _global).storedData[e].x.v)) : ("dilate" !== (this || _global).storedData[e].lastOperator && ((this || _global).storedData[e].lastOperator = "dilate", (this || _global).storedData[e].elem.setAttribute("filter", null)), (this || _global).storedData[e].elem.setAttribute("stroke-width", 2 * (this || _global).storedData[e].x.v));
    }
  }, We.prototype.getMaskelement = function () {
    return (this || _global).maskElement;
  }, We.prototype.createLayerSolidPath = function () {
    var t = "M0,0 ";
    return t += " h" + (this || _global).globalData.compSize.w, t += " v" + (this || _global).globalData.compSize.h, t += " h-" + (this || _global).globalData.compSize.w, t += " v-" + (this || _global).globalData.compSize.h + " ";
  }, We.prototype.drawPath = function (t, e, i) {
    var s,
      a,
      r = " M" + e.v[0][0] + "," + e.v[0][1];
    for (a = e._length, s = 1; s < a; s += 1) r += " C" + e.o[s - 1][0] + "," + e.o[s - 1][1] + " " + e.i[s][0] + "," + e.i[s][1] + " " + e.v[s][0] + "," + e.v[s][1];
    if (e.c && a > 1 && (r += " C" + e.o[s - 1][0] + "," + e.o[s - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), i.lastPath !== r) {
      var n = "";
      i.elem && (e.c && (n = t.inv ? (this || _global).solidPath + r : r), i.elem.setAttribute("d", n)), i.lastPath = r;
    }
  }, We.prototype.destroy = function () {
    (this || _global).element = null, (this || _global).globalData = null, (this || _global).maskElement = null, (this || _global).data = null, (this || _global).masksProperties = null;
  };
  var Xe = function () {
      var t = {};
      return t.createFilter = function (t, e) {
        var i = W("filter");
        i.setAttribute("id", t), !0 !== e && (i.setAttribute("filterUnits", "objectBoundingBox"), i.setAttribute("x", "0%"), i.setAttribute("y", "0%"), i.setAttribute("width", "100%"), i.setAttribute("height", "100%"));
        return i;
      }, t.createAlphaToLuminanceFilter = function () {
        var t = W("feColorMatrix");
        return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
      }, t;
    }(),
    He = function () {
      var t = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: "undefined" != typeof OffscreenCanvas
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
    }(),
    Ye = {},
    Ge = "filter_result_";
  function Ke(t) {
    var e,
      i,
      a = "SourceGraphic",
      r = t.data.ef ? t.data.ef.length : 0,
      n = I(),
      o = Xe.createFilter(n, !0),
      h = 0;
    for ((this || _global).filters = [], e = 0; e < r; e += 1) {
      i = null;
      var l = t.data.ef[e].ty;
      if (Ye[l]) i = new (0, Ye[l].effect)(o, t.effectsManager.effectElements[e], t, Ge + h, a), a = Ge + h, Ye[l].countsAsEffect && (h += 1);
      i && (this || _global).filters.push(i);
    }
    h && (t.globalData.defs.appendChild(o), t.layerElement.setAttribute("filter", "url(" + s() + "#" + n + ")")), (this || _global).filters.length && t.addRenderableComponent(this || _global);
  }
  function Je() {}
  function Ue() {}
  function Ze() {}
  function Qe(t, e, i) {
    (this || _global).assetData = e.getAssetData(t.refId), (this || _global).assetData && (this || _global).assetData.sid && ((this || _global).assetData = e.slotManager.getProp((this || _global).assetData)), this.initElement(t, e, i), (this || _global).sourceRect = {
      top: 0,
      left: 0,
      width: (this || _global).assetData.w,
      height: (this || _global).assetData.h
    };
  }
  function $e(t, e) {
    (this || _global).elem = t, (this || _global).pos = e;
  }
  function ti() {}
  Ke.prototype.renderFrame = function (t) {
    var e,
      i = (this || _global).filters.length;
    for (e = 0; e < i; e += 1) (this || _global).filters[e].renderFrame(t);
  }, Ke.prototype.getEffects = function (t) {
    var e,
      i = (this || _global).filters.length,
      s = [];
    for (e = 0; e < i; e += 1) (this || _global).filters[e].type === t && s.push((this || _global).filters[e]);
    return s;
  }, Je.prototype = {
    initRendererElement: function () {
      (this || _global).layerElement = W("g");
    },
    createContainerElements: function () {
      (this || _global).matteElement = W("g"), (this || _global).transformedElement = (this || _global).layerElement, (this || _global).maskedElement = (this || _global).layerElement, (this || _global)._sizeChanged = !1;
      var t = null;
      if ((this || _global).data.td) {
        (this || _global).matteMasks = {};
        var e = W("g");
        e.setAttribute("id", (this || _global).layerId), e.appendChild((this || _global).layerElement), t = e, (this || _global).globalData.defs.appendChild(e);
      } else (this || _global).data.tt ? ((this || _global).matteElement.appendChild((this || _global).layerElement), t = (this || _global).matteElement, (this || _global).baseElement = (this || _global).matteElement) : (this || _global).baseElement = (this || _global).layerElement;
      if ((this || _global).data.ln && (this || _global).layerElement.setAttribute("id", (this || _global).data.ln), (this || _global).data.cl && (this || _global).layerElement.setAttribute("class", (this || _global).data.cl), 0 === (this || _global).data.ty && !(this || _global).data.hd) {
        var i = W("clipPath"),
          a = W("path");
        a.setAttribute("d", "M0,0 L" + (this || _global).data.w + ",0 L" + (this || _global).data.w + "," + (this || _global).data.h + " L0," + (this || _global).data.h + "z");
        var r = I();
        if (i.setAttribute("id", r), i.appendChild(a), (this || _global).globalData.defs.appendChild(i), this.checkMasks()) {
          var n = W("g");
          n.setAttribute("clip-path", "url(" + s() + "#" + r + ")"), n.appendChild((this || _global).layerElement), (this || _global).transformedElement = n, t ? t.appendChild((this || _global).transformedElement) : (this || _global).baseElement = (this || _global).transformedElement;
        } else (this || _global).layerElement.setAttribute("clip-path", "url(" + s() + "#" + r + ")");
      }
      0 !== (this || _global).data.bm && this.setBlendMode();
    },
    renderElement: function () {
      (this || _global).finalTransform._localMatMdf && (this || _global).transformedElement.setAttribute("transform", (this || _global).finalTransform.localMat.to2dCSS()), (this || _global).finalTransform._opMdf && (this || _global).transformedElement.setAttribute("opacity", (this || _global).finalTransform.localOpacity);
    },
    destroyBaseElement: function () {
      (this || _global).layerElement = null, (this || _global).matteElement = null, (this || _global).maskManager.destroy();
    },
    getBaseElement: function () {
      return (this || _global).data.hd ? null : (this || _global).baseElement;
    },
    createRenderableComponents: function () {
      (this || _global).maskManager = new We((this || _global).data, this || _global, (this || _global).globalData), (this || _global).renderableEffectsManager = new Ke(this || _global), this.searchEffectTransforms();
    },
    getMatte: function (t) {
      if ((this || _global).matteMasks || ((this || _global).matteMasks = {}), !(this || _global).matteMasks[t]) {
        var e,
          i,
          a,
          r,
          n = (this || _global).layerId + "_" + t;
        if (1 === t || 3 === t) {
          var o = W("mask");
          o.setAttribute("id", n), o.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (a = W("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + (this || _global).layerId), o.appendChild(a), (this || _global).globalData.defs.appendChild(o), He.maskType || 1 !== t || (o.setAttribute("mask-type", "luminance"), e = I(), i = Xe.createFilter(e), (this || _global).globalData.defs.appendChild(i), i.appendChild(Xe.createAlphaToLuminanceFilter()), (r = W("g")).appendChild(a), o.appendChild(r), r.setAttribute("filter", "url(" + s() + "#" + e + ")"));
        } else if (2 === t) {
          var h = W("mask");
          h.setAttribute("id", n), h.setAttribute("mask-type", "alpha");
          var l = W("g");
          h.appendChild(l), e = I(), i = Xe.createFilter(e);
          var p = W("feComponentTransfer");
          p.setAttribute("in", "SourceGraphic"), i.appendChild(p);
          var f = W("feFuncA");
          f.setAttribute("type", "table"), f.setAttribute("tableValues", "1.0 0.0"), p.appendChild(f), (this || _global).globalData.defs.appendChild(i);
          var d = W("rect");
          d.setAttribute("width", (this || _global).comp.data.w), d.setAttribute("height", (this || _global).comp.data.h), d.setAttribute("x", "0"), d.setAttribute("y", "0"), d.setAttribute("fill", "#ffffff"), d.setAttribute("opacity", "0"), l.setAttribute("filter", "url(" + s() + "#" + e + ")"), l.appendChild(d), (a = W("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + (this || _global).layerId), l.appendChild(a), He.maskType || (h.setAttribute("mask-type", "luminance"), i.appendChild(Xe.createAlphaToLuminanceFilter()), r = W("g"), l.appendChild(d), r.appendChild((this || _global).layerElement), l.appendChild(r)), (this || _global).globalData.defs.appendChild(h);
        }
        (this || _global).matteMasks[t] = n;
      }
      return (this || _global).matteMasks[t];
    },
    setMatte: function (t) {
      (this || _global).matteElement && (this || _global).matteElement.setAttribute("mask", "url(" + s() + "#" + t + ")");
    }
  }, Ue.prototype = {
    initHierarchy: function () {
      (this || _global).hierarchy = [], (this || _global)._isParent = !1, this.checkParenting();
    },
    setHierarchy: function (t) {
      (this || _global).hierarchy = t;
    },
    setAsParent: function () {
      (this || _global)._isParent = !0;
    },
    checkParenting: function () {
      void 0 !== (this || _global).data.parent && (this || _global).comp.buildElementParenting(this || _global, (this || _global).data.parent, []);
    }
  }, r([Ae, n({
    initElement: function (t, e, i) {
      this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    },
    hide: function () {
      (this || _global).hidden || (this || _global).isInRange && !(this || _global).isTransparent || (((this || _global).baseElement || (this || _global).layerElement).style.display = "none", (this || _global).hidden = !0);
    },
    show: function () {
      (this || _global).isInRange && !(this || _global).isTransparent && ((this || _global).data.hd || (((this || _global).baseElement || (this || _global).layerElement).style.display = "block"), (this || _global).hidden = !1, (this || _global)._isFirstFrame = !0);
    },
    renderFrame: function () {
      (this || _global).data.hd || (this || _global).hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), (this || _global)._isFirstFrame && ((this || _global)._isFirstFrame = !1));
    },
    renderInnerContent: function () {},
    prepareFrame: function (t) {
      (this || _global)._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, (this || _global).isInRange), this.checkTransparency();
    },
    destroy: function () {
      (this || _global).innerElem = null, this.destroyBaseElement();
    }
  })], Ze), r([Re, je, Je, Ue, ze, Ze], Qe), Qe.prototype.createContent = function () {
    var t = (this || _global).globalData.getAssetsPath((this || _global).assetData);
    (this || _global).innerElem = W("image"), (this || _global).innerElem.setAttribute("width", (this || _global).assetData.w + "px"), (this || _global).innerElem.setAttribute("height", (this || _global).assetData.h + "px"), (this || _global).innerElem.setAttribute("preserveAspectRatio", (this || _global).assetData.pr || (this || _global).globalData.renderConfig.imagePreserveAspectRatio), (this || _global).innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), (this || _global).layerElement.appendChild((this || _global).innerElem);
  }, Qe.prototype.sourceRectAtTime = function () {
    return (this || _global).sourceRect;
  }, ti.prototype = {
    addShapeToModifiers: function (t) {
      var e,
        i = (this || _global).shapeModifiers.length;
      for (e = 0; e < i; e += 1) (this || _global).shapeModifiers[e].addShape(t);
    },
    isShapeInAnimatedModifiers: function (t) {
      for (var e = (this || _global).shapeModifiers.length; 0 < e;) if ((this || _global).shapeModifiers[0].isAnimatedWithShape(t)) return !0;
      return !1;
    },
    renderModifiers: function () {
      if ((this || _global).shapeModifiers.length) {
        var t,
          e = (this || _global).shapes.length;
        for (t = 0; t < e; t += 1) (this || _global).shapes[t].sh.reset();
        for (t = (e = (this || _global).shapeModifiers.length) - 1; t >= 0 && !(this || _global).shapeModifiers[t].processShapes((this || _global)._isFirstFrame); t -= 1);
      }
    },
    searchProcessedElement: function (t) {
      for (var e = (this || _global).processedElements, i = 0, s = e.length; i < s;) {
        if (e[i].elem === t) return e[i].pos;
        i += 1;
      }
      return 0;
    },
    addProcessedElement: function (t, e) {
      for (var i = (this || _global).processedElements, s = i.length; s;) if (i[s -= 1].elem === t) return void (i[s].pos = e);
      i.push(new $e(t, e));
    },
    prepareFrame: function (t) {
      this.prepareRenderableFrame(t), this.prepareProperties(t, (this || _global).isInRange);
    }
  };
  var ei = {
      1: "butt",
      2: "round",
      3: "square"
    },
    ii = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
  function si(t, e, i) {
    (this || _global).caches = [], (this || _global).styles = [], (this || _global).transformers = t, (this || _global).lStr = "", (this || _global).sh = i, (this || _global).lvl = e, (this || _global)._isAnimated = !!i.k;
    for (var s = 0, a = t.length; s < a;) {
      if (t[s].mProps.dynamicProperties.length) {
        (this || _global)._isAnimated = !0;
        break;
      }
      s += 1;
    }
  }
  function ai(t, e) {
    (this || _global).data = t, (this || _global).type = t.ty, (this || _global).d = "", (this || _global).lvl = e, (this || _global)._mdf = !1, (this || _global).closed = !0 === t.hd, (this || _global).pElem = W("path"), (this || _global).msElem = null;
  }
  function ri(t, e, i, s) {
    var a;
    (this || _global).elem = t, (this || _global).frameId = -1, (this || _global).dataProps = l(e.length), (this || _global).renderer = i, (this || _global).k = !1, (this || _global).dashStr = "", (this || _global).dashArray = h("float32", e.length ? e.length - 1 : 0), (this || _global).dashoffset = h("float32", 1), this.initDynamicPropertyContainer(s);
    var r,
      n = e.length || 0;
    for (a = 0; a < n; a += 1) r = vt.getProp(t, e[a].v, 0, 0, this || _global), (this || _global).k = r.k || (this || _global).k, (this || _global).dataProps[a] = {
      n: e[a].n,
      p: r
    };
    (this || _global).k || this.getValue(!0), (this || _global)._isAnimated = (this || _global).k;
  }
  function ni(t, e, i) {
    this.initDynamicPropertyContainer(t), (this || _global).getValue = (this || _global).iterateDynamicProperties, (this || _global).o = vt.getProp(t, e.o, 0, 0.01, this || _global), (this || _global).w = vt.getProp(t, e.w, 0, null, this || _global), (this || _global).d = new ri(t, e.d || {}, "svg", this || _global), (this || _global).c = vt.getProp(t, e.c, 1, 255, this || _global), (this || _global).style = i, (this || _global)._isAnimated = !!(this || _global)._isAnimated;
  }
  function oi(t, e, i) {
    this.initDynamicPropertyContainer(t), (this || _global).getValue = (this || _global).iterateDynamicProperties, (this || _global).o = vt.getProp(t, e.o, 0, 0.01, this || _global), (this || _global).c = vt.getProp(t, e.c, 1, 255, this || _global), (this || _global).style = i;
  }
  function hi(t, e, i) {
    this.initDynamicPropertyContainer(t), (this || _global).getValue = (this || _global).iterateDynamicProperties, (this || _global).style = i;
  }
  function li(t, e, i) {
    (this || _global).data = e, (this || _global).c = h("uint8c", 4 * e.p);
    var s = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
    (this || _global).o = h("float32", s), (this || _global)._cmdf = !1, (this || _global)._omdf = !1, (this || _global)._collapsable = this.checkCollapsable(), (this || _global)._hasOpacity = s, this.initDynamicPropertyContainer(i), (this || _global).prop = vt.getProp(t, e.k, 1, null, this || _global), (this || _global).k = (this || _global).prop.k, this.getValue(!0);
  }
  function pi(t, e, i) {
    this.initDynamicPropertyContainer(t), (this || _global).getValue = (this || _global).iterateDynamicProperties, this.initGradientData(t, e, i);
  }
  function fi(t, e, i) {
    this.initDynamicPropertyContainer(t), (this || _global).getValue = (this || _global).iterateDynamicProperties, (this || _global).w = vt.getProp(t, e.w, 0, null, this || _global), (this || _global).d = new ri(t, e.d || {}, "svg", this || _global), this.initGradientData(t, e, i), (this || _global)._isAnimated = !!(this || _global)._isAnimated;
  }
  function di() {
    (this || _global).it = [], (this || _global).prevViewData = [], (this || _global).gr = W("g");
  }
  function mi(t, e, i) {
    (this || _global).transform = {
      mProps: t,
      op: e,
      container: i
    }, (this || _global).elements = [], (this || _global)._isAnimated = (this || _global).transform.mProps.dynamicProperties.length || (this || _global).transform.op.effectsSequence.length;
  }
  si.prototype.setAsAnimated = function () {
    (this || _global)._isAnimated = !0;
  }, ai.prototype.reset = function () {
    (this || _global).d = "", (this || _global)._mdf = !1;
  }, ri.prototype.getValue = function (t) {
    if (((this || _global).elem.globalData.frameId !== (this || _global).frameId || t) && ((this || _global).frameId = (this || _global).elem.globalData.frameId, this.iterateDynamicProperties(), (this || _global)._mdf = (this || _global)._mdf || t, (this || _global)._mdf)) {
      var e = 0,
        i = (this || _global).dataProps.length;
      for ("svg" === (this || _global).renderer && ((this || _global).dashStr = ""), e = 0; e < i; e += 1) "o" !== (this || _global).dataProps[e].n ? "svg" === (this || _global).renderer ? (this || _global).dashStr += " " + (this || _global).dataProps[e].p.v : (this || _global).dashArray[e] = (this || _global).dataProps[e].p.v : (this || _global).dashoffset[0] = (this || _global).dataProps[e].p.v;
    }
  }, r([bt], ri), r([bt], ni), r([bt], oi), r([bt], hi), li.prototype.comparePoints = function (t, e) {
    for (var i = 0, s = (this || _global).o.length / 2; i < s;) {
      if (Math.abs(t[4 * i] - t[4 * e + 2 * i]) > 0.01) return !1;
      i += 1;
    }
    return !0;
  }, li.prototype.checkCollapsable = function () {
    if ((this || _global).o.length / 2 != (this || _global).c.length / 4) return !1;
    if ((this || _global).data.k.k[0].s) for (var t = 0, e = (this || _global).data.k.k.length; t < e;) {
      if (!this.comparePoints((this || _global).data.k.k[t].s, (this || _global).data.p)) return !1;
      t += 1;
    } else if (!this.comparePoints((this || _global).data.k.k, (this || _global).data.p)) return !1;
    return !0;
  }, li.prototype.getValue = function (t) {
    if ((this || _global).prop.getValue(), (this || _global)._mdf = !1, (this || _global)._cmdf = !1, (this || _global)._omdf = !1, (this || _global).prop._mdf || t) {
      var e,
        i,
        s,
        a = 4 * (this || _global).data.p;
      for (e = 0; e < a; e += 1) i = e % 4 == 0 ? 100 : 255, s = Math.round((this || _global).prop.v[e] * i), (this || _global).c[e] !== s && ((this || _global).c[e] = s, (this || _global)._cmdf = !t);
      if ((this || _global).o.length) for (a = (this || _global).prop.v.length, e = 4 * (this || _global).data.p; e < a; e += 1) i = e % 2 == 0 ? 100 : 1, s = e % 2 == 0 ? Math.round(100 * (this || _global).prop.v[e]) : (this || _global).prop.v[e], (this || _global).o[e - 4 * (this || _global).data.p] !== s && ((this || _global).o[e - 4 * (this || _global).data.p] = s, (this || _global)._omdf = !t);
      (this || _global)._mdf = !t;
    }
  }, r([bt], li), pi.prototype.initGradientData = function (t, e, i) {
    (this || _global).o = vt.getProp(t, e.o, 0, 0.01, this || _global), (this || _global).s = vt.getProp(t, e.s, 1, null, this || _global), (this || _global).e = vt.getProp(t, e.e, 1, null, this || _global), (this || _global).h = vt.getProp(t, e.h || {
      k: 0
    }, 0, 0.01, this || _global), (this || _global).a = vt.getProp(t, e.a || {
      k: 0
    }, 0, P, this || _global), (this || _global).g = new li(t, e.g, this || _global), (this || _global).style = i, (this || _global).stops = [], this.setGradientData(i.pElem, e), this.setGradientOpacity(e, i), (this || _global)._isAnimated = !!(this || _global)._isAnimated;
  }, pi.prototype.setGradientData = function (t, e) {
    var i = I(),
      a = W(1 === e.t ? "linearGradient" : "radialGradient");
    a.setAttribute("id", i), a.setAttribute("spreadMethod", "pad"), a.setAttribute("gradientUnits", "userSpaceOnUse");
    var r,
      n,
      o,
      h = [];
    for (o = 4 * e.g.p, n = 0; n < o; n += 4) r = W("stop"), a.appendChild(r), h.push(r);
    t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + s() + "#" + i + ")"), (this || _global).gf = a, (this || _global).cst = h;
  }, pi.prototype.setGradientOpacity = function (t, e) {
    if ((this || _global).g._hasOpacity && !(this || _global).g._collapsable) {
      var i,
        a,
        r,
        n = W("mask"),
        o = W("path");
      n.appendChild(o);
      var h = I(),
        l = I();
      n.setAttribute("id", l);
      var p = W(1 === t.t ? "linearGradient" : "radialGradient");
      p.setAttribute("id", h), p.setAttribute("spreadMethod", "pad"), p.setAttribute("gradientUnits", "userSpaceOnUse"), r = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
      var f = (this || _global).stops;
      for (a = 4 * t.g.p; a < r; a += 2) (i = W("stop")).setAttribute("stop-color", "rgb(255,255,255)"), p.appendChild(i), f.push(i);
      o.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + s() + "#" + h + ")"), "gs" === t.ty && (o.setAttribute("stroke-linecap", ei[t.lc || 2]), o.setAttribute("stroke-linejoin", ii[t.lj || 2]), 1 === t.lj && o.setAttribute("stroke-miterlimit", t.ml)), (this || _global).of = p, (this || _global).ms = n, (this || _global).ost = f, (this || _global).maskId = l, e.msElem = o;
    }
  }, r([bt], pi), r([pi, bt], fi);
  var ci = function (t, e, i, s) {
      if (0 === e) return "";
      var a,
        r = t.o,
        n = t.i,
        o = t.v,
        h = " M" + s.applyToPointStringified(o[0][0], o[0][1]);
      for (a = 1; a < e; a += 1) h += " C" + s.applyToPointStringified(r[a - 1][0], r[a - 1][1]) + " " + s.applyToPointStringified(n[a][0], n[a][1]) + " " + s.applyToPointStringified(o[a][0], o[a][1]);
      return i && e && (h += " C" + s.applyToPointStringified(r[a - 1][0], r[a - 1][1]) + " " + s.applyToPointStringified(n[0][0], n[0][1]) + " " + s.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
    },
    ui = function () {
      var t = new Ft(),
        e = new Ft();
      function i(t, e, i) {
        (i || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (i || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
      }
      function s() {}
      function a(i, s, a) {
        var r,
          n,
          o,
          h,
          l,
          p,
          f,
          d,
          m,
          c,
          u = s.styles.length,
          g = s.lvl;
        for (p = 0; p < u; p += 1) {
          if (h = s.sh._mdf || a, s.styles[p].lvl < g) {
            for (d = e.reset(), m = g - s.styles[p].lvl, c = s.transformers.length - 1; !h && m > 0;) h = s.transformers[c].mProps._mdf || h, m -= 1, c -= 1;
            if (h) for (m = g - s.styles[p].lvl, c = s.transformers.length - 1; m > 0;) d.multiply(s.transformers[c].mProps.v), m -= 1, c -= 1;
          } else d = t;
          if (n = (f = s.sh.paths)._length, h) {
            for (o = "", r = 0; r < n; r += 1) (l = f.shapes[r]) && l._length && (o += ci(l, l._length, l.c, d));
            s.caches[p] = o;
          } else o = s.caches[p];
          s.styles[p].d += !0 === i.hd ? "" : o, s.styles[p]._mdf = h || s.styles[p]._mdf;
        }
      }
      function r(t, e, i) {
        var s = e.style;
        (e.c._mdf || i) && s.pElem.setAttribute("fill", "rgb(" + v(e.c.v[0]) + "," + v(e.c.v[1]) + "," + v(e.c.v[2]) + ")"), (e.o._mdf || i) && s.pElem.setAttribute("fill-opacity", e.o.v);
      }
      function n(t, e, i) {
        o(t, e, i), h(t, e, i);
      }
      function o(t, e, i) {
        var s,
          a,
          r,
          n,
          o,
          h = e.gf,
          l = e.g._hasOpacity,
          p = e.s.v,
          f = e.e.v;
        if (e.o._mdf || i) {
          var d = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
          e.style.pElem.setAttribute(d, e.o.v);
        }
        if (e.s._mdf || i) {
          var m = 1 === t.t ? "x1" : "cx",
            c = "x1" === m ? "y1" : "cy";
          h.setAttribute(m, p[0]), h.setAttribute(c, p[1]), l && !e.g._collapsable && (e.of.setAttribute(m, p[0]), e.of.setAttribute(c, p[1]));
        }
        if (e.g._cmdf || i) {
          s = e.cst;
          var u = e.g.c;
          for (r = s.length, a = 0; a < r; a += 1) (n = s[a]).setAttribute("offset", u[4 * a] + "%"), n.setAttribute("stop-color", "rgb(" + u[4 * a + 1] + "," + u[4 * a + 2] + "," + u[4 * a + 3] + ")");
        }
        if (l && (e.g._omdf || i)) {
          var g = e.g.o;
          for (r = (s = e.g._collapsable ? e.cst : e.ost).length, a = 0; a < r; a += 1) n = s[a], e.g._collapsable || n.setAttribute("offset", g[2 * a] + "%"), n.setAttribute("stop-opacity", g[2 * a + 1]);
        }
        if (1 === t.t) (e.e._mdf || i) && (h.setAttribute("x2", f[0]), h.setAttribute("y2", f[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));else if ((e.s._mdf || e.e._mdf || i) && (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || i) {
          o || (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)));
          var y = Math.atan2(f[1] - p[1], f[0] - p[0]),
            v = e.h.v;
          v >= 1 ? v = 0.99 : v <= -1 && (v = -0.99);
          var b = o * v,
            _ = Math.cos(y + e.a.v) * b + p[0],
            k = Math.sin(y + e.a.v) * b + p[1];
          h.setAttribute("fx", _), h.setAttribute("fy", k), l && !e.g._collapsable && (e.of.setAttribute("fx", _), e.of.setAttribute("fy", k));
        }
      }
      function h(t, e, i) {
        var s = e.style,
          a = e.d;
        a && (a._mdf || i) && a.dashStr && (s.pElem.setAttribute("stroke-dasharray", a.dashStr), s.pElem.setAttribute("stroke-dashoffset", a.dashoffset[0])), e.c && (e.c._mdf || i) && s.pElem.setAttribute("stroke", "rgb(" + v(e.c.v[0]) + "," + v(e.c.v[1]) + "," + v(e.c.v[2]) + ")"), (e.o._mdf || i) && s.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || i) && (s.pElem.setAttribute("stroke-width", e.w.v), s.msElem && s.msElem.setAttribute("stroke-width", e.w.v));
      }
      return {
        createRenderFunction: function (t) {
          switch (t.ty) {
            case "fl":
              return r;
            case "gf":
              return o;
            case "gs":
              return n;
            case "st":
              return h;
            case "sh":
            case "el":
            case "rc":
            case "sr":
              return a;
            case "tr":
              return i;
            case "no":
              return s;
            default:
              return null;
          }
        }
      };
    }();
  function gi(t, e, i) {
    (this || _global).shapes = [], (this || _global).shapesData = t.shapes, (this || _global).stylesList = [], (this || _global).shapeModifiers = [], (this || _global).itemsData = [], (this || _global).processedElements = [], (this || _global).animatedContents = [], this.initElement(t, e, i), (this || _global).prevViewData = [];
  }
  function yi(t, e, i, s, a, r) {
    (this || _global).o = t, (this || _global).sw = e, (this || _global).sc = i, (this || _global).fc = s, (this || _global).m = a, (this || _global).p = r, (this || _global)._mdf = {
      o: !0,
      sw: !!e,
      sc: !!i,
      fc: !!s,
      m: !0,
      p: !0
    };
  }
  function vi(t, e) {
    (this || _global)._frameId = i, (this || _global).pv = "", (this || _global).v = "", (this || _global).kf = !1, (this || _global)._isFirstFrame = !0, (this || _global)._mdf = !1, e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)), (this || _global).data = e, (this || _global).elem = t, (this || _global).comp = (this || _global).elem.comp, (this || _global).keysIndex = 0, (this || _global).canResize = !1, (this || _global).minimumFontSize = 1, (this || _global).effectsSequence = [], (this || _global).currentData = {
      ascent: 0,
      boxWidth: (this || _global).defaultBoxWidth,
      f: "",
      fStyle: "",
      fWeight: "",
      fc: "",
      j: "",
      justifyOffset: "",
      l: [],
      lh: 0,
      lineWidths: [],
      ls: "",
      of: "",
      s: "",
      sc: "",
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: !1,
      strokeColorAnim: !1,
      strokeWidthAnim: !1,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: !1
    }, this.copyData((this || _global).currentData, (this || _global).data.d.k[0].s), this.searchProperty() || this.completeTextData((this || _global).currentData);
  }
  r([Re, je, Je, ti, Ue, ze, Ze], gi), gi.prototype.initSecondaryElement = function () {}, gi.prototype.identityMatrix = new Ft(), gi.prototype.buildExpressionInterface = function () {}, gi.prototype.createContent = function () {
    this.searchShapes((this || _global).shapesData, (this || _global).itemsData, (this || _global).prevViewData, (this || _global).layerElement, 0, [], !0), this.filterUniqueShapes();
  }, gi.prototype.filterUniqueShapes = function () {
    var t,
      e,
      i,
      s,
      a = (this || _global).shapes.length,
      r = (this || _global).stylesList.length,
      n = [],
      o = !1;
    for (i = 0; i < r; i += 1) {
      for (s = (this || _global).stylesList[i], o = !1, n.length = 0, t = 0; t < a; t += 1) -1 !== (e = (this || _global).shapes[t]).styles.indexOf(s) && (n.push(e), o = e._isAnimated || o);
      n.length > 1 && o && this.setShapesAsAnimated(n);
    }
  }, gi.prototype.setShapesAsAnimated = function (t) {
    var e,
      i = t.length;
    for (e = 0; e < i; e += 1) t[e].setAsAnimated();
  }, gi.prototype.createStyleElement = function (t, e) {
    var i,
      a = new ai(t, e),
      r = a.pElem;
    if ("st" === t.ty) i = new ni(this || _global, t, a);else if ("fl" === t.ty) i = new oi(this || _global, t, a);else if ("gf" === t.ty || "gs" === t.ty) {
      i = new ("gf" === t.ty ? pi : fi)(this || _global, t, a), (this || _global).globalData.defs.appendChild(i.gf), i.maskId && ((this || _global).globalData.defs.appendChild(i.ms), (this || _global).globalData.defs.appendChild(i.of), r.setAttribute("mask", "url(" + s() + "#" + i.maskId + ")"));
    } else "no" === t.ty && (i = new hi(this || _global, t, a));
    return "st" !== t.ty && "gs" !== t.ty || (r.setAttribute("stroke-linecap", ei[t.lc || 2]), r.setAttribute("stroke-linejoin", ii[t.lj || 2]), r.setAttribute("fill-opacity", "0"), 1 === t.lj && r.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && r.setAttribute("fill-rule", "evenodd"), t.ln && r.setAttribute("id", t.ln), t.cl && r.setAttribute("class", t.cl), t.bm && (r.style["mix-blend-mode"] = xe(t.bm)), (this || _global).stylesList.push(a), this.addToAnimatedContents(t, i), i;
  }, gi.prototype.createGroupElement = function (t) {
    var e = new di();
    return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = xe(t.bm)), e;
  }, gi.prototype.createTransformElement = function (t, e) {
    var i = Wt.getTransformProperty(this || _global, t, this || _global),
      s = new mi(i, i.o, e);
    return this.addToAnimatedContents(t, s), s;
  }, gi.prototype.createShapeElement = function (t, e, i) {
    var s = 4;
    "rc" === t.ty ? s = 5 : "el" === t.ty ? s = 6 : "sr" === t.ty && (s = 7);
    var a = new si(e, i, Tt.getShapeProp(this || _global, t, s, this || _global));
    return (this || _global).shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(t, a), a;
  }, gi.prototype.addToAnimatedContents = function (t, e) {
    for (var i = 0, s = (this || _global).animatedContents.length; i < s;) {
      if ((this || _global).animatedContents[i].element === e) return;
      i += 1;
    }
    (this || _global).animatedContents.push({
      fn: ui.createRenderFunction(t),
      element: e,
      data: t
    });
  }, gi.prototype.setElementStyles = function (t) {
    var e,
      i = t.styles,
      s = (this || _global).stylesList.length;
    for (e = 0; e < s; e += 1) (this || _global).stylesList[e].closed || i.push((this || _global).stylesList[e]);
  }, gi.prototype.reloadShapes = function () {
    var t;
    (this || _global)._isFirstFrame = !0;
    var e = (this || _global).itemsData.length;
    for (t = 0; t < e; t += 1) (this || _global).prevViewData[t] = (this || _global).itemsData[t];
    for (this.searchShapes((this || _global).shapesData, (this || _global).itemsData, (this || _global).prevViewData, (this || _global).layerElement, 0, [], !0), this.filterUniqueShapes(), e = (this || _global).dynamicProperties.length, t = 0; t < e; t += 1) (this || _global).dynamicProperties[t].getValue();
    this.renderModifiers();
  }, gi.prototype.searchShapes = function (t, e, i, s, a, r, n) {
    var o,
      h,
      l,
      p,
      f,
      d,
      m = [].concat(r),
      c = t.length - 1,
      u = [],
      g = [];
    for (o = c; o >= 0; o -= 1) {
      if ((d = this.searchProcessedElement(t[o])) ? e[o] = i[d - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) d ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], a), t[o]._render && e[o].style.pElem.parentNode !== s && s.appendChild(e[o].style.pElem), u.push(e[o].style);else if ("gr" === t[o].ty) {
        if (d) for (l = e[o].it.length, h = 0; h < l; h += 1) e[o].prevViewData[h] = e[o].it[h];else e[o] = this.createGroupElement(t[o]);
        this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, a + 1, m, n), t[o]._render && e[o].gr.parentNode !== s && s.appendChild(e[o].gr);
      } else "tr" === t[o].ty ? (d || (e[o] = this.createTransformElement(t[o], s)), p = e[o].transform, m.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (d || (e[o] = this.createShapeElement(t[o], m, a)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (d ? (f = e[o]).closed = !1 : ((f = Nt.getModifier(t[o].ty)).init(this || _global, t[o]), e[o] = f, (this || _global).shapeModifiers.push(f)), g.push(f)) : "rp" === t[o].ty && (d ? (f = e[o]).closed = !0 : (f = Nt.getModifier(t[o].ty), e[o] = f, f.init(this || _global, t, o, e), (this || _global).shapeModifiers.push(f), n = !1), g.push(f));
      this.addProcessedElement(t[o], o + 1);
    }
    for (c = u.length, o = 0; o < c; o += 1) u[o].closed = !0;
    for (c = g.length, o = 0; o < c; o += 1) g[o].closed = !0;
  }, gi.prototype.renderInnerContent = function () {
    var t;
    this.renderModifiers();
    var e = (this || _global).stylesList.length;
    for (t = 0; t < e; t += 1) (this || _global).stylesList[t].reset();
    for (this.renderShape(), t = 0; t < e; t += 1) ((this || _global).stylesList[t]._mdf || (this || _global)._isFirstFrame) && ((this || _global).stylesList[t].msElem && ((this || _global).stylesList[t].msElem.setAttribute("d", (this || _global).stylesList[t].d), (this || _global).stylesList[t].d = "M0 0" + (this || _global).stylesList[t].d), (this || _global).stylesList[t].pElem.setAttribute("d", (this || _global).stylesList[t].d || "M0 0"));
  }, gi.prototype.renderShape = function () {
    var t,
      e,
      i = (this || _global).animatedContents.length;
    for (t = 0; t < i; t += 1) e = (this || _global).animatedContents[t], ((this || _global)._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, (this || _global)._isFirstFrame);
  }, gi.prototype.destroy = function () {
    this.destroyBaseElement(), (this || _global).shapesData = null, (this || _global).itemsData = null;
  }, yi.prototype.update = function (t, e, i, s, a, r) {
    (this || _global)._mdf.o = !1, (this || _global)._mdf.sw = !1, (this || _global)._mdf.sc = !1, (this || _global)._mdf.fc = !1, (this || _global)._mdf.m = !1, (this || _global)._mdf.p = !1;
    var n = !1;
    return (this || _global).o !== t && ((this || _global).o = t, (this || _global)._mdf.o = !0, n = !0), (this || _global).sw !== e && ((this || _global).sw = e, (this || _global)._mdf.sw = !0, n = !0), (this || _global).sc !== i && ((this || _global).sc = i, (this || _global)._mdf.sc = !0, n = !0), (this || _global).fc !== s && ((this || _global).fc = s, (this || _global)._mdf.fc = !0, n = !0), (this || _global).m !== a && ((this || _global).m = a, (this || _global)._mdf.m = !0, n = !0), !r.length || (this || _global).p[0] === r[0] && (this || _global).p[1] === r[1] && (this || _global).p[4] === r[4] && (this || _global).p[5] === r[5] && (this || _global).p[12] === r[12] && (this || _global).p[13] === r[13] || ((this || _global).p = r, (this || _global)._mdf.p = !0, n = !0), n;
  }, vi.prototype.defaultBoxWidth = [0, 0], vi.prototype.copyData = function (t, e) {
    for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    return t;
  }, vi.prototype.setCurrentData = function (t) {
    t.__complete || this.completeTextData(t), (this || _global).currentData = t, (this || _global).currentData.boxWidth = (this || _global).currentData.boxWidth || (this || _global).defaultBoxWidth, (this || _global)._mdf = !0;
  }, vi.prototype.searchProperty = function () {
    return this.searchKeyframes();
  }, vi.prototype.searchKeyframes = function () {
    return (this || _global).kf = (this || _global).data.d.k.length > 1, (this || _global).kf && this.addEffect((this || _global).getKeyframeValue.bind(this || _global)), (this || _global).kf;
  }, vi.prototype.addEffect = function (t) {
    (this || _global).effectsSequence.push(t), (this || _global).elem.addDynamicProperty(this || _global);
  }, vi.prototype.getValue = function (t) {
    if ((this || _global).elem.globalData.frameId !== (this || _global).frameId && (this || _global).effectsSequence.length || t) {
      (this || _global).currentData.t = (this || _global).data.d.k[(this || _global).keysIndex].s.t;
      var e = (this || _global).currentData,
        i = (this || _global).keysIndex;
      if ((this || _global).lock) this.setCurrentData((this || _global).currentData);else {
        var s;
        (this || _global).lock = !0, (this || _global)._mdf = !1;
        var a = (this || _global).effectsSequence.length,
          r = t || (this || _global).data.d.k[(this || _global).keysIndex].s;
        for (s = 0; s < a; s += 1) r = i !== (this || _global).keysIndex ? (this || _global).effectsSequence[s](r, r.t) : (this || _global).effectsSequence[s]((this || _global).currentData, r.t);
        e !== r && this.setCurrentData(r), (this || _global).v = (this || _global).currentData, (this || _global).pv = (this || _global).v, (this || _global).lock = !1, (this || _global).frameId = (this || _global).elem.globalData.frameId;
      }
    }
  }, vi.prototype.getKeyframeValue = function () {
    for (var t = (this || _global).data.d.k, e = (this || _global).elem.comp.renderedFrame, i = 0, s = t.length; i <= s - 1 && !(i === s - 1 || t[i + 1].t > e);) i += 1;
    return (this || _global).keysIndex !== i && ((this || _global).keysIndex = i), (this || _global).data.d.k[(this || _global).keysIndex].s;
  }, vi.prototype.buildFinalText = function (t) {
    for (var e, i, s = [], a = 0, r = t.length, n = !1, o = !1, h = ""; a < r;) n = o, o = !1, e = t.charCodeAt(a), h = t.charAt(a), ke.isCombinedCharacter(e) ? n = !0 : e >= 55296 && e <= 56319 ? ke.isRegionalFlag(t, a) ? h = t.substr(a, 14) : (i = t.charCodeAt(a + 1)) >= 56320 && i <= 57343 && (ke.isModifier(e, i) ? (h = t.substr(a, 2), n = !0) : h = ke.isFlagEmoji(t.substr(a, 4)) ? t.substr(a, 4) : t.substr(a, 2)) : e > 56319 ? (i = t.charCodeAt(a + 1), ke.isVariationSelector(e) && (n = !0)) : ke.isZeroWidthJoiner(e) && (n = !0, o = !0), n ? (s[s.length - 1] += h, n = !1) : s.push(h), a += h.length;
    return s;
  }, vi.prototype.completeTextData = function (t) {
    t.__complete = !0;
    var e,
      i,
      s,
      a,
      r,
      n,
      o,
      h = (this || _global).elem.globalData.fontManager,
      l = (this || _global).data,
      p = [],
      f = 0,
      d = l.m.g,
      m = 0,
      c = 0,
      u = 0,
      g = [],
      y = 0,
      v = 0,
      b = h.getFontByName(t.f),
      _ = 0,
      k = _e(b);
    t.fWeight = k.weight, t.fStyle = k.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), i = t.finalText.length, t.finalLineHeight = t.lh;
    var P,
      A = t.tr / 1000 * t.finalSize;
    if (t.sz) for (var S, x, w = !0, D = t.sz[0], C = t.sz[1]; w;) {
      S = 0, y = 0, i = (x = this.buildFinalText(t.t)).length, A = t.tr / 1000 * t.finalSize;
      var M = -1;
      for (e = 0; e < i; e += 1) P = x[e].charCodeAt(0), s = !1, " " === x[e] ? M = e : 13 !== P && 3 !== P || (y = 0, s = !0, S += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(x[e], b.fStyle, b.fFamily), _ = s ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(x[e], t.f, t.finalSize), y + _ > D && " " !== x[e] ? (-1 === M ? i += 1 : e = M, S += t.finalLineHeight || 1.2 * t.finalSize, x.splice(e, M === e ? 1 : 0, "\r"), M = -1, y = 0) : (y += _, y += A);
      S += b.ascent * t.finalSize / 100, (this || _global).canResize && t.finalSize > (this || _global).minimumFontSize && C < S ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = x, i = t.finalText.length, w = !1);
    }
    y = -A, _ = 0;
    var T,
      F = 0;
    for (e = 0; e < i; e += 1) if (s = !1, 13 === (P = (T = t.finalText[e]).charCodeAt(0)) || 3 === P ? (F = 0, g.push(y), v = y > v ? y : v, y = -2 * A, a = "", s = !0, u += 1) : a = T, h.chars ? (o = h.getCharData(T, b.fStyle, h.getFontByName(t.f).fFamily), _ = s ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(a, t.f, t.finalSize), " " === T ? F += _ + A : (y += _ + A + F, F = 0), p.push({
      l: _,
      an: _,
      add: m,
      n: s,
      anIndexes: [],
      val: a,
      line: u,
      animatorJustifyOffset: 0
    }), 2 == d) {
      if (m += _, "" === a || " " === a || e === i - 1) {
        for ("" !== a && " " !== a || (m -= _); c <= e;) p[c].an = m, p[c].ind = f, p[c].extra = _, c += 1;
        f += 1, m = 0;
      }
    } else if (3 == d) {
      if (m += _, "" === a || e === i - 1) {
        for ("" === a && (m -= _); c <= e;) p[c].an = m, p[c].ind = f, p[c].extra = _, c += 1;
        m = 0, f += 1;
      }
    } else p[f].ind = f, p[f].extra = 0, f += 1;
    if (t.l = p, v = y > v ? y : v, g.push(y), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;else switch (t.boxWidth = v, t.j) {
      case 1:
        t.justifyOffset = -t.boxWidth;
        break;
      case 2:
        t.justifyOffset = -t.boxWidth / 2;
        break;
      default:
        t.justifyOffset = 0;
    }
    t.lineWidths = g;
    var E,
      I,
      L,
      V,
      R = l.a;
    n = R.length;
    var z = [];
    for (r = 0; r < n; r += 1) {
      for ((E = R[r]).a.sc && (t.strokeColorAnim = !0), E.a.sw && (t.strokeWidthAnim = !0), (E.a.fc || E.a.fh || E.a.fs || E.a.fb) && (t.fillColorAnim = !0), V = 0, L = E.s.b, e = 0; e < i; e += 1) (I = p[e]).anIndexes[r] = V, (1 == L && "" !== I.val || 2 == L && "" !== I.val && " " !== I.val || 3 == L && (I.n || " " == I.val || e == i - 1) || 4 == L && (I.n || e == i - 1)) && (1 === E.s.rn && z.push(V), V += 1);
      l.a[r].s.totalChars = V;
      var O,
        N = -1;
      if (1 === E.s.rn) for (e = 0; e < i; e += 1) N != (I = p[e]).anIndexes[r] && (N = I.anIndexes[r], O = z.splice(Math.floor(Math.random() * z.length), 1)[0]), I.anIndexes[r] = O;
    }
    t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
  }, vi.prototype.updateDocumentData = function (t, e) {
    e = void 0 === e ? (this || _global).keysIndex : e;
    var i = this.copyData({}, (this || _global).data.d.k[e].s);
    i = this.copyData(i, t), (this || _global).data.d.k[e].s = i, this.recalculate(e), this.setCurrentData(i), (this || _global).elem.addDynamicProperty(this || _global);
  }, vi.prototype.recalculate = function (t) {
    var e = (this || _global).data.d.k[t].s;
    e.__complete = !1, (this || _global).keysIndex = 0, (this || _global)._isFirstFrame = !0, this.getValue(e);
  }, vi.prototype.canResizeFont = function (t) {
    (this || _global).canResize = t, this.recalculate((this || _global).keysIndex), (this || _global).elem.addDynamicProperty(this || _global);
  }, vi.prototype.setMinimumFontSize = function (t) {
    (this || _global).minimumFontSize = Math.floor(t) || 1, this.recalculate((this || _global).keysIndex), (this || _global).elem.addDynamicProperty(this || _global);
  };
  var bi = function () {
    var t = Math.max,
      e = Math.min,
      i = Math.floor;
    function s(t, e) {
      (this || _global)._currentTextLength = -1, (this || _global).k = !1, (this || _global).data = e, (this || _global).elem = t, (this || _global).comp = t.comp, (this || _global).finalS = 0, (this || _global).finalE = 0, this.initDynamicPropertyContainer(t), (this || _global).s = vt.getProp(t, e.s || {
        k: 0
      }, 0, 0, this || _global), (this || _global).e = "e" in e ? vt.getProp(t, e.e, 0, 0, this || _global) : {
        v: 100
      }, (this || _global).o = vt.getProp(t, e.o || {
        k: 0
      }, 0, 0, this || _global), (this || _global).xe = vt.getProp(t, e.xe || {
        k: 0
      }, 0, 0, this || _global), (this || _global).ne = vt.getProp(t, e.ne || {
        k: 0
      }, 0, 0, this || _global), (this || _global).sm = vt.getProp(t, e.sm || {
        k: 100
      }, 0, 0, this || _global), (this || _global).a = vt.getProp(t, e.a, 0, 0.01, this || _global), (this || _global).dynamicProperties.length || this.getValue();
    }
    return s.prototype = {
      getMult: function (s) {
        (this || _global)._currentTextLength !== (this || _global).elem.textProperty.currentData.l.length && this.getValue();
        var a = 0,
          r = 0,
          n = 1,
          o = 1;
        (this || _global).ne.v > 0 ? a = (this || _global).ne.v / 100 : r = -(this || _global).ne.v / 100, (this || _global).xe.v > 0 ? n = 1 - (this || _global).xe.v / 100 : o = 1 + (this || _global).xe.v / 100;
        var h = tt.getBezierEasing(a, r, n, o).get,
          l = 0,
          p = (this || _global).finalS,
          f = (this || _global).finalE,
          d = (this || _global).data.sh;
        if (2 === d) l = h(l = f === p ? s >= f ? 1 : 0 : t(0, e(0.5 / (f - p) + (s - p) / (f - p), 1)));else if (3 === d) l = h(l = f === p ? s >= f ? 0 : 1 : 1 - t(0, e(0.5 / (f - p) + (s - p) / (f - p), 1)));else if (4 === d) f === p ? l = 0 : (l = t(0, e(0.5 / (f - p) + (s - p) / (f - p), 1))) < 0.5 ? l *= 2 : l = 1 - 2 * (l - 0.5), l = h(l);else if (5 === d) {
          if (f === p) l = 0;else {
            var m = f - p,
              c = -m / 2 + (s = e(t(0, s + 0.5 - p), f - p)),
              u = m / 2;
            l = Math.sqrt(1 - c * c / (u * u));
          }
          l = h(l);
        } else 6 === d ? (f === p ? l = 0 : (s = e(t(0, s + 0.5 - p), f - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * s / (f - p))) / 2), l = h(l)) : (s >= i(p) && (l = t(0, e(s - p < 0 ? e(f, 1) - (p - s) : f - s, 1))), l = h(l));
        if (100 !== (this || _global).sm.v) {
          var g = 0.01 * (this || _global).sm.v;
          0 === g && (g = 1e-8);
          var y = 0.5 - 0.5 * g;
          l < y ? l = 0 : (l = (l - y) / g) > 1 && (l = 1);
        }
        return l * (this || _global).a.v;
      },
      getValue: function (t) {
        this.iterateDynamicProperties(), (this || _global)._mdf = t || (this || _global)._mdf, (this || _global)._currentTextLength = (this || _global).elem.textProperty.currentData.l.length || 0, t && 2 === (this || _global).data.r && ((this || _global).e.v = (this || _global)._currentTextLength);
        var e = 2 === (this || _global).data.r ? 1 : 100 / (this || _global).data.totalChars,
          i = (this || _global).o.v / e,
          s = (this || _global).s.v / e + i,
          a = (this || _global).e.v / e + i;
        if (s > a) {
          var r = s;
          s = a, a = r;
        }
        (this || _global).finalS = s, (this || _global).finalE = a;
      }
    }, r([bt], s), {
      getTextSelectorProp: function (t, e, i) {
        return new s(t, e, i);
      }
    };
  }();
  function _i(t, e, i) {
    var s = {
        propType: !1
      },
      a = vt.getProp,
      r = e.a;
    (this || _global).a = {
      r: r.r ? a(t, r.r, 0, P, i) : s,
      rx: r.rx ? a(t, r.rx, 0, P, i) : s,
      ry: r.ry ? a(t, r.ry, 0, P, i) : s,
      sk: r.sk ? a(t, r.sk, 0, P, i) : s,
      sa: r.sa ? a(t, r.sa, 0, P, i) : s,
      s: r.s ? a(t, r.s, 1, 0.01, i) : s,
      a: r.a ? a(t, r.a, 1, 0, i) : s,
      o: r.o ? a(t, r.o, 0, 0.01, i) : s,
      p: r.p ? a(t, r.p, 1, 0, i) : s,
      sw: r.sw ? a(t, r.sw, 0, 0, i) : s,
      sc: r.sc ? a(t, r.sc, 1, 0, i) : s,
      fc: r.fc ? a(t, r.fc, 1, 0, i) : s,
      fh: r.fh ? a(t, r.fh, 0, 0, i) : s,
      fs: r.fs ? a(t, r.fs, 0, 0.01, i) : s,
      fb: r.fb ? a(t, r.fb, 0, 0.01, i) : s,
      t: r.t ? a(t, r.t, 0, 0, i) : s
    }, (this || _global).s = bi.getTextSelectorProp(t, e.s, i), (this || _global).s.t = e.s.t;
  }
  function ki(t, e, i) {
    (this || _global)._isFirstFrame = !0, (this || _global)._hasMaskedPath = !1, (this || _global)._frameId = -1, (this || _global)._textData = t, (this || _global)._renderType = e, (this || _global)._elem = i, (this || _global)._animatorsData = l((this || _global)._textData.a.length), (this || _global)._pathData = {}, (this || _global)._moreOptions = {
      alignment: {}
    }, (this || _global).renderedLetters = [], (this || _global).lettersChangedFlag = !1, this.initDynamicPropertyContainer(i);
  }
  function Pi() {}
  ki.prototype.searchProperties = function () {
    var t,
      e,
      i = (this || _global)._textData.a.length,
      s = vt.getProp;
    for (t = 0; t < i; t += 1) e = (this || _global)._textData.a[t], (this || _global)._animatorsData[t] = new _i((this || _global)._elem, e, this || _global);
    (this || _global)._textData.p && "m" in (this || _global)._textData.p ? ((this || _global)._pathData = {
      a: s((this || _global)._elem, (this || _global)._textData.p.a, 0, 0, this || _global),
      f: s((this || _global)._elem, (this || _global)._textData.p.f, 0, 0, this || _global),
      l: s((this || _global)._elem, (this || _global)._textData.p.l, 0, 0, this || _global),
      r: s((this || _global)._elem, (this || _global)._textData.p.r, 0, 0, this || _global),
      p: s((this || _global)._elem, (this || _global)._textData.p.p, 0, 0, this || _global),
      m: (this || _global)._elem.maskManager.getMaskProperty((this || _global)._textData.p.m)
    }, (this || _global)._hasMaskedPath = !0) : (this || _global)._hasMaskedPath = !1, (this || _global)._moreOptions.alignment = s((this || _global)._elem, (this || _global)._textData.m.a, 1, 0, this || _global);
  }, ki.prototype.getMeasures = function (t, e) {
    if ((this || _global).lettersChangedFlag = e, (this || _global)._mdf || (this || _global)._isFirstFrame || e || (this || _global)._hasMaskedPath && (this || _global)._pathData.m._mdf) {
      (this || _global)._isFirstFrame = !1;
      var i,
        s,
        a,
        r,
        n,
        o,
        h,
        l,
        p,
        f,
        d,
        m,
        c,
        u,
        g,
        y,
        v,
        b,
        _,
        k = (this || _global)._moreOptions.alignment.v,
        P = (this || _global)._animatorsData,
        A = (this || _global)._textData,
        S = (this || _global).mHelper,
        x = (this || _global)._renderType,
        w = (this || _global).renderedLetters.length,
        D = t.l;
      if ((this || _global)._hasMaskedPath) {
        if (_ = (this || _global)._pathData.m, !(this || _global)._pathData.n || (this || _global)._pathData._mdf) {
          var C,
            M = _.v;
          for ((this || _global)._pathData.r.v && (M = M.reverse()), n = {
            tLength: 0,
            segments: []
          }, r = M._length - 1, y = 0, a = 0; a < r; a += 1) C = rt.buildBezierData(M.v[a], M.v[a + 1], [M.o[a][0] - M.v[a][0], M.o[a][1] - M.v[a][1]], [M.i[a + 1][0] - M.v[a + 1][0], M.i[a + 1][1] - M.v[a + 1][1]]), n.tLength += C.segmentLength, n.segments.push(C), y += C.segmentLength;
          a = r, _.v.c && (C = rt.buildBezierData(M.v[a], M.v[0], [M.o[a][0] - M.v[a][0], M.o[a][1] - M.v[a][1]], [M.i[0][0] - M.v[0][0], M.i[0][1] - M.v[0][1]]), n.tLength += C.segmentLength, n.segments.push(C), y += C.segmentLength), (this || _global)._pathData.pi = n;
        }
        if (n = (this || _global)._pathData.pi, o = (this || _global)._pathData.f.v, d = 0, f = 1, l = 0, p = !0, u = n.segments, o < 0 && _.v.c) for (n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), f = (c = u[d = u.length - 1].points).length - 1; o < 0;) o += c[f].partialLength, (f -= 1) < 0 && (f = (c = u[d -= 1].points).length - 1);
        m = (c = u[d].points)[f - 1], g = (h = c[f]).partialLength;
      }
      r = D.length, i = 0, s = 0;
      var T,
        F,
        E,
        I,
        L,
        V = 1.2 * t.finalSize * 0.714,
        N = !0;
      E = P.length;
      var B,
        q,
        j,
        W,
        X,
        H,
        Y,
        G,
        K,
        J,
        U,
        Z,
        Q = -1,
        $ = o,
        tt = d,
        et = f,
        it = -1,
        st = "",
        at = (this || _global).defaultPropsArray;
      if (2 === t.j || 1 === t.j) {
        var nt = 0,
          ot = 0,
          ht = 2 === t.j ? -0.5 : -1,
          lt = 0,
          pt = !0;
        for (a = 0; a < r; a += 1) if (D[a].n) {
          for (nt && (nt += ot); lt < a;) D[lt].animatorJustifyOffset = nt, lt += 1;
          nt = 0, pt = !0;
        } else {
          for (F = 0; F < E; F += 1) (T = P[F].a).t.propType && (pt && 2 === t.j && (ot += T.t.v * ht), (L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars)).length ? nt += T.t.v * L[0] * ht : nt += T.t.v * L * ht);
          pt = !1;
        }
        for (nt && (nt += ot); lt < a;) D[lt].animatorJustifyOffset = nt, lt += 1;
      }
      for (a = 0; a < r; a += 1) {
        if (S.reset(), W = 1, D[a].n) i = 0, s += t.yOffset, s += N ? 1 : 0, o = $, N = !1, (this || _global)._hasMaskedPath && (f = et, m = (c = u[d = tt].points)[f - 1], g = (h = c[f]).partialLength, l = 0), st = "", U = "", K = "", Z = "", at = (this || _global).defaultPropsArray;else {
          if ((this || _global)._hasMaskedPath) {
            if (it !== D[a].line) {
              switch (t.j) {
                case 1:
                  o += y - t.lineWidths[D[a].line];
                  break;
                case 2:
                  o += (y - t.lineWidths[D[a].line]) / 2;
              }
              it = D[a].line;
            }
            Q !== D[a].ind && (D[Q] && (o += D[Q].extra), o += D[a].an / 2, Q = D[a].ind), o += k[0] * D[a].an * 0.005;
            var ft = 0;
            for (F = 0; F < E; F += 1) (T = P[F].a).p.propType && ((L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars)).length ? ft += T.p.v[0] * L[0] : ft += T.p.v[0] * L), T.a.propType && ((L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars)).length ? ft += T.a.v[0] * L[0] : ft += T.a.v[0] * L);
            for (p = !0, (this || _global)._pathData.a.v && (o = 0.5 * D[0].an + (y - (this || _global)._pathData.f.v - 0.5 * D[0].an - 0.5 * D[D.length - 1].an) * Q / (r - 1), o += (this || _global)._pathData.f.v); p;) l + g >= o + ft || !c ? (v = (o + ft - l) / h.partialLength, q = m.point[0] + (h.point[0] - m.point[0]) * v, j = m.point[1] + (h.point[1] - m.point[1]) * v, S.translate(-k[0] * D[a].an * 0.005, -k[1] * V * 0.01), p = !1) : c && (l += h.partialLength, (f += 1) >= c.length && (f = 0, u[d += 1] ? c = u[d].points : _.v.c ? (f = 0, c = u[d = 0].points) : (l -= h.partialLength, c = null)), c && (m = h, g = (h = c[f]).partialLength));
            B = D[a].an / 2 - D[a].add, S.translate(-B, 0, 0);
          } else B = D[a].an / 2 - D[a].add, S.translate(-B, 0, 0), S.translate(-k[0] * D[a].an * 0.005, -k[1] * V * 0.01, 0);
          for (F = 0; F < E; F += 1) (T = P[F].a).t.propType && (L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars), 0 === i && 0 === t.j || ((this || _global)._hasMaskedPath ? L.length ? o += T.t.v * L[0] : o += T.t.v * L : L.length ? i += T.t.v * L[0] : i += T.t.v * L));
          for (t.strokeWidthAnim && (H = t.sw || 0), t.strokeColorAnim && (X = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (Y = [t.fc[0], t.fc[1], t.fc[2]]), F = 0; F < E; F += 1) (T = P[F].a).a.propType && ((L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars)).length ? S.translate(-T.a.v[0] * L[0], -T.a.v[1] * L[1], T.a.v[2] * L[2]) : S.translate(-T.a.v[0] * L, -T.a.v[1] * L, T.a.v[2] * L));
          for (F = 0; F < E; F += 1) (T = P[F].a).s.propType && ((L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars)).length ? S.scale(1 + (T.s.v[0] - 1) * L[0], 1 + (T.s.v[1] - 1) * L[1], 1) : S.scale(1 + (T.s.v[0] - 1) * L, 1 + (T.s.v[1] - 1) * L, 1));
          for (F = 0; F < E; F += 1) {
            if (T = P[F].a, L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars), T.sk.propType && (L.length ? S.skewFromAxis(-T.sk.v * L[0], T.sa.v * L[1]) : S.skewFromAxis(-T.sk.v * L, T.sa.v * L)), T.r.propType && (L.length ? S.rotateZ(-T.r.v * L[2]) : S.rotateZ(-T.r.v * L)), T.ry.propType && (L.length ? S.rotateY(T.ry.v * L[1]) : S.rotateY(T.ry.v * L)), T.rx.propType && (L.length ? S.rotateX(T.rx.v * L[0]) : S.rotateX(T.rx.v * L)), T.o.propType && (L.length ? W += (T.o.v * L[0] - W) * L[0] : W += (T.o.v * L - W) * L), t.strokeWidthAnim && T.sw.propType && (L.length ? H += T.sw.v * L[0] : H += T.sw.v * L), t.strokeColorAnim && T.sc.propType) for (G = 0; G < 3; G += 1) L.length ? X[G] += (T.sc.v[G] - X[G]) * L[0] : X[G] += (T.sc.v[G] - X[G]) * L;
            if (t.fillColorAnim && t.fc) {
              if (T.fc.propType) for (G = 0; G < 3; G += 1) L.length ? Y[G] += (T.fc.v[G] - Y[G]) * L[0] : Y[G] += (T.fc.v[G] - Y[G]) * L;
              T.fh.propType && (Y = L.length ? O(Y, T.fh.v * L[0]) : O(Y, T.fh.v * L)), T.fs.propType && (Y = L.length ? R(Y, T.fs.v * L[0]) : R(Y, T.fs.v * L)), T.fb.propType && (Y = L.length ? z(Y, T.fb.v * L[0]) : z(Y, T.fb.v * L));
            }
          }
          for (F = 0; F < E; F += 1) (T = P[F].a).p.propType && (L = P[F].s.getMult(D[a].anIndexes[F], A.a[F].s.totalChars), (this || _global)._hasMaskedPath ? L.length ? S.translate(0, T.p.v[1] * L[0], -T.p.v[2] * L[1]) : S.translate(0, T.p.v[1] * L, -T.p.v[2] * L) : L.length ? S.translate(T.p.v[0] * L[0], T.p.v[1] * L[1], -T.p.v[2] * L[2]) : S.translate(T.p.v[0] * L, T.p.v[1] * L, -T.p.v[2] * L));
          if (t.strokeWidthAnim && (K = H < 0 ? 0 : H), t.strokeColorAnim && (J = "rgb(" + Math.round(255 * X[0]) + "," + Math.round(255 * X[1]) + "," + Math.round(255 * X[2]) + ")"), t.fillColorAnim && t.fc && (U = "rgb(" + Math.round(255 * Y[0]) + "," + Math.round(255 * Y[1]) + "," + Math.round(255 * Y[2]) + ")"), (this || _global)._hasMaskedPath) {
            if (S.translate(0, -t.ls), S.translate(0, k[1] * V * 0.01 + s, 0), (this || _global)._pathData.p.v) {
              b = (h.point[1] - m.point[1]) / (h.point[0] - m.point[0]);
              var dt = 180 * Math.atan(b) / Math.PI;
              h.point[0] < m.point[0] && (dt += 180), S.rotate(-dt * Math.PI / 180);
            }
            S.translate(q, j, 0), o -= k[0] * D[a].an * 0.005, D[a + 1] && Q !== D[a + 1].ind && (o += D[a].an / 2, o += 0.001 * t.tr * t.finalSize);
          } else {
            switch (S.translate(i, s, 0), t.ps && S.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
              case 1:
                S.translate(D[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[D[a].line]), 0, 0);
                break;
              case 2:
                S.translate(D[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[D[a].line]) / 2, 0, 0);
            }
            S.translate(0, -t.ls), S.translate(B, 0, 0), S.translate(k[0] * D[a].an * 0.005, k[1] * V * 0.01, 0), i += D[a].l + 0.001 * t.tr * t.finalSize;
          }
          "html" === x ? st = S.toCSS() : "svg" === x ? st = S.to2dCSS() : at = [S.props[0], S.props[1], S.props[2], S.props[3], S.props[4], S.props[5], S.props[6], S.props[7], S.props[8], S.props[9], S.props[10], S.props[11], S.props[12], S.props[13], S.props[14], S.props[15]], Z = W;
        }
        w <= a ? (I = new yi(Z, K, J, U, st, at), (this || _global).renderedLetters.push(I), w += 1, (this || _global).lettersChangedFlag = !0) : (I = (this || _global).renderedLetters[a], (this || _global).lettersChangedFlag = I.update(Z, K, J, U, st, at) || (this || _global).lettersChangedFlag);
      }
    }
  }, ki.prototype.getValue = function () {
    (this || _global)._elem.globalData.frameId !== (this || _global)._frameId && ((this || _global)._frameId = (this || _global)._elem.globalData.frameId, this.iterateDynamicProperties());
  }, ki.prototype.mHelper = new Ft(), ki.prototype.defaultPropsArray = [], r([bt], ki), Pi.prototype.initElement = function (t, e, i) {
    (this || _global).lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, i), (this || _global).textProperty = new vi(this || _global, t.t, (this || _global).dynamicProperties), (this || _global).textAnimator = new ki(t.t, (this || _global).renderType, this || _global), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), (this || _global).textAnimator.searchProperties((this || _global).dynamicProperties);
  }, Pi.prototype.prepareFrame = function (t) {
    (this || _global)._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, (this || _global).isInRange);
  }, Pi.prototype.createPathShape = function (t, e) {
    var i,
      s,
      a = e.length,
      r = "";
    for (i = 0; i < a; i += 1) "sh" === e[i].ty && (s = e[i].ks.k, r += ci(s, s.i.length, !0, t));
    return r;
  }, Pi.prototype.updateDocumentData = function (t, e) {
    (this || _global).textProperty.updateDocumentData(t, e);
  }, Pi.prototype.canResizeFont = function (t) {
    (this || _global).textProperty.canResizeFont(t);
  }, Pi.prototype.setMinimumFontSize = function (t) {
    (this || _global).textProperty.setMinimumFontSize(t);
  }, Pi.prototype.applyTextPropertiesToMatrix = function (t, e, i, s, a) {
    switch (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j) {
      case 1:
        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]), 0, 0);
        break;
      case 2:
        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]) / 2, 0, 0);
    }
    e.translate(s, a, 0);
  }, Pi.prototype.buildColor = function (t) {
    return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
  }, Pi.prototype.emptyProp = new yi(), Pi.prototype.destroy = function () {}, Pi.prototype.validateText = function () {
    ((this || _global).textProperty._mdf || (this || _global).textProperty._isFirstFrame) && (this.buildNewText(), (this || _global).textProperty._isFirstFrame = !1, (this || _global).textProperty._mdf = !1);
  };
  var Ai,
    Si = {
      shapes: []
    };
  function xi(t, e, i) {
    (this || _global).textSpans = [], (this || _global).renderType = "svg", this.initElement(t, e, i);
  }
  function wi(t, e, i) {
    this.initElement(t, e, i);
  }
  function Di(t, e, i) {
    this.initFrame(), this.initBaseData(t, e, i), this.initFrame(), this.initTransform(t, e, i), this.initHierarchy();
  }
  function Ci() {}
  function Mi() {}
  function Ti(t, e, i) {
    (this || _global).layers = t.layers, (this || _global).supports3d = !0, (this || _global).completeLayers = !1, (this || _global).pendingElements = [], (this || _global).elements = (this || _global).layers ? l((this || _global).layers.length) : [], this.initElement(t, e, i), (this || _global).tm = t.tm ? vt.getProp(this || _global, t.tm, 0, e.frameRate, this || _global) : {
      _placeholder: !0
    };
  }
  function Fi(t, e) {
    (this || _global).animationItem = t, (this || _global).layers = null, (this || _global).renderedFrame = -1, (this || _global).svgElement = W("svg");
    var i = "";
    if (e && e.title) {
      var s = W("title"),
        a = I();
      s.setAttribute("id", a), s.textContent = e.title, (this || _global).svgElement.appendChild(s), i += a;
    }
    if (e && e.description) {
      var r = W("desc"),
        n = I();
      r.setAttribute("id", n), r.textContent = e.description, (this || _global).svgElement.appendChild(r), i += " " + n;
    }
    i && (this || _global).svgElement.setAttribute("aria-labelledby", i);
    var o = W("defs");
    (this || _global).svgElement.appendChild(o);
    var h = W("g");
    (this || _global).svgElement.appendChild(h), (this || _global).layerElement = h, (this || _global).renderConfig = {
      preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
      imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
      contentVisibility: e && e.contentVisibility || "visible",
      progressiveLoad: e && e.progressiveLoad || !1,
      hideOnTransparent: !(e && !1 === e.hideOnTransparent),
      viewBoxOnly: e && e.viewBoxOnly || !1,
      viewBoxSize: e && e.viewBoxSize || !1,
      className: e && e.className || "",
      id: e && e.id || "",
      focusable: e && e.focusable,
      filterSize: {
        width: e && e.filterSize && e.filterSize.width || "100%",
        height: e && e.filterSize && e.filterSize.height || "100%",
        x: e && e.filterSize && e.filterSize.x || "0%",
        y: e && e.filterSize && e.filterSize.y || "0%"
      },
      width: e && e.width,
      height: e && e.height,
      runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
    }, (this || _global).globalData = {
      _mdf: !1,
      frameNum: -1,
      defs: o,
      renderConfig: (this || _global).renderConfig
    }, (this || _global).elements = [], (this || _global).pendingElements = [], (this || _global).destroyed = !1, (this || _global).rendererType = "svg";
  }
  return r([Re, je, Je, Ue, ze, Ze, Pi], xi), xi.prototype.createContent = function () {
    (this || _global).data.singleShape && !(this || _global).globalData.fontManager.chars && ((this || _global).textContainer = W("text"));
  }, xi.prototype.buildTextContents = function (t) {
    for (var e = 0, i = t.length, s = [], a = ""; e < i;) t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (s.push(a), a = "") : a += t[e], e += 1;
    return s.push(a), s;
  }, xi.prototype.buildShapeData = function (t, e) {
    if (t.shapes && t.shapes.length) {
      var i = t.shapes[0];
      if (i.it) {
        var s = i.it[i.it.length - 1];
        s.s && (s.s.k[0] = e, s.s.k[1] = e);
      }
    }
    return t;
  }, xi.prototype.buildNewText = function () {
    var t, e;
    this.addDynamicProperty(this || _global);
    var i = (this || _global).textProperty.currentData;
    (this || _global).renderedLetters = l(i ? i.l.length : 0), i.fc ? (this || _global).layerElement.setAttribute("fill", this.buildColor(i.fc)) : (this || _global).layerElement.setAttribute("fill", "rgba(0,0,0,0)"), i.sc && ((this || _global).layerElement.setAttribute("stroke", this.buildColor(i.sc)), (this || _global).layerElement.setAttribute("stroke-width", i.sw)), (this || _global).layerElement.setAttribute("font-size", i.finalSize);
    var s = (this || _global).globalData.fontManager.getFontByName(i.f);
    if (s.fClass) (this || _global).layerElement.setAttribute("class", s.fClass);else {
      (this || _global).layerElement.setAttribute("font-family", s.fFamily);
      var a = i.fWeight,
        r = i.fStyle;
      (this || _global).layerElement.setAttribute("font-style", r), (this || _global).layerElement.setAttribute("font-weight", a);
    }
    (this || _global).layerElement.setAttribute("aria-label", i.t);
    var n,
      o = i.l || [],
      h = !!(this || _global).globalData.fontManager.chars;
    e = o.length;
    var p = (this || _global).mHelper,
      f = (this || _global).data.singleShape,
      d = 0,
      m = 0,
      c = !0,
      u = 0.001 * i.tr * i.finalSize;
    if (!f || h || i.sz) {
      var g,
        y = (this || _global).textSpans.length;
      for (t = 0; t < e; t += 1) {
        if ((this || _global).textSpans[t] || ((this || _global).textSpans[t] = {
          span: null,
          childSpan: null,
          glyph: null
        }), !h || !f || 0 === t) {
          if (n = y > t ? (this || _global).textSpans[t].span : W(h ? "g" : "text"), y <= t) {
            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), (this || _global).textSpans[t].span = n, h) {
              var v = W("g");
              n.appendChild(v), (this || _global).textSpans[t].childSpan = v;
            }
            (this || _global).textSpans[t].span = n, (this || _global).layerElement.appendChild(n);
          }
          n.style.display = "inherit";
        }
        if (p.reset(), f && (o[t].n && (d = -u, m += i.yOffset, m += c ? 1 : 0, c = !1), this.applyTextPropertiesToMatrix(i, p, o[t].line, d, m), d += o[t].l || 0, d += u), h) {
          var b;
          if (1 === (g = (this || _global).globalData.fontManager.getCharData(i.finalText[t], s.fStyle, (this || _global).globalData.fontManager.getFontByName(i.f).fFamily)).t) b = new Ti(g.data, (this || _global).globalData, this || _global);else {
            var _ = Si;
            g.data && g.data.shapes && (_ = this.buildShapeData(g.data, i.finalSize)), b = new gi(_, (this || _global).globalData, this || _global);
          }
          if ((this || _global).textSpans[t].glyph) {
            var k = (this || _global).textSpans[t].glyph;
            (this || _global).textSpans[t].childSpan.removeChild(k.layerElement), k.destroy();
          }
          (this || _global).textSpans[t].glyph = b, b._debug = !0, b.prepareFrame(0), b.renderFrame(), (this || _global).textSpans[t].childSpan.appendChild(b.layerElement), 1 === g.t && (this || _global).textSpans[t].childSpan.setAttribute("transform", "scale(" + i.finalSize / 100 + "," + i.finalSize / 100 + ")");
        } else f && n.setAttribute("transform", "translate(" + p.props[12] + "," + p.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
      }
      f && n && n.setAttribute("d", "");
    } else {
      var P = (this || _global).textContainer,
        A = "start";
      switch (i.j) {
        case 1:
          A = "end";
          break;
        case 2:
          A = "middle";
          break;
        default:
          A = "start";
      }
      P.setAttribute("text-anchor", A), P.setAttribute("letter-spacing", u);
      var S = this.buildTextContents(i.finalText);
      for (e = S.length, m = i.ps ? i.ps[1] + i.ascent : 0, t = 0; t < e; t += 1) (n = (this || _global).textSpans[t].span || W("tspan")).textContent = S[t], n.setAttribute("x", 0), n.setAttribute("y", m), n.style.display = "inherit", P.appendChild(n), (this || _global).textSpans[t] || ((this || _global).textSpans[t] = {
        span: null,
        glyph: null
      }), (this || _global).textSpans[t].span = n, m += i.finalLineHeight;
      (this || _global).layerElement.appendChild(P);
    }
    for (; t < (this || _global).textSpans.length;) (this || _global).textSpans[t].span.style.display = "none", t += 1;
    (this || _global)._sizeChanged = !0;
  }, xi.prototype.sourceRectAtTime = function () {
    if (this.prepareFrame((this || _global).comp.renderedFrame - (this || _global).data.st), this.renderInnerContent(), (this || _global)._sizeChanged) {
      (this || _global)._sizeChanged = !1;
      var t = (this || _global).layerElement.getBBox();
      (this || _global).bbox = {
        top: t.y,
        left: t.x,
        width: t.width,
        height: t.height
      };
    }
    return (this || _global).bbox;
  }, xi.prototype.getValue = function () {
    var t,
      e,
      i = (this || _global).textSpans.length;
    for ((this || _global).renderedFrame = (this || _global).comp.renderedFrame, t = 0; t < i; t += 1) (e = (this || _global).textSpans[t].glyph) && (e.prepareFrame((this || _global).comp.renderedFrame - (this || _global).data.st), e._mdf && ((this || _global)._mdf = !0));
  }, xi.prototype.renderInnerContent = function () {
    if (this.validateText(), (!(this || _global).data.singleShape || (this || _global)._mdf) && ((this || _global).textAnimator.getMeasures((this || _global).textProperty.currentData, (this || _global).lettersChangedFlag), (this || _global).lettersChangedFlag || (this || _global).textAnimator.lettersChangedFlag)) {
      var t, e;
      (this || _global)._sizeChanged = !0;
      var i,
        s,
        a,
        r = (this || _global).textAnimator.renderedLetters,
        n = (this || _global).textProperty.currentData.l;
      for (e = n.length, t = 0; t < e; t += 1) n[t].n || (i = r[t], s = (this || _global).textSpans[t].span, (a = (this || _global).textSpans[t].glyph) && a.renderFrame(), i._mdf.m && s.setAttribute("transform", i.m), i._mdf.o && s.setAttribute("opacity", i.o), i._mdf.sw && s.setAttribute("stroke-width", i.sw), i._mdf.sc && s.setAttribute("stroke", i.sc), i._mdf.fc && s.setAttribute("fill", i.fc));
    }
  }, r([Qe], wi), wi.prototype.createContent = function () {
    var t = W("rect");
    t.setAttribute("width", (this || _global).data.sw), t.setAttribute("height", (this || _global).data.sh), t.setAttribute("fill", (this || _global).data.sc), (this || _global).layerElement.appendChild(t);
  }, Di.prototype.prepareFrame = function (t) {
    this.prepareProperties(t, !0);
  }, Di.prototype.renderFrame = function () {}, Di.prototype.getBaseElement = function () {
    return null;
  }, Di.prototype.destroy = function () {}, Di.prototype.sourceRectAtTime = function () {}, Di.prototype.hide = function () {}, r([Re, je, Ue, ze], Di), r([Be], Ci), Ci.prototype.createNull = function (t) {
    return new Di(t, (this || _global).globalData, this || _global);
  }, Ci.prototype.createShape = function (t) {
    return new gi(t, (this || _global).globalData, this || _global);
  }, Ci.prototype.createText = function (t) {
    return new xi(t, (this || _global).globalData, this || _global);
  }, Ci.prototype.createImage = function (t) {
    return new Qe(t, (this || _global).globalData, this || _global);
  }, Ci.prototype.createSolid = function (t) {
    return new wi(t, (this || _global).globalData, this || _global);
  }, Ci.prototype.configAnimation = function (t) {
    (this || _global).svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), (this || _global).svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), (this || _global).renderConfig.viewBoxSize ? (this || _global).svgElement.setAttribute("viewBox", (this || _global).renderConfig.viewBoxSize) : (this || _global).svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), (this || _global).renderConfig.viewBoxOnly || ((this || _global).svgElement.setAttribute("width", t.w), (this || _global).svgElement.setAttribute("height", t.h), (this || _global).svgElement.style.width = "100%", (this || _global).svgElement.style.height = "100%", (this || _global).svgElement.style.transform = "translate3d(0,0,0)", (this || _global).svgElement.style.contentVisibility = (this || _global).renderConfig.contentVisibility), (this || _global).renderConfig.width && (this || _global).svgElement.setAttribute("width", (this || _global).renderConfig.width), (this || _global).renderConfig.height && (this || _global).svgElement.setAttribute("height", (this || _global).renderConfig.height), (this || _global).renderConfig.className && (this || _global).svgElement.setAttribute("class", (this || _global).renderConfig.className), (this || _global).renderConfig.id && (this || _global).svgElement.setAttribute("id", (this || _global).renderConfig.id), void 0 !== (this || _global).renderConfig.focusable && (this || _global).svgElement.setAttribute("focusable", (this || _global).renderConfig.focusable), (this || _global).svgElement.setAttribute("preserveAspectRatio", (this || _global).renderConfig.preserveAspectRatio), (this || _global).animationItem.wrapper.appendChild((this || _global).svgElement);
    var e = (this || _global).globalData.defs;
    this.setupGlobalData(t, e), (this || _global).globalData.progressiveLoad = (this || _global).renderConfig.progressiveLoad, (this || _global).data = t;
    var i = W("clipPath"),
      a = W("rect");
    a.setAttribute("width", t.w), a.setAttribute("height", t.h), a.setAttribute("x", 0), a.setAttribute("y", 0);
    var r = I();
    i.setAttribute("id", r), i.appendChild(a), (this || _global).layerElement.setAttribute("clip-path", "url(" + s() + "#" + r + ")"), e.appendChild(i), (this || _global).layers = t.layers, (this || _global).elements = l(t.layers.length);
  }, Ci.prototype.destroy = function () {
    var t;
    (this || _global).animationItem.wrapper && ((this || _global).animationItem.wrapper.innerText = ""), (this || _global).layerElement = null, (this || _global).globalData.defs = null;
    var e = (this || _global).layers ? (this || _global).layers.length : 0;
    for (t = 0; t < e; t += 1) (this || _global).elements[t] && (this || _global).elements[t].destroy && (this || _global).elements[t].destroy();
    (this || _global).elements.length = 0, (this || _global).destroyed = !0, (this || _global).animationItem = null;
  }, Ci.prototype.updateContainerSize = function () {}, Ci.prototype.findIndexByInd = function (t) {
    var e = 0,
      i = (this || _global).layers.length;
    for (e = 0; e < i; e += 1) if ((this || _global).layers[e].ind === t) return e;
    return -1;
  }, Ci.prototype.buildItem = function (t) {
    var e = (this || _global).elements;
    if (!e[t] && 99 !== (this || _global).layers[t].ty) {
      e[t] = !0;
      var i = this.createItem((this || _global).layers[t]);
      if (e[t] = i, N() && (0 === (this || _global).layers[t].ty && (this || _global).globalData.projectInterface.registerComposition(i), i.initExpressions()), this.appendElementInPos(i, t), (this || _global).layers[t].tt) {
        var s = "tp" in (this || _global).layers[t] ? this.findIndexByInd((this || _global).layers[t].tp) : t - 1;
        if (-1 === s) return;
        if ((this || _global).elements[s] && !0 !== (this || _global).elements[s]) {
          var a = e[s].getMatte((this || _global).layers[t].tt);
          i.setMatte(a);
        } else this.buildItem(s), this.addPendingElement(i);
      }
    }
  }, Ci.prototype.checkPendingElements = function () {
    for (; (this || _global).pendingElements.length;) {
      var t = (this || _global).pendingElements.pop();
      if (t.checkParenting(), t.data.tt) for (var e = 0, i = (this || _global).elements.length; e < i;) {
        if ((this || _global).elements[e] === t) {
          var s = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1,
            a = (this || _global).elements[s].getMatte((this || _global).layers[e].tt);
          t.setMatte(a);
          break;
        }
        e += 1;
      }
    }
  }, Ci.prototype.renderFrame = function (t) {
    if ((this || _global).renderedFrame !== t && !(this || _global).destroyed) {
      var e;
      null === t ? t = (this || _global).renderedFrame : (this || _global).renderedFrame = t, (this || _global).globalData.frameNum = t, (this || _global).globalData.frameId += 1, (this || _global).globalData.projectInterface.currentFrame = t, (this || _global).globalData._mdf = !1;
      var i = (this || _global).layers.length;
      for ((this || _global).completeLayers || this.checkLayers(t), e = i - 1; e >= 0; e -= 1) ((this || _global).completeLayers || (this || _global).elements[e]) && (this || _global).elements[e].prepareFrame(t - (this || _global).layers[e].st);
      if ((this || _global).globalData._mdf) for (e = 0; e < i; e += 1) ((this || _global).completeLayers || (this || _global).elements[e]) && (this || _global).elements[e].renderFrame();
    }
  }, Ci.prototype.appendElementInPos = function (t, e) {
    var i = t.getBaseElement();
    if (i) {
      for (var s, a = 0; a < e;) (this || _global).elements[a] && !0 !== (this || _global).elements[a] && (this || _global).elements[a].getBaseElement() && (s = (this || _global).elements[a].getBaseElement()), a += 1;
      s ? (this || _global).layerElement.insertBefore(i, s) : (this || _global).layerElement.appendChild(i);
    }
  }, Ci.prototype.hide = function () {
    (this || _global).layerElement.style.display = "none";
  }, Ci.prototype.show = function () {
    (this || _global).layerElement.style.display = "block";
  }, r([Re, je, Ue, ze, Ze], Mi), Mi.prototype.initElement = function (t, e, i) {
    this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !(this || _global).data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
  }, Mi.prototype.prepareFrame = function (t) {
    if ((this || _global)._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, (this || _global).isInRange), (this || _global).isInRange || (this || _global).data.xt) {
      if ((this || _global).tm._placeholder) (this || _global).renderedFrame = t / (this || _global).data.sr;else {
        var e = (this || _global).tm.v;
        e === (this || _global).data.op && (e = (this || _global).data.op - 1), (this || _global).renderedFrame = e;
      }
      var i,
        s = (this || _global).elements.length;
      for ((this || _global).completeLayers || this.checkLayers((this || _global).renderedFrame), i = s - 1; i >= 0; i -= 1) ((this || _global).completeLayers || (this || _global).elements[i]) && ((this || _global).elements[i].prepareFrame((this || _global).renderedFrame - (this || _global).layers[i].st), (this || _global).elements[i]._mdf && ((this || _global)._mdf = !0));
    }
  }, Mi.prototype.renderInnerContent = function () {
    var t,
      e = (this || _global).layers.length;
    for (t = 0; t < e; t += 1) ((this || _global).completeLayers || (this || _global).elements[t]) && (this || _global).elements[t].renderFrame();
  }, Mi.prototype.setElements = function (t) {
    (this || _global).elements = t;
  }, Mi.prototype.getElements = function () {
    return (this || _global).elements;
  }, Mi.prototype.destroyElements = function () {
    var t,
      e = (this || _global).layers.length;
    for (t = 0; t < e; t += 1) (this || _global).elements[t] && (this || _global).elements[t].destroy();
  }, Mi.prototype.destroy = function () {
    this.destroyElements(), this.destroyBaseElement();
  }, r([Ci, Mi, Je], Ti), Ti.prototype.createComp = function (t) {
    return new Ti(t, (this || _global).globalData, this || _global);
  }, r([Ci], Fi), Fi.prototype.createComp = function (t) {
    return new Ti(t, (this || _global).globalData, this || _global);
  }, Ai = Fi, U["svg"] = Ai, Nt.registerModifier("tm", qt), Nt.registerModifier("pb", jt), Nt.registerModifier("rp", Xt), Nt.registerModifier("rd", Ht), Nt.registerModifier("zz", he), Nt.registerModifier("op", be), It;
});
export default exports;